import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, ContentChildren, Output, Inject } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_alerts, PROPERTY_TOKEN_annotations, PROPERTY_TOKEN_breaks, PROPERTY_TOKEN_constantLines, PROPERTY_TOKEN_strips, PROPERTY_TOKEN_items, PROPERTY_TOKEN_buttons, PROPERTY_TOKEN_center, PROPERTY_TOKEN_changes, PROPERTY_TOKEN_series, PROPERTY_TOKEN_cols, PROPERTY_TOKEN_columns, PROPERTY_TOKEN_validationRules, PROPERTY_TOKEN_commands, PROPERTY_TOKEN_connectionPoints, PROPERTY_TOKEN_customOperations, PROPERTY_TOKEN_customShapes, PROPERTY_TOKEN_toolbarItems, PROPERTY_TOKEN_fields, PROPERTY_TOKEN_fileSelectionItems, PROPERTY_TOKEN_groups, PROPERTY_TOKEN_groupItems, PROPERTY_TOKEN_tabs, PROPERTY_TOKEN_location, PROPERTY_TOKEN_layers, PROPERTY_TOKEN_legends, PROPERTY_TOKEN_markers, PROPERTY_TOKEN_mentions, PROPERTY_TOKEN_menuItems, PROPERTY_TOKEN_panes, PROPERTY_TOKEN_ranges, PROPERTY_TOKEN_resources, PROPERTY_TOKEN_routes, PROPERTY_TOKEN_locations, PROPERTY_TOKEN_rows, PROPERTY_TOKEN_sortByGroupSummaryInfo, PROPERTY_TOKEN_stripLines, PROPERTY_TOKEN_totalItems, PROPERTY_TOKEN_typingUsers, PROPERTY_TOKEN_valueAxis, PROPERTY_TOKEN_views } from 'devextreme-angular/core/tokens';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoAdapterComponent = /*#__PURE__*/(() => {
  class DxoAdapterComponent extends NestedOption {
    get applyValidationResults() {
      return this._getOption('applyValidationResults');
    }
    set applyValidationResults(value) {
      this._setOption('applyValidationResults', value);
    }
    get bypass() {
      return this._getOption('bypass');
    }
    set bypass(value) {
      this._setOption('bypass', value);
    }
    get focus() {
      return this._getOption('focus');
    }
    set focus(value) {
      this._setOption('focus', value);
    }
    get getValue() {
      return this._getOption('getValue');
    }
    set getValue(value) {
      this._setOption('getValue', value);
    }
    get reset() {
      return this._getOption('reset');
    }
    set reset(value) {
      this._setOption('reset', value);
    }
    get validationRequestsCallbacks() {
      return this._getOption('validationRequestsCallbacks');
    }
    set validationRequestsCallbacks(value) {
      this._setOption('validationRequestsCallbacks', value);
    }
    get _optionPath() {
      return 'adapter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAdapterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAdapterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAdapterComponent,
      selectors: [["dxo-adapter"]],
      inputs: {
        applyValidationResults: "applyValidationResults",
        bypass: "bypass",
        focus: "focus",
        getValue: "getValue",
        reset: "reset",
        validationRequestsCallbacks: "validationRequestsCallbacks"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAdapterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAdapterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAdapterModule = /*#__PURE__*/(() => {
  class DxoAdapterModule {
    /** @nocollapse */static ɵfac = function DxoAdapterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAdapterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAdapterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAdapterComponent]
    });
  }
  return DxoAdapterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAdaptiveLayoutComponent = /*#__PURE__*/(() => {
  class DxoAdaptiveLayoutComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get keepLabels() {
      return this._getOption('keepLabels');
    }
    set keepLabels(value) {
      this._setOption('keepLabels', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'adaptiveLayout';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAdaptiveLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAdaptiveLayoutComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAdaptiveLayoutComponent,
      selectors: [["dxo-adaptive-layout"]],
      inputs: {
        height: "height",
        keepLabels: "keepLabels",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAdaptiveLayoutComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAdaptiveLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAdaptiveLayoutModule = /*#__PURE__*/(() => {
  class DxoAdaptiveLayoutModule {
    /** @nocollapse */static ɵfac = function DxoAdaptiveLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAdaptiveLayoutModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAdaptiveLayoutModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAdaptiveLayoutComponent]
    });
  }
  return DxoAdaptiveLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAggregationIntervalComponent = /*#__PURE__*/(() => {
  class DxoAggregationIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'aggregationInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAggregationIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAggregationIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAggregationIntervalComponent,
      selectors: [["dxo-aggregation-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAggregationIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAggregationIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAggregationIntervalModule = /*#__PURE__*/(() => {
  class DxoAggregationIntervalModule {
    /** @nocollapse */static ɵfac = function DxoAggregationIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAggregationIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAggregationIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAggregationIntervalComponent]
    });
  }
  return DxoAggregationIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAggregationComponent = /*#__PURE__*/(() => {
  class DxoAggregationComponent extends NestedOption {
    get calculate() {
      return this._getOption('calculate');
    }
    set calculate(value) {
      this._setOption('calculate', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get method() {
      return this._getOption('method');
    }
    set method(value) {
      this._setOption('method', value);
    }
    get _optionPath() {
      return 'aggregation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAggregationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAggregationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAggregationComponent,
      selectors: [["dxo-aggregation"]],
      inputs: {
        calculate: "calculate",
        enabled: "enabled",
        method: "method"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAggregationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAggregationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAggregationModule = /*#__PURE__*/(() => {
  class DxoAggregationModule {
    /** @nocollapse */static ɵfac = function DxoAggregationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAggregationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAggregationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAggregationComponent]
    });
  }
  return DxoAggregationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiAlert = /*#__PURE__*/(() => {
  class DxiAlert extends CollectionNestedOption {
    get id() {
      return this._getOption('id');
    }
    set id(value) {
      this._setOption('id', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiAlert_BaseFactory;
      return function DxiAlert_Factory(__ngFactoryType__) {
        return (ɵDxiAlert_BaseFactory || (ɵDxiAlert_BaseFactory = i0.ɵɵgetInheritedFactory(DxiAlert)))(__ngFactoryType__ || DxiAlert);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiAlert,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiAlert_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiAlert;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiAlertComponent = /*#__PURE__*/(() => {
  class DxiAlertComponent extends DxiAlert {
    get _optionPath() {
      return 'alerts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiAlertComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAlertComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiAlertComponent,
      selectors: [["dxi-alert"]],
      inputs: {
        id: "id",
        message: "message"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_alerts,
        useExisting: DxiAlertComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiAlertComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiAlertModule = /*#__PURE__*/(() => {
  class DxiAlertModule {
    /** @nocollapse */static ɵfac = function DxiAlertModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAlertModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiAlertModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiAlertComponent]
    });
  }
  return DxiAlertModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAnimationConfig = /*#__PURE__*/(() => {
  class DxoAnimationConfig extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get maxPointCountSupported() {
      return this._getOption('maxPointCountSupported');
    }
    set maxPointCountSupported(value) {
      this._setOption('maxPointCountSupported', value);
    }
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoAnimationConfig_BaseFactory;
      return function DxoAnimationConfig_Factory(__ngFactoryType__) {
        return (ɵDxoAnimationConfig_BaseFactory || (ɵDxoAnimationConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxoAnimationConfig)))(__ngFactoryType__ || DxoAnimationConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAnimationConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAnimationConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoAnimationConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoAnimationComponent = /*#__PURE__*/(() => {
  class DxoAnimationComponent extends DxoAnimationConfig {
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAnimationComponent,
      selectors: [["dxo-animation"]],
      inputs: {
        hide: "hide",
        show: "show",
        duration: "duration",
        easing: "easing",
        enabled: "enabled",
        maxPointCountSupported: "maxPointCountSupported",
        complete: "complete",
        delay: "delay",
        direction: "direction",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAnimationModule = /*#__PURE__*/(() => {
  class DxoAnimationModule {
    /** @nocollapse */static ɵfac = function DxoAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAnimationComponent]
    });
  }
  return DxoAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartAnnotationConfig = /*#__PURE__*/(() => {
  class DxiChartAnnotationConfig extends CollectionNestedOption {
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get angle() {
      return this._getOption('angle');
    }
    set angle(value) {
      this._setOption('angle', value);
    }
    get radius() {
      return this._getOption('radius');
    }
    set radius(value) {
      this._setOption('radius', value);
    }
    get coordinates() {
      return this._getOption('coordinates');
    }
    set coordinates(value) {
      this._setOption('coordinates', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiChartAnnotationConfig_BaseFactory;
      return function DxiChartAnnotationConfig_Factory(__ngFactoryType__) {
        return (ɵDxiChartAnnotationConfig_BaseFactory || (ɵDxiChartAnnotationConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxiChartAnnotationConfig)))(__ngFactoryType__ || DxiChartAnnotationConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartAnnotationConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartAnnotationConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiChartAnnotationConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiAnnotationComponent = /*#__PURE__*/(() => {
  class DxiAnnotationComponent extends DxiChartAnnotationConfig {
    get _optionPath() {
      return 'annotations';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiAnnotationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAnnotationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiAnnotationComponent,
      selectors: [["dxi-annotation"]],
      inputs: {
        allowDragging: "allowDragging",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        axis: "axis",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        name: "name",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        value: "value",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y",
        location: "location",
        angle: "angle",
        radius: "radius",
        coordinates: "coordinates"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_annotations,
        useExisting: DxiAnnotationComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiAnnotationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiAnnotationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiAnnotationModule = /*#__PURE__*/(() => {
  class DxiAnnotationModule {
    /** @nocollapse */static ɵfac = function DxiAnnotationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiAnnotationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiAnnotationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiAnnotationComponent]
    });
  }
  return DxiAnnotationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoApiKeyComponent = /*#__PURE__*/(() => {
  class DxoApiKeyComponent extends NestedOption {
    get azure() {
      return this._getOption('azure');
    }
    set azure(value) {
      this._setOption('azure', value);
    }
    get bing() {
      return this._getOption('bing');
    }
    set bing(value) {
      this._setOption('bing', value);
    }
    get google() {
      return this._getOption('google');
    }
    set google(value) {
      this._setOption('google', value);
    }
    get googleStatic() {
      return this._getOption('googleStatic');
    }
    set googleStatic(value) {
      this._setOption('googleStatic', value);
    }
    get _optionPath() {
      return 'apiKey';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoApiKeyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoApiKeyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoApiKeyComponent,
      selectors: [["dxo-api-key"]],
      inputs: {
        azure: "azure",
        bing: "bing",
        google: "google",
        googleStatic: "googleStatic"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoApiKeyComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoApiKeyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoApiKeyModule = /*#__PURE__*/(() => {
  class DxoApiKeyModule {
    /** @nocollapse */static ɵfac = function DxoApiKeyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoApiKeyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoApiKeyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoApiKeyComponent]
    });
  }
  return DxoApiKeyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAppointmentDraggingComponent = /*#__PURE__*/(() => {
  class DxoAppointmentDraggingComponent extends NestedOption {
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    get onAdd() {
      return this._getOption('onAdd');
    }
    set onAdd(value) {
      this._setOption('onAdd', value);
    }
    get onDragEnd() {
      return this._getOption('onDragEnd');
    }
    set onDragEnd(value) {
      this._setOption('onDragEnd', value);
    }
    get onDragMove() {
      return this._getOption('onDragMove');
    }
    set onDragMove(value) {
      this._setOption('onDragMove', value);
    }
    get onDragStart() {
      return this._getOption('onDragStart');
    }
    set onDragStart(value) {
      this._setOption('onDragStart', value);
    }
    get onRemove() {
      return this._getOption('onRemove');
    }
    set onRemove(value) {
      this._setOption('onRemove', value);
    }
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    get _optionPath() {
      return 'appointmentDragging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAppointmentDraggingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAppointmentDraggingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAppointmentDraggingComponent,
      selectors: [["dxo-appointment-dragging"]],
      inputs: {
        autoScroll: "autoScroll",
        data: "data",
        group: "group",
        onAdd: "onAdd",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onRemove: "onRemove",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAppointmentDraggingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAppointmentDraggingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAppointmentDraggingModule = /*#__PURE__*/(() => {
  class DxoAppointmentDraggingModule {
    /** @nocollapse */static ɵfac = function DxoAppointmentDraggingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAppointmentDraggingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAppointmentDraggingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAppointmentDraggingComponent]
    });
  }
  return DxoAppointmentDraggingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonSeriesSettings = /*#__PURE__*/(() => {
  class DxoChartCommonSeriesSettings extends NestedOption {
    get aggregation() {
      return this._getOption('aggregation');
    }
    set aggregation(value) {
      this._setOption('aggregation', value);
    }
    get area() {
      return this._getOption('area');
    }
    set area(value) {
      this._setOption('area', value);
    }
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get bar() {
      return this._getOption('bar');
    }
    set bar(value) {
      this._setOption('bar', value);
    }
    get barOverlapGroup() {
      return this._getOption('barOverlapGroup');
    }
    set barOverlapGroup(value) {
      this._setOption('barOverlapGroup', value);
    }
    get barPadding() {
      return this._getOption('barPadding');
    }
    set barPadding(value) {
      this._setOption('barPadding', value);
    }
    get barWidth() {
      return this._getOption('barWidth');
    }
    set barWidth(value) {
      this._setOption('barWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get bubble() {
      return this._getOption('bubble');
    }
    set bubble(value) {
      this._setOption('bubble', value);
    }
    get candlestick() {
      return this._getOption('candlestick');
    }
    set candlestick(value) {
      this._setOption('candlestick', value);
    }
    get closeValueField() {
      return this._getOption('closeValueField');
    }
    set closeValueField(value) {
      this._setOption('closeValueField', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get fullstackedarea() {
      return this._getOption('fullstackedarea');
    }
    set fullstackedarea(value) {
      this._setOption('fullstackedarea', value);
    }
    get fullstackedbar() {
      return this._getOption('fullstackedbar');
    }
    set fullstackedbar(value) {
      this._setOption('fullstackedbar', value);
    }
    get fullstackedline() {
      return this._getOption('fullstackedline');
    }
    set fullstackedline(value) {
      this._setOption('fullstackedline', value);
    }
    get fullstackedspline() {
      return this._getOption('fullstackedspline');
    }
    set fullstackedspline(value) {
      this._setOption('fullstackedspline', value);
    }
    get fullstackedsplinearea() {
      return this._getOption('fullstackedsplinearea');
    }
    set fullstackedsplinearea(value) {
      this._setOption('fullstackedsplinearea', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get ignoreEmptyPoints() {
      return this._getOption('ignoreEmptyPoints');
    }
    set ignoreEmptyPoints(value) {
      this._setOption('ignoreEmptyPoints', value);
    }
    get innerColor() {
      return this._getOption('innerColor');
    }
    set innerColor(value) {
      this._setOption('innerColor', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get line() {
      return this._getOption('line');
    }
    set line(value) {
      this._setOption('line', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minBarSize() {
      return this._getOption('minBarSize');
    }
    set minBarSize(value) {
      this._setOption('minBarSize', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get openValueField() {
      return this._getOption('openValueField');
    }
    set openValueField(value) {
      this._setOption('openValueField', value);
    }
    get pane() {
      return this._getOption('pane');
    }
    set pane(value) {
      this._setOption('pane', value);
    }
    get point() {
      return this._getOption('point');
    }
    set point(value) {
      this._setOption('point', value);
    }
    get rangearea() {
      return this._getOption('rangearea');
    }
    set rangearea(value) {
      this._setOption('rangearea', value);
    }
    get rangebar() {
      return this._getOption('rangebar');
    }
    set rangebar(value) {
      this._setOption('rangebar', value);
    }
    get rangeValue1Field() {
      return this._getOption('rangeValue1Field');
    }
    set rangeValue1Field(value) {
      this._setOption('rangeValue1Field', value);
    }
    get rangeValue2Field() {
      return this._getOption('rangeValue2Field');
    }
    set rangeValue2Field(value) {
      this._setOption('rangeValue2Field', value);
    }
    get reduction() {
      return this._getOption('reduction');
    }
    set reduction(value) {
      this._setOption('reduction', value);
    }
    get scatter() {
      return this._getOption('scatter');
    }
    set scatter(value) {
      this._setOption('scatter', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get showInLegend() {
      return this._getOption('showInLegend');
    }
    set showInLegend(value) {
      this._setOption('showInLegend', value);
    }
    get sizeField() {
      return this._getOption('sizeField');
    }
    set sizeField(value) {
      this._setOption('sizeField', value);
    }
    get spline() {
      return this._getOption('spline');
    }
    set spline(value) {
      this._setOption('spline', value);
    }
    get splinearea() {
      return this._getOption('splinearea');
    }
    set splinearea(value) {
      this._setOption('splinearea', value);
    }
    get stack() {
      return this._getOption('stack');
    }
    set stack(value) {
      this._setOption('stack', value);
    }
    get stackedarea() {
      return this._getOption('stackedarea');
    }
    set stackedarea(value) {
      this._setOption('stackedarea', value);
    }
    get stackedbar() {
      return this._getOption('stackedbar');
    }
    set stackedbar(value) {
      this._setOption('stackedbar', value);
    }
    get stackedline() {
      return this._getOption('stackedline');
    }
    set stackedline(value) {
      this._setOption('stackedline', value);
    }
    get stackedspline() {
      return this._getOption('stackedspline');
    }
    set stackedspline(value) {
      this._setOption('stackedspline', value);
    }
    get stackedsplinearea() {
      return this._getOption('stackedsplinearea');
    }
    set stackedsplinearea(value) {
      this._setOption('stackedsplinearea', value);
    }
    get steparea() {
      return this._getOption('steparea');
    }
    set steparea(value) {
      this._setOption('steparea', value);
    }
    get stepline() {
      return this._getOption('stepline');
    }
    set stepline(value) {
      this._setOption('stepline', value);
    }
    get stock() {
      return this._getOption('stock');
    }
    set stock(value) {
      this._setOption('stock', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueErrorBar() {
      return this._getOption('valueErrorBar');
    }
    set valueErrorBar(value) {
      this._setOption('valueErrorBar', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get minSegmentSize() {
      return this._getOption('minSegmentSize');
    }
    set minSegmentSize(value) {
      this._setOption('minSegmentSize', value);
    }
    get smallValuesGrouping() {
      return this._getOption('smallValuesGrouping');
    }
    set smallValuesGrouping(value) {
      this._setOption('smallValuesGrouping', value);
    }
    get closed() {
      return this._getOption('closed');
    }
    set closed(value) {
      this._setOption('closed', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoChartCommonSeriesSettings_BaseFactory;
      return function DxoChartCommonSeriesSettings_Factory(__ngFactoryType__) {
        return (ɵDxoChartCommonSeriesSettings_BaseFactory || (ɵDxoChartCommonSeriesSettings_BaseFactory = i0.ɵɵgetInheritedFactory(DxoChartCommonSeriesSettings)))(__ngFactoryType__ || DxoChartCommonSeriesSettings);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonSeriesSettings,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonSeriesSettings_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoChartCommonSeriesSettings;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoAreaComponent = /*#__PURE__*/(() => {
  class DxoAreaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'area';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAreaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAreaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAreaComponent,
      selectors: [["dxo-area"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAreaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAreaModule = /*#__PURE__*/(() => {
  class DxoAreaModule {
    /** @nocollapse */static ɵfac = function DxoAreaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAreaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAreaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAreaComponent]
    });
  }
  return DxoAreaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoArgumentAxisComponent = /*#__PURE__*/(() => {
  class DxoArgumentAxisComponent extends NestedOption {
    set _breaksContentChildren(value) {
      this.setChildren('breaks', value);
    }
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get aggregatedPointsPosition() {
      return this._getOption('aggregatedPointsPosition');
    }
    set aggregatedPointsPosition(value) {
      this._setOption('aggregatedPointsPosition', value);
    }
    get aggregationGroupWidth() {
      return this._getOption('aggregationGroupWidth');
    }
    set aggregationGroupWidth(value) {
      this._setOption('aggregationGroupWidth', value);
    }
    get aggregationInterval() {
      return this._getOption('aggregationInterval');
    }
    set aggregationInterval(value) {
      this._setOption('aggregationInterval', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get breaks() {
      return this._getOption('breaks');
    }
    set breaks(value) {
      this._setOption('breaks', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get customPosition() {
      return this._getOption('customPosition');
    }
    set customPosition(value) {
      this._setOption('customPosition', value);
    }
    get customPositionAxis() {
      return this._getOption('customPositionAxis');
    }
    set customPositionAxis(value) {
      this._setOption('customPositionAxis', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get holidays() {
      return this._getOption('holidays');
    }
    set holidays(value) {
      this._setOption('holidays', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get minVisualRangeLength() {
      return this._getOption('minVisualRangeLength');
    }
    set minVisualRangeLength(value) {
      this._setOption('minVisualRangeLength', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get singleWorkdays() {
      return this._getOption('singleWorkdays');
    }
    set singleWorkdays(value) {
      this._setOption('singleWorkdays', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visualRange() {
      return this._getOption('visualRange');
    }
    set visualRange(value) {
      this._setOption('visualRange', value);
    }
    get visualRangeUpdateMode() {
      return this._getOption('visualRangeUpdateMode');
    }
    set visualRangeUpdateMode(value) {
      this._setOption('visualRangeUpdateMode', value);
    }
    get wholeRange() {
      return this._getOption('wholeRange');
    }
    set wholeRange(value) {
      this._setOption('wholeRange', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get workdaysOnly() {
      return this._getOption('workdaysOnly');
    }
    set workdaysOnly(value) {
      this._setOption('workdaysOnly', value);
    }
    get workWeek() {
      return this._getOption('workWeek');
    }
    set workWeek(value) {
      this._setOption('workWeek', value);
    }
    get firstPointOnStartAngle() {
      return this._getOption('firstPointOnStartAngle');
    }
    set firstPointOnStartAngle(value) {
      this._setOption('firstPointOnStartAngle', value);
    }
    get originValue() {
      return this._getOption('originValue');
    }
    set originValue(value) {
      this._setOption('originValue', value);
    }
    get period() {
      return this._getOption('period');
    }
    set period(value) {
      this._setOption('period', value);
    }
    get startAngle() {
      return this._getOption('startAngle');
    }
    set startAngle(value) {
      this._setOption('startAngle', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    categoriesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visualRangeChange;
    get _optionPath() {
      return 'argumentAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'categoriesChange'
      }, {
        emit: 'visualRangeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoArgumentAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoArgumentAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoArgumentAxisComponent,
      selectors: [["dxo-argument-axis"]],
      contentQueries: function DxoArgumentAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_breaks, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._breaksContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        aggregatedPointsPosition: "aggregatedPointsPosition",
        aggregationGroupWidth: "aggregationGroupWidth",
        aggregationInterval: "aggregationInterval",
        allowDecimals: "allowDecimals",
        argumentType: "argumentType",
        axisDivisionFactor: "axisDivisionFactor",
        breaks: "breaks",
        breakStyle: "breakStyle",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        customPosition: "customPosition",
        customPositionAxis: "customPositionAxis",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        holidays: "holidays",
        hoverMode: "hoverMode",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        minValueMargin: "minValueMargin",
        minVisualRangeLength: "minVisualRangeLength",
        offset: "offset",
        opacity: "opacity",
        placeholderSize: "placeholderSize",
        position: "position",
        singleWorkdays: "singleWorkdays",
        strips: "strips",
        stripStyle: "stripStyle",
        tick: "tick",
        tickInterval: "tickInterval",
        title: "title",
        type: "type",
        valueMarginsEnabled: "valueMarginsEnabled",
        visible: "visible",
        visualRange: "visualRange",
        visualRangeUpdateMode: "visualRangeUpdateMode",
        wholeRange: "wholeRange",
        width: "width",
        workdaysOnly: "workdaysOnly",
        workWeek: "workWeek",
        firstPointOnStartAngle: "firstPointOnStartAngle",
        originValue: "originValue",
        period: "period",
        startAngle: "startAngle"
      },
      outputs: {
        categoriesChange: "categoriesChange",
        visualRangeChange: "visualRangeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoArgumentAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoArgumentAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoArgumentAxisModule = /*#__PURE__*/(() => {
  class DxoArgumentAxisModule {
    /** @nocollapse */static ɵfac = function DxoArgumentAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoArgumentAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoArgumentAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoArgumentAxisComponent]
    });
  }
  return DxoArgumentAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFormat = /*#__PURE__*/(() => {
  class DxoFormat extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFormat_BaseFactory;
      return function DxoFormat_Factory(__ngFactoryType__) {
        return (ɵDxoFormat_BaseFactory || (ɵDxoFormat_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFormat)))(__ngFactoryType__ || DxoFormat);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFormat,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFormat_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFormat;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoArgumentFormatComponent = /*#__PURE__*/(() => {
  class DxoArgumentFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'argumentFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoArgumentFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoArgumentFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoArgumentFormatComponent,
      selectors: [["dxo-argument-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoArgumentFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoArgumentFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoArgumentFormatModule = /*#__PURE__*/(() => {
  class DxoArgumentFormatModule {
    /** @nocollapse */static ɵfac = function DxoArgumentFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoArgumentFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoArgumentFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoArgumentFormatComponent]
    });
  }
  return DxoArgumentFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAtComponent = /*#__PURE__*/(() => {
  class DxoAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAtComponent,
      selectors: [["dxo-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAtComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAtModule = /*#__PURE__*/(() => {
  class DxoAtModule {
    /** @nocollapse */static ɵfac = function DxoAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAtComponent]
    });
  }
  return DxoAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoUser = /*#__PURE__*/(() => {
  class DxoUser extends NestedOption {
    get avatarAlt() {
      return this._getOption('avatarAlt');
    }
    set avatarAlt(value) {
      this._setOption('avatarAlt', value);
    }
    get avatarUrl() {
      return this._getOption('avatarUrl');
    }
    set avatarUrl(value) {
      this._setOption('avatarUrl', value);
    }
    get id() {
      return this._getOption('id');
    }
    set id(value) {
      this._setOption('id', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoUser_BaseFactory;
      return function DxoUser_Factory(__ngFactoryType__) {
        return (ɵDxoUser_BaseFactory || (ɵDxoUser_BaseFactory = i0.ɵɵgetInheritedFactory(DxoUser)))(__ngFactoryType__ || DxoUser);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoUser,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoUser_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoUser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoAuthorComponent = /*#__PURE__*/(() => {
  class DxoAuthorComponent extends DxoUser {
    get _optionPath() {
      return 'author';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAuthorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAuthorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAuthorComponent,
      selectors: [["dxo-author"]],
      inputs: {
        avatarAlt: "avatarAlt",
        avatarUrl: "avatarUrl",
        id: "id",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAuthorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAuthorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAuthorModule = /*#__PURE__*/(() => {
  class DxoAuthorModule {
    /** @nocollapse */static ɵfac = function DxoAuthorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAuthorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAuthorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAuthorComponent]
    });
  }
  return DxoAuthorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAutoLayoutComponent = /*#__PURE__*/(() => {
  class DxoAutoLayoutComponent extends NestedOption {
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'autoLayout';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoAutoLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutoLayoutComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAutoLayoutComponent,
      selectors: [["dxo-auto-layout"]],
      inputs: {
        orientation: "orientation",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAutoLayoutComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoAutoLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoAutoLayoutModule = /*#__PURE__*/(() => {
  class DxoAutoLayoutModule {
    /** @nocollapse */static ɵfac = function DxoAutoLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoAutoLayoutModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoAutoLayoutModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAutoLayoutComponent]
    });
  }
  return DxoAutoLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartsColor = /*#__PURE__*/(() => {
  class DxoChartsColor extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoChartsColor_BaseFactory;
      return function DxoChartsColor_Factory(__ngFactoryType__) {
        return (ɵDxoChartsColor_BaseFactory || (ɵDxoChartsColor_BaseFactory = i0.ɵɵgetInheritedFactory(DxoChartsColor)))(__ngFactoryType__ || DxoChartsColor);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartsColor,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartsColor_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoChartsColor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoBackgroundColorComponent = /*#__PURE__*/(() => {
  class DxoBackgroundColorComponent extends DxoChartsColor {
    get _optionPath() {
      return 'backgroundColor';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBackgroundColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBackgroundColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBackgroundColorComponent,
      selectors: [["dxo-background-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBackgroundColorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBackgroundColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBackgroundColorModule = /*#__PURE__*/(() => {
  class DxoBackgroundColorModule {
    /** @nocollapse */static ɵfac = function DxoBackgroundColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBackgroundColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBackgroundColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBackgroundColorComponent]
    });
  }
  return DxoBackgroundColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoBackgroundComponent = /*#__PURE__*/(() => {
  class DxoBackgroundComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get borderColor() {
      return this._getOption('borderColor');
    }
    set borderColor(value) {
      this._setOption('borderColor', value);
    }
    get _optionPath() {
      return 'background';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBackgroundComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBackgroundComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBackgroundComponent,
      selectors: [["dxo-background"]],
      inputs: {
        color: "color",
        image: "image",
        visible: "visible",
        borderColor: "borderColor"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBackgroundComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBackgroundComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBackgroundModule = /*#__PURE__*/(() => {
  class DxoBackgroundModule {
    /** @nocollapse */static ɵfac = function DxoBackgroundModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBackgroundModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBackgroundModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBackgroundComponent]
    });
  }
  return DxoBackgroundModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoBarComponent = /*#__PURE__*/(() => {
  class DxoBarComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'bar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBarComponent,
      selectors: [["dxo-bar"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBarModule = /*#__PURE__*/(() => {
  class DxoBarModule {
    /** @nocollapse */static ɵfac = function DxoBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBarComponent]
    });
  }
  return DxoBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoBehaviorComponent = /*#__PURE__*/(() => {
  class DxoBehaviorComponent extends NestedOption {
    get allowSlidersSwap() {
      return this._getOption('allowSlidersSwap');
    }
    set allowSlidersSwap(value) {
      this._setOption('allowSlidersSwap', value);
    }
    get animationEnabled() {
      return this._getOption('animationEnabled');
    }
    set animationEnabled(value) {
      this._setOption('animationEnabled', value);
    }
    get manualRangeSelectionEnabled() {
      return this._getOption('manualRangeSelectionEnabled');
    }
    set manualRangeSelectionEnabled(value) {
      this._setOption('manualRangeSelectionEnabled', value);
    }
    get moveSelectedRangeByClick() {
      return this._getOption('moveSelectedRangeByClick');
    }
    set moveSelectedRangeByClick(value) {
      this._setOption('moveSelectedRangeByClick', value);
    }
    get snapToTicks() {
      return this._getOption('snapToTicks');
    }
    set snapToTicks(value) {
      this._setOption('snapToTicks', value);
    }
    get valueChangeMode() {
      return this._getOption('valueChangeMode');
    }
    set valueChangeMode(value) {
      this._setOption('valueChangeMode', value);
    }
    get _optionPath() {
      return 'behavior';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBehaviorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBehaviorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBehaviorComponent,
      selectors: [["dxo-behavior"]],
      inputs: {
        allowSlidersSwap: "allowSlidersSwap",
        animationEnabled: "animationEnabled",
        manualRangeSelectionEnabled: "manualRangeSelectionEnabled",
        moveSelectedRangeByClick: "moveSelectedRangeByClick",
        snapToTicks: "snapToTicks",
        valueChangeMode: "valueChangeMode"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBehaviorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBehaviorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBehaviorModule = /*#__PURE__*/(() => {
  class DxoBehaviorModule {
    /** @nocollapse */static ɵfac = function DxoBehaviorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBehaviorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBehaviorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBehaviorComponent]
    });
  }
  return DxoBehaviorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoBorderComponent = /*#__PURE__*/(() => {
  class DxoBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBorderComponent,
      selectors: [["dxo-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width",
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBorderModule = /*#__PURE__*/(() => {
  class DxoBorderModule {
    /** @nocollapse */static ɵfac = function DxoBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBorderComponent]
    });
  }
  return DxoBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBoundaryOffsetComponent,
      selectors: [["dxo-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBoundaryOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBoundaryOffsetComponent]
    });
  }
  return DxoBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoBoxOptions = /*#__PURE__*/(() => {
  class DxoBoxOptions extends NestedOption {
    get align() {
      return this._getOption('align');
    }
    set align(value) {
      this._setOption('align', value);
    }
    get crossAlign() {
      return this._getOption('crossAlign');
    }
    set crossAlign(value) {
      this._setOption('crossAlign', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get itemHoldTimeout() {
      return this._getOption('itemHoldTimeout');
    }
    set itemHoldTimeout(value) {
      this._setOption('itemHoldTimeout', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get itemTemplate() {
      return this._getOption('itemTemplate');
    }
    set itemTemplate(value) {
      this._setOption('itemTemplate', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onItemClick() {
      return this._getOption('onItemClick');
    }
    set onItemClick(value) {
      this._setOption('onItemClick', value);
    }
    get onItemContextMenu() {
      return this._getOption('onItemContextMenu');
    }
    set onItemContextMenu(value) {
      this._setOption('onItemContextMenu', value);
    }
    get onItemHold() {
      return this._getOption('onItemHold');
    }
    set onItemHold(value) {
      this._setOption('onItemHold', value);
    }
    get onItemRendered() {
      return this._getOption('onItemRendered');
    }
    set onItemRendered(value) {
      this._setOption('onItemRendered', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoBoxOptions_BaseFactory;
      return function DxoBoxOptions_Factory(__ngFactoryType__) {
        return (ɵDxoBoxOptions_BaseFactory || (ɵDxoBoxOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoBoxOptions)))(__ngFactoryType__ || DxoBoxOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBoxOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBoxOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoBoxOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoBoxComponent = /*#__PURE__*/(() => {
  class DxoBoxComponent extends DxoBoxOptions {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemsChange;
    get _optionPath() {
      return 'box';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'itemsChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBoxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBoxComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBoxComponent,
      selectors: [["dxo-box"]],
      contentQueries: function DxoBoxComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        align: "align",
        crossAlign: "crossAlign",
        dataSource: "dataSource",
        direction: "direction",
        disabled: "disabled",
        elementAttr: "elementAttr",
        height: "height",
        hoverStateEnabled: "hoverStateEnabled",
        itemHoldTimeout: "itemHoldTimeout",
        items: "items",
        itemTemplate: "itemTemplate",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onItemContextMenu: "onItemContextMenu",
        onItemHold: "onItemHold",
        onItemRendered: "onItemRendered",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        visible: "visible",
        width: "width"
      },
      outputs: {
        itemsChange: "itemsChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBoxComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBoxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBoxModule = /*#__PURE__*/(() => {
  class DxoBoxModule {
    /** @nocollapse */static ɵfac = function DxoBoxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBoxModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBoxModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBoxComponent]
    });
  }
  return DxoBoxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiVizScaleBreak = /*#__PURE__*/(() => {
  class DxiVizScaleBreak extends CollectionNestedOption {
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiVizScaleBreak_BaseFactory;
      return function DxiVizScaleBreak_Factory(__ngFactoryType__) {
        return (ɵDxiVizScaleBreak_BaseFactory || (ɵDxiVizScaleBreak_BaseFactory = i0.ɵɵgetInheritedFactory(DxiVizScaleBreak)))(__ngFactoryType__ || DxiVizScaleBreak);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiVizScaleBreak,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiVizScaleBreak_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiVizScaleBreak;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiBreakComponent = /*#__PURE__*/(() => {
  class DxiBreakComponent extends DxiVizScaleBreak {
    get _optionPath() {
      return 'breaks';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiBreakComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiBreakComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiBreakComponent,
      selectors: [["dxi-break"]],
      inputs: {
        endValue: "endValue",
        startValue: "startValue"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_breaks,
        useExisting: DxiBreakComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiBreakComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiBreakComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiBreakModule = /*#__PURE__*/(() => {
  class DxiBreakModule {
    /** @nocollapse */static ɵfac = function DxiBreakModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiBreakModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiBreakModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiBreakComponent]
    });
  }
  return DxiBreakModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoBreakStyleComponent = /*#__PURE__*/(() => {
  class DxoBreakStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get line() {
      return this._getOption('line');
    }
    set line(value) {
      this._setOption('line', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'breakStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBreakStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBreakStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBreakStyleComponent,
      selectors: [["dxo-break-style"]],
      inputs: {
        color: "color",
        line: "line",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBreakStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBreakStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBreakStyleModule = /*#__PURE__*/(() => {
  class DxoBreakStyleModule {
    /** @nocollapse */static ɵfac = function DxoBreakStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBreakStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBreakStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBreakStyleComponent]
    });
  }
  return DxoBreakStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoBubbleComponent = /*#__PURE__*/(() => {
  class DxoBubbleComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'bubble';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoBubbleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBubbleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoBubbleComponent,
      selectors: [["dxo-bubble"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoBubbleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoBubbleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoBubbleModule = /*#__PURE__*/(() => {
  class DxoBubbleModule {
    /** @nocollapse */static ɵfac = function DxoBubbleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoBubbleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoBubbleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoBubbleComponent]
    });
  }
  return DxoBubbleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiTextEditorButton = /*#__PURE__*/(() => {
  class DxiTextEditorButton extends CollectionNestedOption {
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiTextEditorButton_BaseFactory;
      return function DxiTextEditorButton_Factory(__ngFactoryType__) {
        return (ɵDxiTextEditorButton_BaseFactory || (ɵDxiTextEditorButton_BaseFactory = i0.ɵɵgetInheritedFactory(DxiTextEditorButton)))(__ngFactoryType__ || DxiTextEditorButton);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTextEditorButton,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiTextEditorButton_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiTextEditorButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiButtonComponent = /*#__PURE__*/(() => {
  class DxiButtonComponent extends DxiTextEditorButton {
    get _optionPath() {
      return 'buttons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiButtonComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiButtonComponent,
      selectors: [["dxi-button"]],
      inputs: {
        location: "location",
        name: "name",
        options: "options",
        cssClass: "cssClass",
        disabled: "disabled",
        hint: "hint",
        icon: "icon",
        onClick: "onClick",
        template: "template",
        text: "text",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_buttons,
        useExisting: DxiButtonComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiButtonComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiButtonModule = /*#__PURE__*/(() => {
  class DxiButtonModule {
    /** @nocollapse */static ɵfac = function DxiButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiButtonModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiButtonModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiButtonComponent]
    });
  }
  return DxiButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoButtonOptions = /*#__PURE__*/(() => {
  class DxoButtonOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useSubmitBehavior() {
      return this._getOption('useSubmitBehavior');
    }
    set useSubmitBehavior(value) {
      this._setOption('useSubmitBehavior', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoButtonOptions_BaseFactory;
      return function DxoButtonOptions_Factory(__ngFactoryType__) {
        return (ɵDxoButtonOptions_BaseFactory || (ɵDxoButtonOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoButtonOptions)))(__ngFactoryType__ || DxoButtonOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoButtonOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoButtonOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoButtonOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoButtonOptionsComponent = /*#__PURE__*/(() => {
  class DxoButtonOptionsComponent extends DxoButtonOptions {
    get _optionPath() {
      return 'buttonOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoButtonOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoButtonOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoButtonOptionsComponent,
      selectors: [["dxo-button-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        icon: "icon",
        onClick: "onClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        template: "template",
        text: "text",
        type: "type",
        useSubmitBehavior: "useSubmitBehavior",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoButtonOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoButtonOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoButtonOptionsModule = /*#__PURE__*/(() => {
  class DxoButtonOptionsModule {
    /** @nocollapse */static ɵfac = function DxoButtonOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoButtonOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoButtonOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoButtonOptionsComponent]
    });
  }
  return DxoButtonOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCalendarOptions = /*#__PURE__*/(() => {
  class DxoCalendarOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get cellTemplate() {
      return this._getOption('cellTemplate');
    }
    set cellTemplate(value) {
      this._setOption('cellTemplate', value);
    }
    get dateSerializationFormat() {
      return this._getOption('dateSerializationFormat');
    }
    set dateSerializationFormat(value) {
      this._setOption('dateSerializationFormat', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get disabledDates() {
      return this._getOption('disabledDates');
    }
    set disabledDates(value) {
      this._setOption('disabledDates', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get firstDayOfWeek() {
      return this._getOption('firstDayOfWeek');
    }
    set firstDayOfWeek(value) {
      this._setOption('firstDayOfWeek', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get isDirty() {
      return this._getOption('isDirty');
    }
    set isDirty(value) {
      this._setOption('isDirty', value);
    }
    get isValid() {
      return this._getOption('isValid');
    }
    set isValid(value) {
      this._setOption('isValid', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get maxZoomLevel() {
      return this._getOption('maxZoomLevel');
    }
    set maxZoomLevel(value) {
      this._setOption('maxZoomLevel', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get minZoomLevel() {
      return this._getOption('minZoomLevel');
    }
    set minZoomLevel(value) {
      this._setOption('minZoomLevel', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onValueChanged() {
      return this._getOption('onValueChanged');
    }
    set onValueChanged(value) {
      this._setOption('onValueChanged', value);
    }
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectWeekOnClick() {
      return this._getOption('selectWeekOnClick');
    }
    set selectWeekOnClick(value) {
      this._setOption('selectWeekOnClick', value);
    }
    get showTodayButton() {
      return this._getOption('showTodayButton');
    }
    set showTodayButton(value) {
      this._setOption('showTodayButton', value);
    }
    get showWeekNumbers() {
      return this._getOption('showWeekNumbers');
    }
    set showWeekNumbers(value) {
      this._setOption('showWeekNumbers', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get validationError() {
      return this._getOption('validationError');
    }
    set validationError(value) {
      this._setOption('validationError', value);
    }
    get validationErrors() {
      return this._getOption('validationErrors');
    }
    set validationErrors(value) {
      this._setOption('validationErrors', value);
    }
    get validationMessageMode() {
      return this._getOption('validationMessageMode');
    }
    set validationMessageMode(value) {
      this._setOption('validationMessageMode', value);
    }
    get validationMessagePosition() {
      return this._getOption('validationMessagePosition');
    }
    set validationMessagePosition(value) {
      this._setOption('validationMessagePosition', value);
    }
    get validationStatus() {
      return this._getOption('validationStatus');
    }
    set validationStatus(value) {
      this._setOption('validationStatus', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get weekNumberRule() {
      return this._getOption('weekNumberRule');
    }
    set weekNumberRule(value) {
      this._setOption('weekNumberRule', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get zoomLevel() {
      return this._getOption('zoomLevel');
    }
    set zoomLevel(value) {
      this._setOption('zoomLevel', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoCalendarOptions_BaseFactory;
      return function DxoCalendarOptions_Factory(__ngFactoryType__) {
        return (ɵDxoCalendarOptions_BaseFactory || (ɵDxoCalendarOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoCalendarOptions)))(__ngFactoryType__ || DxoCalendarOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCalendarOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCalendarOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCalendarOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoCalendarOptionsComponent = /*#__PURE__*/(() => {
  class DxoCalendarOptionsComponent extends DxoCalendarOptions {
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    zoomLevelChange;
    get _optionPath() {
      return 'calendarOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }, {
        emit: 'zoomLevelChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCalendarOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCalendarOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCalendarOptionsComponent,
      selectors: [["dxo-calendar-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        cellTemplate: "cellTemplate",
        dateSerializationFormat: "dateSerializationFormat",
        disabled: "disabled",
        disabledDates: "disabledDates",
        elementAttr: "elementAttr",
        firstDayOfWeek: "firstDayOfWeek",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        isDirty: "isDirty",
        isValid: "isValid",
        max: "max",
        maxZoomLevel: "maxZoomLevel",
        min: "min",
        minZoomLevel: "minZoomLevel",
        name: "name",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onValueChanged: "onValueChanged",
        readOnly: "readOnly",
        rtlEnabled: "rtlEnabled",
        selectionMode: "selectionMode",
        selectWeekOnClick: "selectWeekOnClick",
        showTodayButton: "showTodayButton",
        showWeekNumbers: "showWeekNumbers",
        tabIndex: "tabIndex",
        validationError: "validationError",
        validationErrors: "validationErrors",
        validationMessageMode: "validationMessageMode",
        validationMessagePosition: "validationMessagePosition",
        validationStatus: "validationStatus",
        value: "value",
        visible: "visible",
        weekNumberRule: "weekNumberRule",
        width: "width",
        zoomLevel: "zoomLevel"
      },
      outputs: {
        valueChange: "valueChange",
        zoomLevelChange: "zoomLevelChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCalendarOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCalendarOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCalendarOptionsModule = /*#__PURE__*/(() => {
  class DxoCalendarOptionsModule {
    /** @nocollapse */static ɵfac = function DxoCalendarOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCalendarOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCalendarOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCalendarOptionsComponent]
    });
  }
  return DxoCalendarOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoCandlestickComponent = /*#__PURE__*/(() => {
  class DxoCandlestickComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'candlestick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCandlestickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCandlestickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCandlestickComponent,
      selectors: [["dxo-candlestick"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCandlestickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCandlestickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCandlestickModule = /*#__PURE__*/(() => {
  class DxoCandlestickModule {
    /** @nocollapse */static ɵfac = function DxoCandlestickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCandlestickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCandlestickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCandlestickComponent]
    });
  }
  return DxoCandlestickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiCenterComponent = /*#__PURE__*/(() => {
  class DxiCenterComponent extends CollectionNestedOption {
    get lat() {
      return this._getOption('lat');
    }
    set lat(value) {
      this._setOption('lat', value);
    }
    get lng() {
      return this._getOption('lng');
    }
    set lng(value) {
      this._setOption('lng', value);
    }
    get _optionPath() {
      return 'center';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiCenterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCenterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiCenterComponent,
      selectors: [["dxi-center"]],
      inputs: {
        lat: "lat",
        lng: "lng"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_center,
        useExisting: DxiCenterComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiCenterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiCenterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiCenterModule = /*#__PURE__*/(() => {
  class DxiCenterModule {
    /** @nocollapse */static ɵfac = function DxiCenterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCenterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiCenterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiCenterComponent]
    });
  }
  return DxiCenterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataChange = /*#__PURE__*/(() => {
  class DxiDataChange extends CollectionNestedOption {
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get insertAfterKey() {
      return this._getOption('insertAfterKey');
    }
    set insertAfterKey(value) {
      this._setOption('insertAfterKey', value);
    }
    get insertBeforeKey() {
      return this._getOption('insertBeforeKey');
    }
    set insertBeforeKey(value) {
      this._setOption('insertBeforeKey', value);
    }
    get key() {
      return this._getOption('key');
    }
    set key(value) {
      this._setOption('key', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiDataChange_BaseFactory;
      return function DxiDataChange_Factory(__ngFactoryType__) {
        return (ɵDxiDataChange_BaseFactory || (ɵDxiDataChange_BaseFactory = i0.ɵɵgetInheritedFactory(DxiDataChange)))(__ngFactoryType__ || DxiDataChange);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataChange,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataChange_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiDataChange;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiChangeComponent = /*#__PURE__*/(() => {
  class DxiChangeComponent extends DxiDataChange {
    get _optionPath() {
      return 'changes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiChangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChangeComponent,
      selectors: [["dxi-change"]],
      inputs: {
        data: "data",
        insertAfterKey: "insertAfterKey",
        insertBeforeKey: "insertBeforeKey",
        key: "key",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_changes,
        useExisting: DxiChangeComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiChangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiChangeModule = /*#__PURE__*/(() => {
  class DxiChangeModule {
    /** @nocollapse */static ɵfac = function DxiChangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiChangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiChangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiChangeComponent]
    });
  }
  return DxiChangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartComponent = /*#__PURE__*/(() => {
  class DxoChartComponent extends NestedOption {
    set _seriesContentChildren(value) {
      this.setChildren('series', value);
    }
    get barGroupPadding() {
      return this._getOption('barGroupPadding');
    }
    set barGroupPadding(value) {
      this._setOption('barGroupPadding', value);
    }
    get barGroupWidth() {
      return this._getOption('barGroupWidth');
    }
    set barGroupWidth(value) {
      this._setOption('barGroupWidth', value);
    }
    get bottomIndent() {
      return this._getOption('bottomIndent');
    }
    set bottomIndent(value) {
      this._setOption('bottomIndent', value);
    }
    get commonSeriesSettings() {
      return this._getOption('commonSeriesSettings');
    }
    set commonSeriesSettings(value) {
      this._setOption('commonSeriesSettings', value);
    }
    get dataPrepareSettings() {
      return this._getOption('dataPrepareSettings');
    }
    set dataPrepareSettings(value) {
      this._setOption('dataPrepareSettings', value);
    }
    get maxBubbleSize() {
      return this._getOption('maxBubbleSize');
    }
    set maxBubbleSize(value) {
      this._setOption('maxBubbleSize', value);
    }
    get minBubbleSize() {
      return this._getOption('minBubbleSize');
    }
    set minBubbleSize(value) {
      this._setOption('minBubbleSize', value);
    }
    get negativesAsZeroes() {
      return this._getOption('negativesAsZeroes');
    }
    set negativesAsZeroes(value) {
      this._setOption('negativesAsZeroes', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get paletteExtensionMode() {
      return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value) {
      this._setOption('paletteExtensionMode', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get seriesTemplate() {
      return this._getOption('seriesTemplate');
    }
    set seriesTemplate(value) {
      this._setOption('seriesTemplate', value);
    }
    get topIndent() {
      return this._getOption('topIndent');
    }
    set topIndent(value) {
      this._setOption('topIndent', value);
    }
    get valueAxis() {
      return this._getOption('valueAxis');
    }
    set valueAxis(value) {
      this._setOption('valueAxis', value);
    }
    get _optionPath() {
      return 'chart';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoChartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartComponent,
      selectors: [["dxo-chart"]],
      contentQueries: function DxoChartComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_series, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._seriesContentChildren = _t);
        }
      },
      inputs: {
        barGroupPadding: "barGroupPadding",
        barGroupWidth: "barGroupWidth",
        bottomIndent: "bottomIndent",
        commonSeriesSettings: "commonSeriesSettings",
        dataPrepareSettings: "dataPrepareSettings",
        maxBubbleSize: "maxBubbleSize",
        minBubbleSize: "minBubbleSize",
        negativesAsZeroes: "negativesAsZeroes",
        palette: "palette",
        paletteExtensionMode: "paletteExtensionMode",
        series: "series",
        seriesTemplate: "seriesTemplate",
        topIndent: "topIndent",
        valueAxis: "valueAxis"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoChartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoChartModule = /*#__PURE__*/(() => {
  class DxoChartModule {
    /** @nocollapse */static ɵfac = function DxoChartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoChartModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoChartModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoChartComponent]
    });
  }
  return DxoChartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColCountByScreenComponent = /*#__PURE__*/(() => {
  class DxoColCountByScreenComponent extends NestedOption {
    get lg() {
      return this._getOption('lg');
    }
    set lg(value) {
      this._setOption('lg', value);
    }
    get md() {
      return this._getOption('md');
    }
    set md(value) {
      this._setOption('md', value);
    }
    get sm() {
      return this._getOption('sm');
    }
    set sm(value) {
      this._setOption('sm', value);
    }
    get xs() {
      return this._getOption('xs');
    }
    set xs(value) {
      this._setOption('xs', value);
    }
    get _optionPath() {
      return 'colCountByScreen';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoColCountByScreenComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColCountByScreenComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColCountByScreenComponent,
      selectors: [["dxo-col-count-by-screen"]],
      inputs: {
        lg: "lg",
        md: "md",
        sm: "sm",
        xs: "xs"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColCountByScreenComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoColCountByScreenComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoColCountByScreenModule = /*#__PURE__*/(() => {
  class DxoColCountByScreenModule {
    /** @nocollapse */static ɵfac = function DxoColCountByScreenModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColCountByScreenModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoColCountByScreenModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoColCountByScreenComponent]
    });
  }
  return DxoColCountByScreenModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiColComponent = /*#__PURE__*/(() => {
  class DxiColComponent extends CollectionNestedOption {
    get baseSize() {
      return this._getOption('baseSize');
    }
    set baseSize(value) {
      this._setOption('baseSize', value);
    }
    get ratio() {
      return this._getOption('ratio');
    }
    set ratio(value) {
      this._setOption('ratio', value);
    }
    get screen() {
      return this._getOption('screen');
    }
    set screen(value) {
      this._setOption('screen', value);
    }
    get shrink() {
      return this._getOption('shrink');
    }
    set shrink(value) {
      this._setOption('shrink', value);
    }
    get _optionPath() {
      return 'cols';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiColComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiColComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiColComponent,
      selectors: [["dxi-col"]],
      inputs: {
        baseSize: "baseSize",
        ratio: "ratio",
        screen: "screen",
        shrink: "shrink"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_cols,
        useExisting: DxiColComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiColComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiColComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiColModule = /*#__PURE__*/(() => {
  class DxiColModule {
    /** @nocollapse */static ɵfac = function DxiColModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiColModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiColModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiColComponent]
    });
  }
  return DxiColModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCollisionComponent = /*#__PURE__*/(() => {
  class DxoCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCollisionComponent,
      selectors: [["dxo-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCollisionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCollisionModule = /*#__PURE__*/(() => {
  class DxoCollisionModule {
    /** @nocollapse */static ɵfac = function DxoCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCollisionComponent]
    });
  }
  return DxoCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoColorComponent = /*#__PURE__*/(() => {
  class DxoColorComponent extends DxoChartsColor {
    get _optionPath() {
      return 'color';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColorComponent,
      selectors: [["dxo-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoColorModule = /*#__PURE__*/(() => {
  class DxoColorModule {
    /** @nocollapse */static ɵfac = function DxoColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoColorComponent]
    });
  }
  return DxoColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColorizerComponent = /*#__PURE__*/(() => {
  class DxoColorizerComponent extends NestedOption {
    get colorCodeField() {
      return this._getOption('colorCodeField');
    }
    set colorCodeField(value) {
      this._setOption('colorCodeField', value);
    }
    get colorizeGroups() {
      return this._getOption('colorizeGroups');
    }
    set colorizeGroups(value) {
      this._setOption('colorizeGroups', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get paletteExtensionMode() {
      return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value) {
      this._setOption('paletteExtensionMode', value);
    }
    get range() {
      return this._getOption('range');
    }
    set range(value) {
      this._setOption('range', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'colorizer';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoColorizerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColorizerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColorizerComponent,
      selectors: [["dxo-colorizer"]],
      inputs: {
        colorCodeField: "colorCodeField",
        colorizeGroups: "colorizeGroups",
        palette: "palette",
        paletteExtensionMode: "paletteExtensionMode",
        range: "range",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColorizerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoColorizerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoColorizerModule = /*#__PURE__*/(() => {
  class DxoColorizerModule {
    /** @nocollapse */static ɵfac = function DxoColorizerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColorizerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoColorizerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoColorizerComponent]
    });
  }
  return DxoColorizerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColumnChooser = /*#__PURE__*/(() => {
  class DxoColumnChooser extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get emptyPanelText() {
      return this._getOption('emptyPanelText');
    }
    set emptyPanelText(value) {
      this._setOption('emptyPanelText', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get search() {
      return this._getOption('search');
    }
    set search(value) {
      this._setOption('search', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get selection() {
      return this._getOption('selection');
    }
    set selection(value) {
      this._setOption('selection', value);
    }
    get sortOrder() {
      return this._getOption('sortOrder');
    }
    set sortOrder(value) {
      this._setOption('sortOrder', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoColumnChooser_BaseFactory;
      return function DxoColumnChooser_Factory(__ngFactoryType__) {
        return (ɵDxoColumnChooser_BaseFactory || (ɵDxoColumnChooser_BaseFactory = i0.ɵɵgetInheritedFactory(DxoColumnChooser)))(__ngFactoryType__ || DxoColumnChooser);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColumnChooser,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColumnChooser_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoColumnChooser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoColumnChooserComponent = /*#__PURE__*/(() => {
  class DxoColumnChooserComponent extends DxoColumnChooser {
    get _optionPath() {
      return 'columnChooser';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoColumnChooserComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColumnChooserComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColumnChooserComponent,
      selectors: [["dxo-column-chooser"]],
      inputs: {
        allowSearch: "allowSearch",
        container: "container",
        emptyPanelText: "emptyPanelText",
        enabled: "enabled",
        height: "height",
        mode: "mode",
        position: "position",
        search: "search",
        searchTimeout: "searchTimeout",
        selection: "selection",
        sortOrder: "sortOrder",
        title: "title",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColumnChooserComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoColumnChooserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoColumnChooserModule = /*#__PURE__*/(() => {
  class DxoColumnChooserModule {
    /** @nocollapse */static ɵfac = function DxoColumnChooserModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColumnChooserModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoColumnChooserModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoColumnChooserComponent]
    });
  }
  return DxoColumnChooserModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridColumn = /*#__PURE__*/(() => {
  class DxiDataGridColumn extends CollectionNestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get allowEditing() {
      return this._getOption('allowEditing');
    }
    set allowEditing(value) {
      this._setOption('allowEditing', value);
    }
    get allowExporting() {
      return this._getOption('allowExporting');
    }
    set allowExporting(value) {
      this._setOption('allowExporting', value);
    }
    get allowFiltering() {
      return this._getOption('allowFiltering');
    }
    set allowFiltering(value) {
      this._setOption('allowFiltering', value);
    }
    get allowFixing() {
      return this._getOption('allowFixing');
    }
    set allowFixing(value) {
      this._setOption('allowFixing', value);
    }
    get allowGrouping() {
      return this._getOption('allowGrouping');
    }
    set allowGrouping(value) {
      this._setOption('allowGrouping', value);
    }
    get allowHeaderFiltering() {
      return this._getOption('allowHeaderFiltering');
    }
    set allowHeaderFiltering(value) {
      this._setOption('allowHeaderFiltering', value);
    }
    get allowHiding() {
      return this._getOption('allowHiding');
    }
    set allowHiding(value) {
      this._setOption('allowHiding', value);
    }
    get allowReordering() {
      return this._getOption('allowReordering');
    }
    set allowReordering(value) {
      this._setOption('allowReordering', value);
    }
    get allowResizing() {
      return this._getOption('allowResizing');
    }
    set allowResizing(value) {
      this._setOption('allowResizing', value);
    }
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get allowSorting() {
      return this._getOption('allowSorting');
    }
    set allowSorting(value) {
      this._setOption('allowSorting', value);
    }
    get autoExpandGroup() {
      return this._getOption('autoExpandGroup');
    }
    set autoExpandGroup(value) {
      this._setOption('autoExpandGroup', value);
    }
    get buttons() {
      return this._getOption('buttons');
    }
    set buttons(value) {
      this._setOption('buttons', value);
    }
    get calculateCellValue() {
      return this._getOption('calculateCellValue');
    }
    set calculateCellValue(value) {
      this._setOption('calculateCellValue', value);
    }
    get calculateDisplayValue() {
      return this._getOption('calculateDisplayValue');
    }
    set calculateDisplayValue(value) {
      this._setOption('calculateDisplayValue', value);
    }
    get calculateFilterExpression() {
      return this._getOption('calculateFilterExpression');
    }
    set calculateFilterExpression(value) {
      this._setOption('calculateFilterExpression', value);
    }
    get calculateGroupValue() {
      return this._getOption('calculateGroupValue');
    }
    set calculateGroupValue(value) {
      this._setOption('calculateGroupValue', value);
    }
    get calculateSortValue() {
      return this._getOption('calculateSortValue');
    }
    set calculateSortValue(value) {
      this._setOption('calculateSortValue', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get cellTemplate() {
      return this._getOption('cellTemplate');
    }
    set cellTemplate(value) {
      this._setOption('cellTemplate', value);
    }
    get columns() {
      return this._getOption('columns');
    }
    set columns(value) {
      this._setOption('columns', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get dataType() {
      return this._getOption('dataType');
    }
    set dataType(value) {
      this._setOption('dataType', value);
    }
    get editCellTemplate() {
      return this._getOption('editCellTemplate');
    }
    set editCellTemplate(value) {
      this._setOption('editCellTemplate', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get encodeHtml() {
      return this._getOption('encodeHtml');
    }
    set encodeHtml(value) {
      this._setOption('encodeHtml', value);
    }
    get falseText() {
      return this._getOption('falseText');
    }
    set falseText(value) {
      this._setOption('falseText', value);
    }
    get filterOperations() {
      return this._getOption('filterOperations');
    }
    set filterOperations(value) {
      this._setOption('filterOperations', value);
    }
    get filterType() {
      return this._getOption('filterType');
    }
    set filterType(value) {
      this._setOption('filterType', value);
    }
    get filterValue() {
      return this._getOption('filterValue');
    }
    set filterValue(value) {
      this._setOption('filterValue', value);
    }
    get filterValues() {
      return this._getOption('filterValues');
    }
    set filterValues(value) {
      this._setOption('filterValues', value);
    }
    get fixed() {
      return this._getOption('fixed');
    }
    set fixed(value) {
      this._setOption('fixed', value);
    }
    get fixedPosition() {
      return this._getOption('fixedPosition');
    }
    set fixedPosition(value) {
      this._setOption('fixedPosition', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get formItem() {
      return this._getOption('formItem');
    }
    set formItem(value) {
      this._setOption('formItem', value);
    }
    get groupCellTemplate() {
      return this._getOption('groupCellTemplate');
    }
    set groupCellTemplate(value) {
      this._setOption('groupCellTemplate', value);
    }
    get groupIndex() {
      return this._getOption('groupIndex');
    }
    set groupIndex(value) {
      this._setOption('groupIndex', value);
    }
    get headerCellTemplate() {
      return this._getOption('headerCellTemplate');
    }
    set headerCellTemplate(value) {
      this._setOption('headerCellTemplate', value);
    }
    get headerFilter() {
      return this._getOption('headerFilter');
    }
    set headerFilter(value) {
      this._setOption('headerFilter', value);
    }
    get hidingPriority() {
      return this._getOption('hidingPriority');
    }
    set hidingPriority(value) {
      this._setOption('hidingPriority', value);
    }
    get isBand() {
      return this._getOption('isBand');
    }
    set isBand(value) {
      this._setOption('isBand', value);
    }
    get lookup() {
      return this._getOption('lookup');
    }
    set lookup(value) {
      this._setOption('lookup', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get ownerBand() {
      return this._getOption('ownerBand');
    }
    set ownerBand(value) {
      this._setOption('ownerBand', value);
    }
    get renderAsync() {
      return this._getOption('renderAsync');
    }
    set renderAsync(value) {
      this._setOption('renderAsync', value);
    }
    get selectedFilterOperation() {
      return this._getOption('selectedFilterOperation');
    }
    set selectedFilterOperation(value) {
      this._setOption('selectedFilterOperation', value);
    }
    get setCellValue() {
      return this._getOption('setCellValue');
    }
    set setCellValue(value) {
      this._setOption('setCellValue', value);
    }
    get showEditorAlways() {
      return this._getOption('showEditorAlways');
    }
    set showEditorAlways(value) {
      this._setOption('showEditorAlways', value);
    }
    get showInColumnChooser() {
      return this._getOption('showInColumnChooser');
    }
    set showInColumnChooser(value) {
      this._setOption('showInColumnChooser', value);
    }
    get showWhenGrouped() {
      return this._getOption('showWhenGrouped');
    }
    set showWhenGrouped(value) {
      this._setOption('showWhenGrouped', value);
    }
    get sortIndex() {
      return this._getOption('sortIndex');
    }
    set sortIndex(value) {
      this._setOption('sortIndex', value);
    }
    get sortingMethod() {
      return this._getOption('sortingMethod');
    }
    set sortingMethod(value) {
      this._setOption('sortingMethod', value);
    }
    get sortOrder() {
      return this._getOption('sortOrder');
    }
    set sortOrder(value) {
      this._setOption('sortOrder', value);
    }
    get trueText() {
      return this._getOption('trueText');
    }
    set trueText(value) {
      this._setOption('trueText', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get validationRules() {
      return this._getOption('validationRules');
    }
    set validationRules(value) {
      this._setOption('validationRules', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visibleIndex() {
      return this._getOption('visibleIndex');
    }
    set visibleIndex(value) {
      this._setOption('visibleIndex', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiDataGridColumn_BaseFactory;
      return function DxiDataGridColumn_Factory(__ngFactoryType__) {
        return (ɵDxiDataGridColumn_BaseFactory || (ɵDxiDataGridColumn_BaseFactory = i0.ɵɵgetInheritedFactory(DxiDataGridColumn)))(__ngFactoryType__ || DxiDataGridColumn);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridColumn,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridColumn_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiDataGridColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiColumnComponent = /*#__PURE__*/(() => {
  class DxiColumnComponent extends DxiDataGridColumn {
    set _buttonsContentChildren(value) {
      this.setChildren('buttons', value);
    }
    set _columnsContentChildren(value) {
      this.setChildren('columns', value);
    }
    set _validationRulesContentChildren(value) {
      this.setChildren('validationRules', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterValueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterValuesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    groupIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedFilterOperationChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    sortIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    sortOrderChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleIndexChange;
    get _optionPath() {
      return 'columns';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'filterValueChange'
      }, {
        emit: 'filterValuesChange'
      }, {
        emit: 'groupIndexChange'
      }, {
        emit: 'selectedFilterOperationChange'
      }, {
        emit: 'sortIndexChange'
      }, {
        emit: 'sortOrderChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'visibleIndexChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiColumnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiColumnComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiColumnComponent,
      selectors: [["dxi-column"]],
      contentQueries: function DxiColumnComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_buttons, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_columns, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_validationRules, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._buttonsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._columnsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._validationRulesContentChildren = _t);
        }
      },
      inputs: {
        alignment: "alignment",
        allowEditing: "allowEditing",
        allowExporting: "allowExporting",
        allowFiltering: "allowFiltering",
        allowFixing: "allowFixing",
        allowGrouping: "allowGrouping",
        allowHeaderFiltering: "allowHeaderFiltering",
        allowHiding: "allowHiding",
        allowReordering: "allowReordering",
        allowResizing: "allowResizing",
        allowSearch: "allowSearch",
        allowSorting: "allowSorting",
        autoExpandGroup: "autoExpandGroup",
        buttons: "buttons",
        calculateCellValue: "calculateCellValue",
        calculateDisplayValue: "calculateDisplayValue",
        calculateFilterExpression: "calculateFilterExpression",
        calculateGroupValue: "calculateGroupValue",
        calculateSortValue: "calculateSortValue",
        caption: "caption",
        cellTemplate: "cellTemplate",
        columns: "columns",
        cssClass: "cssClass",
        customizeText: "customizeText",
        dataField: "dataField",
        dataType: "dataType",
        editCellTemplate: "editCellTemplate",
        editorOptions: "editorOptions",
        encodeHtml: "encodeHtml",
        falseText: "falseText",
        filterOperations: "filterOperations",
        filterType: "filterType",
        filterValue: "filterValue",
        filterValues: "filterValues",
        fixed: "fixed",
        fixedPosition: "fixedPosition",
        format: "format",
        formItem: "formItem",
        groupCellTemplate: "groupCellTemplate",
        groupIndex: "groupIndex",
        headerCellTemplate: "headerCellTemplate",
        headerFilter: "headerFilter",
        hidingPriority: "hidingPriority",
        isBand: "isBand",
        lookup: "lookup",
        minWidth: "minWidth",
        name: "name",
        ownerBand: "ownerBand",
        renderAsync: "renderAsync",
        selectedFilterOperation: "selectedFilterOperation",
        setCellValue: "setCellValue",
        showEditorAlways: "showEditorAlways",
        showInColumnChooser: "showInColumnChooser",
        showWhenGrouped: "showWhenGrouped",
        sortIndex: "sortIndex",
        sortingMethod: "sortingMethod",
        sortOrder: "sortOrder",
        trueText: "trueText",
        type: "type",
        validationRules: "validationRules",
        visible: "visible",
        visibleIndex: "visibleIndex",
        width: "width"
      },
      outputs: {
        filterValueChange: "filterValueChange",
        filterValuesChange: "filterValuesChange",
        groupIndexChange: "groupIndexChange",
        selectedFilterOperationChange: "selectedFilterOperationChange",
        sortIndexChange: "sortIndexChange",
        sortOrderChange: "sortOrderChange",
        visibleChange: "visibleChange",
        visibleIndexChange: "visibleIndexChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_columns,
        useExisting: DxiColumnComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiColumnComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiColumnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiColumnModule = /*#__PURE__*/(() => {
  class DxiColumnModule {
    /** @nocollapse */static ɵfac = function DxiColumnModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiColumnModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiColumnModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiColumnComponent]
    });
  }
  return DxiColumnModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColumnFixingComponent = /*#__PURE__*/(() => {
  class DxoColumnFixingComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get icons() {
      return this._getOption('icons');
    }
    set icons(value) {
      this._setOption('icons', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get _optionPath() {
      return 'columnFixing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoColumnFixingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColumnFixingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColumnFixingComponent,
      selectors: [["dxo-column-fixing"]],
      inputs: {
        enabled: "enabled",
        icons: "icons",
        texts: "texts"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColumnFixingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoColumnFixingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoColumnFixingModule = /*#__PURE__*/(() => {
  class DxoColumnFixingModule {
    /** @nocollapse */static ɵfac = function DxoColumnFixingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoColumnFixingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoColumnFixingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoColumnFixingComponent]
    });
  }
  return DxoColumnFixingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramCustomCommand = /*#__PURE__*/(() => {
  class DxiDiagramCustomCommand extends CollectionNestedOption {
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get prompt() {
      return this._getOption('prompt');
    }
    set prompt(value) {
      this._setOption('prompt', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiDiagramCustomCommand_BaseFactory;
      return function DxiDiagramCustomCommand_Factory(__ngFactoryType__) {
        return (ɵDxiDiagramCustomCommand_BaseFactory || (ɵDxiDiagramCustomCommand_BaseFactory = i0.ɵɵgetInheritedFactory(DxiDiagramCustomCommand)))(__ngFactoryType__ || DxiDiagramCustomCommand);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramCustomCommand,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramCustomCommand_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiDiagramCustomCommand;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiCommandComponent = /*#__PURE__*/(() => {
  class DxiCommandComponent extends DxiDiagramCustomCommand {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get _optionPath() {
      return 'commands';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiCommandComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCommandComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiCommandComponent,
      selectors: [["dxi-command"]],
      contentQueries: function DxiCommandComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        icon: "icon",
        items: "items",
        location: "location",
        name: "name",
        text: "text",
        options: "options",
        prompt: "prompt"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_commands,
        useExisting: DxiCommandComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiCommandComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiCommandComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiCommandModule = /*#__PURE__*/(() => {
  class DxiCommandModule {
    /** @nocollapse */static ɵfac = function DxiCommandModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCommandModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiCommandModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiCommandComponent]
    });
  }
  return DxiCommandModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoChartCommonAnnotationConfig = /*#__PURE__*/(() => {
  class DxoChartCommonAnnotationConfig extends NestedOption {
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get angle() {
      return this._getOption('angle');
    }
    set angle(value) {
      this._setOption('angle', value);
    }
    get radius() {
      return this._getOption('radius');
    }
    set radius(value) {
      this._setOption('radius', value);
    }
    get coordinates() {
      return this._getOption('coordinates');
    }
    set coordinates(value) {
      this._setOption('coordinates', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoChartCommonAnnotationConfig_BaseFactory;
      return function DxoChartCommonAnnotationConfig_Factory(__ngFactoryType__) {
        return (ɵDxoChartCommonAnnotationConfig_BaseFactory || (ɵDxoChartCommonAnnotationConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxoChartCommonAnnotationConfig)))(__ngFactoryType__ || DxoChartCommonAnnotationConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoChartCommonAnnotationConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoChartCommonAnnotationConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoChartCommonAnnotationConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoCommonAnnotationSettingsComponent = /*#__PURE__*/(() => {
  class DxoCommonAnnotationSettingsComponent extends DxoChartCommonAnnotationConfig {
    get _optionPath() {
      return 'commonAnnotationSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCommonAnnotationSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonAnnotationSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCommonAnnotationSettingsComponent,
      selectors: [["dxo-common-annotation-settings"]],
      inputs: {
        allowDragging: "allowDragging",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        axis: "axis",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        value: "value",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y",
        location: "location",
        angle: "angle",
        radius: "radius",
        coordinates: "coordinates"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCommonAnnotationSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCommonAnnotationSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCommonAnnotationSettingsModule = /*#__PURE__*/(() => {
  class DxoCommonAnnotationSettingsModule {
    /** @nocollapse */static ɵfac = function DxoCommonAnnotationSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonAnnotationSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCommonAnnotationSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCommonAnnotationSettingsComponent]
    });
  }
  return DxoCommonAnnotationSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCommonAxisSettingsComponent = /*#__PURE__*/(() => {
  class DxoCommonAxisSettingsComponent extends NestedOption {
    get aggregatedPointsPosition() {
      return this._getOption('aggregatedPointsPosition');
    }
    set aggregatedPointsPosition(value) {
      this._setOption('aggregatedPointsPosition', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'commonAxisSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCommonAxisSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonAxisSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCommonAxisSettingsComponent,
      selectors: [["dxo-common-axis-settings"]],
      inputs: {
        aggregatedPointsPosition: "aggregatedPointsPosition",
        allowDecimals: "allowDecimals",
        breakStyle: "breakStyle",
        color: "color",
        constantLineStyle: "constantLineStyle",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minValueMargin: "minValueMargin",
        opacity: "opacity",
        placeholderSize: "placeholderSize",
        stripStyle: "stripStyle",
        tick: "tick",
        title: "title",
        valueMarginsEnabled: "valueMarginsEnabled",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCommonAxisSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCommonAxisSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCommonAxisSettingsModule = /*#__PURE__*/(() => {
  class DxoCommonAxisSettingsModule {
    /** @nocollapse */static ɵfac = function DxoCommonAxisSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonAxisSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCommonAxisSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCommonAxisSettingsComponent]
    });
  }
  return DxoCommonAxisSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCommonPaneSettingsComponent = /*#__PURE__*/(() => {
  class DxoCommonPaneSettingsComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get _optionPath() {
      return 'commonPaneSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCommonPaneSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonPaneSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCommonPaneSettingsComponent,
      selectors: [["dxo-common-pane-settings"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCommonPaneSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCommonPaneSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCommonPaneSettingsModule = /*#__PURE__*/(() => {
  class DxoCommonPaneSettingsModule {
    /** @nocollapse */static ɵfac = function DxoCommonPaneSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonPaneSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCommonPaneSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCommonPaneSettingsComponent]
    });
  }
  return DxoCommonPaneSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoCommonSeriesSettingsComponent = /*#__PURE__*/(() => {
  class DxoCommonSeriesSettingsComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'commonSeriesSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCommonSeriesSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonSeriesSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCommonSeriesSettingsComponent,
      selectors: [["dxo-common-series-settings"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        argumentType: "argumentType",
        minSegmentSize: "minSegmentSize",
        smallValuesGrouping: "smallValuesGrouping",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCommonSeriesSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCommonSeriesSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCommonSeriesSettingsModule = /*#__PURE__*/(() => {
  class DxoCommonSeriesSettingsModule {
    /** @nocollapse */static ɵfac = function DxoCommonSeriesSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCommonSeriesSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCommonSeriesSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCommonSeriesSettingsComponent]
    });
  }
  return DxoCommonSeriesSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiConnectionPointComponent = /*#__PURE__*/(() => {
  class DxiConnectionPointComponent extends CollectionNestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'connectionPoints';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiConnectionPointComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiConnectionPointComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiConnectionPointComponent,
      selectors: [["dxi-connection-point"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_connectionPoints,
        useExisting: DxiConnectionPointComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiConnectionPointComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiConnectionPointComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiConnectionPointModule = /*#__PURE__*/(() => {
  class DxiConnectionPointModule {
    /** @nocollapse */static ɵfac = function DxiConnectionPointModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiConnectionPointModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiConnectionPointModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiConnectionPointComponent]
    });
  }
  return DxiConnectionPointModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoConnectorComponent = /*#__PURE__*/(() => {
  class DxoConnectorComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'connector';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoConnectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoConnectorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoConnectorComponent,
      selectors: [["dxo-connector"]],
      inputs: {
        color: "color",
        visible: "visible",
        width: "width",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoConnectorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoConnectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoConnectorModule = /*#__PURE__*/(() => {
  class DxoConnectorModule {
    /** @nocollapse */static ɵfac = function DxoConnectorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoConnectorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoConnectorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoConnectorComponent]
    });
  }
  return DxoConnectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiConstantLineComponent = /*#__PURE__*/(() => {
  class DxiConstantLineComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get displayBehindSeries() {
      return this._getOption('displayBehindSeries');
    }
    set displayBehindSeries(value) {
      this._setOption('displayBehindSeries', value);
    }
    get extendAxis() {
      return this._getOption('extendAxis');
    }
    set extendAxis(value) {
      this._setOption('extendAxis', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLines';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiConstantLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiConstantLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiConstantLineComponent,
      selectors: [["dxi-constant-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        displayBehindSeries: "displayBehindSeries",
        extendAxis: "extendAxis",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        value: "value",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_constantLines,
        useExisting: DxiConstantLineComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiConstantLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiConstantLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiConstantLineModule = /*#__PURE__*/(() => {
  class DxiConstantLineModule {
    /** @nocollapse */static ɵfac = function DxiConstantLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiConstantLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiConstantLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiConstantLineComponent]
    });
  }
  return DxiConstantLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoConstantLineStyleComponent = /*#__PURE__*/(() => {
  class DxoConstantLineStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLineStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoConstantLineStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoConstantLineStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoConstantLineStyleComponent,
      selectors: [["dxo-constant-line-style"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoConstantLineStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoConstantLineStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoConstantLineStyleModule = /*#__PURE__*/(() => {
  class DxoConstantLineStyleModule {
    /** @nocollapse */static ɵfac = function DxoConstantLineStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoConstantLineStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoConstantLineStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoConstantLineStyleComponent]
    });
  }
  return DxoConstantLineStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFileManagerContextMenu = /*#__PURE__*/(() => {
  class DxoFileManagerContextMenu extends NestedOption {
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFileManagerContextMenu_BaseFactory;
      return function DxoFileManagerContextMenu_Factory(__ngFactoryType__) {
        return (ɵDxoFileManagerContextMenu_BaseFactory || (ɵDxoFileManagerContextMenu_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFileManagerContextMenu)))(__ngFactoryType__ || DxoFileManagerContextMenu);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFileManagerContextMenu,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFileManagerContextMenu_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFileManagerContextMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoContextMenuComponent = /*#__PURE__*/(() => {
  class DxoContextMenuComponent extends DxoFileManagerContextMenu {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get _optionPath() {
      return 'contextMenu';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoContextMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoContextMenuComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoContextMenuComponent,
      selectors: [["dxo-context-menu"]],
      contentQueries: function DxoContextMenuComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        enabled: "enabled",
        items: "items"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoContextMenuComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoContextMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoContextMenuModule = /*#__PURE__*/(() => {
  class DxoContextMenuModule {
    /** @nocollapse */static ɵfac = function DxoContextMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoContextMenuModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoContextMenuModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoContextMenuComponent]
    });
  }
  return DxoContextMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoContextToolboxComponent = /*#__PURE__*/(() => {
  class DxoContextToolboxComponent extends NestedOption {
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get shapeIconsPerRow() {
      return this._getOption('shapeIconsPerRow');
    }
    set shapeIconsPerRow(value) {
      this._setOption('shapeIconsPerRow', value);
    }
    get shapes() {
      return this._getOption('shapes');
    }
    set shapes(value) {
      this._setOption('shapes', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'contextToolbox';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoContextToolboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoContextToolboxComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoContextToolboxComponent,
      selectors: [["dxo-context-toolbox"]],
      inputs: {
        category: "category",
        displayMode: "displayMode",
        enabled: "enabled",
        shapeIconsPerRow: "shapeIconsPerRow",
        shapes: "shapes",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoContextToolboxComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoContextToolboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoContextToolboxModule = /*#__PURE__*/(() => {
  class DxoContextToolboxModule {
    /** @nocollapse */static ɵfac = function DxoContextToolboxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoContextToolboxModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoContextToolboxModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoContextToolboxComponent]
    });
  }
  return DxoContextToolboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoControlBarComponent = /*#__PURE__*/(() => {
  class DxoControlBarComponent extends NestedOption {
    get borderColor() {
      return this._getOption('borderColor');
    }
    set borderColor(value) {
      this._setOption('borderColor', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get panVisible() {
      return this._getOption('panVisible');
    }
    set panVisible(value) {
      this._setOption('panVisible', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get zoomVisible() {
      return this._getOption('zoomVisible');
    }
    set zoomVisible(value) {
      this._setOption('zoomVisible', value);
    }
    get _optionPath() {
      return 'controlBar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoControlBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoControlBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoControlBarComponent,
      selectors: [["dxo-control-bar"]],
      inputs: {
        borderColor: "borderColor",
        color: "color",
        enabled: "enabled",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        opacity: "opacity",
        panVisible: "panVisible",
        verticalAlignment: "verticalAlignment",
        zoomVisible: "zoomVisible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoControlBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoControlBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoControlBarModule = /*#__PURE__*/(() => {
  class DxoControlBarModule {
    /** @nocollapse */static ɵfac = function DxoControlBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoControlBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoControlBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoControlBarComponent]
    });
  }
  return DxoControlBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoConverter = /*#__PURE__*/(() => {
  class DxoConverter extends NestedOption {
    get fromHtml() {
      return this._getOption('fromHtml');
    }
    set fromHtml(value) {
      this._setOption('fromHtml', value);
    }
    get toHtml() {
      return this._getOption('toHtml');
    }
    set toHtml(value) {
      this._setOption('toHtml', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoConverter_BaseFactory;
      return function DxoConverter_Factory(__ngFactoryType__) {
        return (ɵDxoConverter_BaseFactory || (ɵDxoConverter_BaseFactory = i0.ɵɵgetInheritedFactory(DxoConverter)))(__ngFactoryType__ || DxoConverter);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoConverter,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoConverter_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoConverter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoConverterComponent = /*#__PURE__*/(() => {
  class DxoConverterComponent extends DxoConverter {
    get _optionPath() {
      return 'converter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoConverterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoConverterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoConverterComponent,
      selectors: [["dxo-converter"]],
      inputs: {
        fromHtml: "fromHtml",
        toHtml: "toHtml"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoConverterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoConverterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoConverterModule = /*#__PURE__*/(() => {
  class DxoConverterModule {
    /** @nocollapse */static ɵfac = function DxoConverterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoConverterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoConverterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoConverterComponent]
    });
  }
  return DxoConverterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCrosshairComponent = /*#__PURE__*/(() => {
  class DxoCrosshairComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get horizontalLine() {
      return this._getOption('horizontalLine');
    }
    set horizontalLine(value) {
      this._setOption('horizontalLine', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get verticalLine() {
      return this._getOption('verticalLine');
    }
    set verticalLine(value) {
      this._setOption('verticalLine', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'crosshair';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCrosshairComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCrosshairComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCrosshairComponent,
      selectors: [["dxo-crosshair"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        enabled: "enabled",
        horizontalLine: "horizontalLine",
        label: "label",
        opacity: "opacity",
        verticalLine: "verticalLine",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCrosshairComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCrosshairComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCrosshairModule = /*#__PURE__*/(() => {
  class DxoCrosshairModule {
    /** @nocollapse */static ɵfac = function DxoCrosshairModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCrosshairModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCrosshairModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCrosshairComponent]
    });
  }
  return DxoCrosshairModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCursorOffsetComponent = /*#__PURE__*/(() => {
  class DxoCursorOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'cursorOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCursorOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCursorOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCursorOffsetComponent,
      selectors: [["dxo-cursor-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCursorOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoCursorOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCursorOffsetModule = /*#__PURE__*/(() => {
  class DxoCursorOffsetModule {
    /** @nocollapse */static ɵfac = function DxoCursorOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCursorOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCursorOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoCursorOffsetComponent]
    });
  }
  return DxoCursorOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiFilterBuilderCustomOperation = /*#__PURE__*/(() => {
  class DxiFilterBuilderCustomOperation extends CollectionNestedOption {
    get calculateFilterExpression() {
      return this._getOption('calculateFilterExpression');
    }
    set calculateFilterExpression(value) {
      this._setOption('calculateFilterExpression', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get dataTypes() {
      return this._getOption('dataTypes');
    }
    set dataTypes(value) {
      this._setOption('dataTypes', value);
    }
    get editorTemplate() {
      return this._getOption('editorTemplate');
    }
    set editorTemplate(value) {
      this._setOption('editorTemplate', value);
    }
    get hasValue() {
      return this._getOption('hasValue');
    }
    set hasValue(value) {
      this._setOption('hasValue', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiFilterBuilderCustomOperation_BaseFactory;
      return function DxiFilterBuilderCustomOperation_Factory(__ngFactoryType__) {
        return (ɵDxiFilterBuilderCustomOperation_BaseFactory || (ɵDxiFilterBuilderCustomOperation_BaseFactory = i0.ɵɵgetInheritedFactory(DxiFilterBuilderCustomOperation)))(__ngFactoryType__ || DxiFilterBuilderCustomOperation);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiFilterBuilderCustomOperation,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiFilterBuilderCustomOperation_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiFilterBuilderCustomOperation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiCustomOperationComponent = /*#__PURE__*/(() => {
  class DxiCustomOperationComponent extends DxiFilterBuilderCustomOperation {
    get _optionPath() {
      return 'customOperations';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiCustomOperationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCustomOperationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiCustomOperationComponent,
      selectors: [["dxi-custom-operation"]],
      inputs: {
        calculateFilterExpression: "calculateFilterExpression",
        caption: "caption",
        customizeText: "customizeText",
        dataTypes: "dataTypes",
        editorTemplate: "editorTemplate",
        hasValue: "hasValue",
        icon: "icon",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_customOperations,
        useExisting: DxiCustomOperationComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiCustomOperationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiCustomOperationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiCustomOperationModule = /*#__PURE__*/(() => {
  class DxiCustomOperationModule {
    /** @nocollapse */static ɵfac = function DxiCustomOperationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCustomOperationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiCustomOperationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiCustomOperationComponent]
    });
  }
  return DxiCustomOperationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiCustomShapeComponent = /*#__PURE__*/(() => {
  class DxiCustomShapeComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    set _connectionPointsContentChildren(value) {
      this.setChildren('connectionPoints', value);
    }
    get allowEditImage() {
      return this._getOption('allowEditImage');
    }
    set allowEditImage(value) {
      this._setOption('allowEditImage', value);
    }
    get allowEditText() {
      return this._getOption('allowEditText');
    }
    set allowEditText(value) {
      this._setOption('allowEditText', value);
    }
    get allowResize() {
      return this._getOption('allowResize');
    }
    set allowResize(value) {
      this._setOption('allowResize', value);
    }
    get backgroundImageHeight() {
      return this._getOption('backgroundImageHeight');
    }
    set backgroundImageHeight(value) {
      this._setOption('backgroundImageHeight', value);
    }
    get backgroundImageLeft() {
      return this._getOption('backgroundImageLeft');
    }
    set backgroundImageLeft(value) {
      this._setOption('backgroundImageLeft', value);
    }
    get backgroundImageToolboxUrl() {
      return this._getOption('backgroundImageToolboxUrl');
    }
    set backgroundImageToolboxUrl(value) {
      this._setOption('backgroundImageToolboxUrl', value);
    }
    get backgroundImageTop() {
      return this._getOption('backgroundImageTop');
    }
    set backgroundImageTop(value) {
      this._setOption('backgroundImageTop', value);
    }
    get backgroundImageUrl() {
      return this._getOption('backgroundImageUrl');
    }
    set backgroundImageUrl(value) {
      this._setOption('backgroundImageUrl', value);
    }
    get backgroundImageWidth() {
      return this._getOption('backgroundImageWidth');
    }
    set backgroundImageWidth(value) {
      this._setOption('backgroundImageWidth', value);
    }
    get baseType() {
      return this._getOption('baseType');
    }
    set baseType(value) {
      this._setOption('baseType', value);
    }
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get connectionPoints() {
      return this._getOption('connectionPoints');
    }
    set connectionPoints(value) {
      this._setOption('connectionPoints', value);
    }
    get defaultHeight() {
      return this._getOption('defaultHeight');
    }
    set defaultHeight(value) {
      this._setOption('defaultHeight', value);
    }
    get defaultImageUrl() {
      return this._getOption('defaultImageUrl');
    }
    set defaultImageUrl(value) {
      this._setOption('defaultImageUrl', value);
    }
    get defaultText() {
      return this._getOption('defaultText');
    }
    set defaultText(value) {
      this._setOption('defaultText', value);
    }
    get defaultWidth() {
      return this._getOption('defaultWidth');
    }
    set defaultWidth(value) {
      this._setOption('defaultWidth', value);
    }
    get imageHeight() {
      return this._getOption('imageHeight');
    }
    set imageHeight(value) {
      this._setOption('imageHeight', value);
    }
    get imageLeft() {
      return this._getOption('imageLeft');
    }
    set imageLeft(value) {
      this._setOption('imageLeft', value);
    }
    get imageTop() {
      return this._getOption('imageTop');
    }
    set imageTop(value) {
      this._setOption('imageTop', value);
    }
    get imageWidth() {
      return this._getOption('imageWidth');
    }
    set imageWidth(value) {
      this._setOption('imageWidth', value);
    }
    get keepRatioOnAutoSize() {
      return this._getOption('keepRatioOnAutoSize');
    }
    set keepRatioOnAutoSize(value) {
      this._setOption('keepRatioOnAutoSize', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get templateHeight() {
      return this._getOption('templateHeight');
    }
    set templateHeight(value) {
      this._setOption('templateHeight', value);
    }
    get templateLeft() {
      return this._getOption('templateLeft');
    }
    set templateLeft(value) {
      this._setOption('templateLeft', value);
    }
    get templateTop() {
      return this._getOption('templateTop');
    }
    set templateTop(value) {
      this._setOption('templateTop', value);
    }
    get templateWidth() {
      return this._getOption('templateWidth');
    }
    set templateWidth(value) {
      this._setOption('templateWidth', value);
    }
    get textHeight() {
      return this._getOption('textHeight');
    }
    set textHeight(value) {
      this._setOption('textHeight', value);
    }
    get textLeft() {
      return this._getOption('textLeft');
    }
    set textLeft(value) {
      this._setOption('textLeft', value);
    }
    get textTop() {
      return this._getOption('textTop');
    }
    set textTop(value) {
      this._setOption('textTop', value);
    }
    get textWidth() {
      return this._getOption('textWidth');
    }
    set textWidth(value) {
      this._setOption('textWidth', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get toolboxTemplate() {
      return this._getOption('toolboxTemplate');
    }
    set toolboxTemplate(value) {
      this._setOption('toolboxTemplate', value);
    }
    get toolboxWidthToHeightRatio() {
      return this._getOption('toolboxWidthToHeightRatio');
    }
    set toolboxWidthToHeightRatio(value) {
      this._setOption('toolboxWidthToHeightRatio', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'customShapes';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiCustomShapeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCustomShapeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiCustomShapeComponent,
      selectors: [["dxi-custom-shape"]],
      contentQueries: function DxiCustomShapeComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_connectionPoints, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._connectionPointsContentChildren = _t);
        }
      },
      inputs: {
        allowEditImage: "allowEditImage",
        allowEditText: "allowEditText",
        allowResize: "allowResize",
        backgroundImageHeight: "backgroundImageHeight",
        backgroundImageLeft: "backgroundImageLeft",
        backgroundImageToolboxUrl: "backgroundImageToolboxUrl",
        backgroundImageTop: "backgroundImageTop",
        backgroundImageUrl: "backgroundImageUrl",
        backgroundImageWidth: "backgroundImageWidth",
        baseType: "baseType",
        category: "category",
        connectionPoints: "connectionPoints",
        defaultHeight: "defaultHeight",
        defaultImageUrl: "defaultImageUrl",
        defaultText: "defaultText",
        defaultWidth: "defaultWidth",
        imageHeight: "imageHeight",
        imageLeft: "imageLeft",
        imageTop: "imageTop",
        imageWidth: "imageWidth",
        keepRatioOnAutoSize: "keepRatioOnAutoSize",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        template: "template",
        templateHeight: "templateHeight",
        templateLeft: "templateLeft",
        templateTop: "templateTop",
        templateWidth: "templateWidth",
        textHeight: "textHeight",
        textLeft: "textLeft",
        textTop: "textTop",
        textWidth: "textWidth",
        title: "title",
        toolboxTemplate: "toolboxTemplate",
        toolboxWidthToHeightRatio: "toolboxWidthToHeightRatio",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_customShapes,
        useExisting: DxiCustomShapeComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiCustomShapeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiCustomShapeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiCustomShapeModule = /*#__PURE__*/(() => {
  class DxiCustomShapeModule {
    /** @nocollapse */static ɵfac = function DxiCustomShapeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCustomShapeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiCustomShapeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiCustomShapeComponent]
    });
  }
  return DxiCustomShapeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataPrepareSettingsComponent = /*#__PURE__*/(() => {
  class DxoDataPrepareSettingsComponent extends NestedOption {
    get checkTypeForAllData() {
      return this._getOption('checkTypeForAllData');
    }
    set checkTypeForAllData(value) {
      this._setOption('checkTypeForAllData', value);
    }
    get convertToAxisDataType() {
      return this._getOption('convertToAxisDataType');
    }
    set convertToAxisDataType(value) {
      this._setOption('convertToAxisDataType', value);
    }
    get sortingMethod() {
      return this._getOption('sortingMethod');
    }
    set sortingMethod(value) {
      this._setOption('sortingMethod', value);
    }
    get _optionPath() {
      return 'dataPrepareSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataPrepareSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataPrepareSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataPrepareSettingsComponent,
      selectors: [["dxo-data-prepare-settings"]],
      inputs: {
        checkTypeForAllData: "checkTypeForAllData",
        convertToAxisDataType: "convertToAxisDataType",
        sortingMethod: "sortingMethod"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataPrepareSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataPrepareSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataPrepareSettingsModule = /*#__PURE__*/(() => {
  class DxoDataPrepareSettingsModule {
    /** @nocollapse */static ɵfac = function DxoDataPrepareSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataPrepareSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataPrepareSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataPrepareSettingsComponent]
    });
  }
  return DxoDataPrepareSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoDayHeaderFormatComponent = /*#__PURE__*/(() => {
  class DxoDayHeaderFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'dayHeaderFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDayHeaderFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDayHeaderFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDayHeaderFormatComponent,
      selectors: [["dxo-day-header-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDayHeaderFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDayHeaderFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDayHeaderFormatModule = /*#__PURE__*/(() => {
  class DxoDayHeaderFormatModule {
    /** @nocollapse */static ɵfac = function DxoDayHeaderFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDayHeaderFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDayHeaderFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDayHeaderFormatComponent]
    });
  }
  return DxoDayHeaderFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDefaultItemPropertiesComponent = /*#__PURE__*/(() => {
  class DxoDefaultItemPropertiesComponent extends NestedOption {
    get connectorLineEnd() {
      return this._getOption('connectorLineEnd');
    }
    set connectorLineEnd(value) {
      this._setOption('connectorLineEnd', value);
    }
    get connectorLineStart() {
      return this._getOption('connectorLineStart');
    }
    set connectorLineStart(value) {
      this._setOption('connectorLineStart', value);
    }
    get connectorLineType() {
      return this._getOption('connectorLineType');
    }
    set connectorLineType(value) {
      this._setOption('connectorLineType', value);
    }
    get shapeMaxHeight() {
      return this._getOption('shapeMaxHeight');
    }
    set shapeMaxHeight(value) {
      this._setOption('shapeMaxHeight', value);
    }
    get shapeMaxWidth() {
      return this._getOption('shapeMaxWidth');
    }
    set shapeMaxWidth(value) {
      this._setOption('shapeMaxWidth', value);
    }
    get shapeMinHeight() {
      return this._getOption('shapeMinHeight');
    }
    set shapeMinHeight(value) {
      this._setOption('shapeMinHeight', value);
    }
    get shapeMinWidth() {
      return this._getOption('shapeMinWidth');
    }
    set shapeMinWidth(value) {
      this._setOption('shapeMinWidth', value);
    }
    get style() {
      return this._getOption('style');
    }
    set style(value) {
      this._setOption('style', value);
    }
    get textStyle() {
      return this._getOption('textStyle');
    }
    set textStyle(value) {
      this._setOption('textStyle', value);
    }
    get _optionPath() {
      return 'defaultItemProperties';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDefaultItemPropertiesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDefaultItemPropertiesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDefaultItemPropertiesComponent,
      selectors: [["dxo-default-item-properties"]],
      inputs: {
        connectorLineEnd: "connectorLineEnd",
        connectorLineStart: "connectorLineStart",
        connectorLineType: "connectorLineType",
        shapeMaxHeight: "shapeMaxHeight",
        shapeMaxWidth: "shapeMaxWidth",
        shapeMinHeight: "shapeMinHeight",
        shapeMinWidth: "shapeMinWidth",
        style: "style",
        textStyle: "textStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDefaultItemPropertiesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDefaultItemPropertiesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDefaultItemPropertiesModule = /*#__PURE__*/(() => {
  class DxoDefaultItemPropertiesModule {
    /** @nocollapse */static ɵfac = function DxoDefaultItemPropertiesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDefaultItemPropertiesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDefaultItemPropertiesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDefaultItemPropertiesComponent]
    });
  }
  return DxoDefaultItemPropertiesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDelayComponent = /*#__PURE__*/(() => {
  class DxoDelayComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'delay';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDelayComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDelayComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDelayComponent,
      selectors: [["dxo-delay"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDelayComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDelayComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDelayModule = /*#__PURE__*/(() => {
  class DxoDelayModule {
    /** @nocollapse */static ɵfac = function DxoDelayModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDelayModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDelayModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDelayComponent]
    });
  }
  return DxoDelayModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDependenciesComponent = /*#__PURE__*/(() => {
  class DxoDependenciesComponent extends NestedOption {
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get predecessorIdExpr() {
      return this._getOption('predecessorIdExpr');
    }
    set predecessorIdExpr(value) {
      this._setOption('predecessorIdExpr', value);
    }
    get successorIdExpr() {
      return this._getOption('successorIdExpr');
    }
    set successorIdExpr(value) {
      this._setOption('successorIdExpr', value);
    }
    get typeExpr() {
      return this._getOption('typeExpr');
    }
    set typeExpr(value) {
      this._setOption('typeExpr', value);
    }
    get _optionPath() {
      return 'dependencies';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDependenciesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDependenciesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDependenciesComponent,
      selectors: [["dxo-dependencies"]],
      inputs: {
        dataSource: "dataSource",
        keyExpr: "keyExpr",
        predecessorIdExpr: "predecessorIdExpr",
        successorIdExpr: "successorIdExpr",
        typeExpr: "typeExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDependenciesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDependenciesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDependenciesModule = /*#__PURE__*/(() => {
  class DxoDependenciesModule {
    /** @nocollapse */static ɵfac = function DxoDependenciesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDependenciesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDependenciesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDependenciesComponent]
    });
  }
  return DxoDependenciesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDetailsComponent = /*#__PURE__*/(() => {
  class DxoDetailsComponent extends NestedOption {
    set _columnsContentChildren(value) {
      this.setChildren('columns', value);
    }
    get columns() {
      return this._getOption('columns');
    }
    set columns(value) {
      this._setOption('columns', value);
    }
    get _optionPath() {
      return 'details';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDetailsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDetailsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDetailsComponent,
      selectors: [["dxo-details"]],
      contentQueries: function DxoDetailsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_columns, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._columnsContentChildren = _t);
        }
      },
      inputs: {
        columns: "columns"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDetailsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDetailsModule = /*#__PURE__*/(() => {
  class DxoDetailsModule {
    /** @nocollapse */static ɵfac = function DxoDetailsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDetailsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDetailsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDetailsComponent]
    });
  }
  return DxoDetailsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoDisplayFormatComponent = /*#__PURE__*/(() => {
  class DxoDisplayFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'displayFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDisplayFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDisplayFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDisplayFormatComponent,
      selectors: [["dxo-display-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDisplayFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDisplayFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDisplayFormatModule = /*#__PURE__*/(() => {
  class DxoDisplayFormatModule {
    /** @nocollapse */static ɵfac = function DxoDisplayFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDisplayFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDisplayFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDisplayFormatComponent]
    });
  }
  return DxoDisplayFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDragBoxStyleComponent = /*#__PURE__*/(() => {
  class DxoDragBoxStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'dragBoxStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDragBoxStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDragBoxStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDragBoxStyleComponent,
      selectors: [["dxo-drag-box-style"]],
      inputs: {
        color: "color",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDragBoxStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDragBoxStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDragBoxStyleModule = /*#__PURE__*/(() => {
  class DxoDragBoxStyleModule {
    /** @nocollapse */static ɵfac = function DxoDragBoxStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDragBoxStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDragBoxStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDragBoxStyleComponent]
    });
  }
  return DxoDragBoxStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPopupOptions = /*#__PURE__*/(() => {
  class DxoPopupOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    get hideEvent() {
      return this._getOption('hideEvent');
    }
    set hideEvent(value) {
      this._setOption('hideEvent', value);
    }
    get showEvent() {
      return this._getOption('showEvent');
    }
    set showEvent(value) {
      this._setOption('showEvent', value);
    }
    get target() {
      return this._getOption('target');
    }
    set target(value) {
      this._setOption('target', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoPopupOptions_BaseFactory;
      return function DxoPopupOptions_Factory(__ngFactoryType__) {
        return (ɵDxoPopupOptions_BaseFactory || (ɵDxoPopupOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoPopupOptions)))(__ngFactoryType__ || DxoPopupOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPopupOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPopupOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPopupOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoDropDownOptionsComponent = /*#__PURE__*/(() => {
  class DxoDropDownOptionsComponent extends DxoPopupOptions {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'dropDownOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownOptionsComponent,
      selectors: [["dxo-drop-down-options"]],
      contentQueries: function DxoDropDownOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr",
        hideEvent: "hideEvent",
        showEvent: "showEvent",
        target: "target"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownOptionsModule = /*#__PURE__*/(() => {
  class DxoDropDownOptionsModule {
    /** @nocollapse */static ɵfac = function DxoDropDownOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownOptionsComponent]
    });
  }
  return DxoDropDownOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoEdgesComponent = /*#__PURE__*/(() => {
  class DxoEdgesComponent extends NestedOption {
    get customDataExpr() {
      return this._getOption('customDataExpr');
    }
    set customDataExpr(value) {
      this._setOption('customDataExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get fromExpr() {
      return this._getOption('fromExpr');
    }
    set fromExpr(value) {
      this._setOption('fromExpr', value);
    }
    get fromLineEndExpr() {
      return this._getOption('fromLineEndExpr');
    }
    set fromLineEndExpr(value) {
      this._setOption('fromLineEndExpr', value);
    }
    get fromPointIndexExpr() {
      return this._getOption('fromPointIndexExpr');
    }
    set fromPointIndexExpr(value) {
      this._setOption('fromPointIndexExpr', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get lineTypeExpr() {
      return this._getOption('lineTypeExpr');
    }
    set lineTypeExpr(value) {
      this._setOption('lineTypeExpr', value);
    }
    get lockedExpr() {
      return this._getOption('lockedExpr');
    }
    set lockedExpr(value) {
      this._setOption('lockedExpr', value);
    }
    get pointsExpr() {
      return this._getOption('pointsExpr');
    }
    set pointsExpr(value) {
      this._setOption('pointsExpr', value);
    }
    get styleExpr() {
      return this._getOption('styleExpr');
    }
    set styleExpr(value) {
      this._setOption('styleExpr', value);
    }
    get textExpr() {
      return this._getOption('textExpr');
    }
    set textExpr(value) {
      this._setOption('textExpr', value);
    }
    get textStyleExpr() {
      return this._getOption('textStyleExpr');
    }
    set textStyleExpr(value) {
      this._setOption('textStyleExpr', value);
    }
    get toExpr() {
      return this._getOption('toExpr');
    }
    set toExpr(value) {
      this._setOption('toExpr', value);
    }
    get toLineEndExpr() {
      return this._getOption('toLineEndExpr');
    }
    set toLineEndExpr(value) {
      this._setOption('toLineEndExpr', value);
    }
    get toPointIndexExpr() {
      return this._getOption('toPointIndexExpr');
    }
    set toPointIndexExpr(value) {
      this._setOption('toPointIndexExpr', value);
    }
    get zIndexExpr() {
      return this._getOption('zIndexExpr');
    }
    set zIndexExpr(value) {
      this._setOption('zIndexExpr', value);
    }
    get _optionPath() {
      return 'edges';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoEdgesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoEdgesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoEdgesComponent,
      selectors: [["dxo-edges"]],
      inputs: {
        customDataExpr: "customDataExpr",
        dataSource: "dataSource",
        fromExpr: "fromExpr",
        fromLineEndExpr: "fromLineEndExpr",
        fromPointIndexExpr: "fromPointIndexExpr",
        keyExpr: "keyExpr",
        lineTypeExpr: "lineTypeExpr",
        lockedExpr: "lockedExpr",
        pointsExpr: "pointsExpr",
        styleExpr: "styleExpr",
        textExpr: "textExpr",
        textStyleExpr: "textStyleExpr",
        toExpr: "toExpr",
        toLineEndExpr: "toLineEndExpr",
        toPointIndexExpr: "toPointIndexExpr",
        zIndexExpr: "zIndexExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoEdgesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoEdgesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoEdgesModule = /*#__PURE__*/(() => {
  class DxoEdgesModule {
    /** @nocollapse */static ɵfac = function DxoEdgesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoEdgesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoEdgesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoEdgesComponent]
    });
  }
  return DxoEdgesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoEditingComponent = /*#__PURE__*/(() => {
  class DxoEditingComponent extends NestedOption {
    set _changesContentChildren(value) {
      this.setChildren('changes', value);
    }
    get allowDeleting() {
      return this._getOption('allowDeleting');
    }
    set allowDeleting(value) {
      this._setOption('allowDeleting', value);
    }
    get allowUpdating() {
      return this._getOption('allowUpdating');
    }
    set allowUpdating(value) {
      this._setOption('allowUpdating', value);
    }
    get allowAdding() {
      return this._getOption('allowAdding');
    }
    set allowAdding(value) {
      this._setOption('allowAdding', value);
    }
    get changes() {
      return this._getOption('changes');
    }
    set changes(value) {
      this._setOption('changes', value);
    }
    get confirmDelete() {
      return this._getOption('confirmDelete');
    }
    set confirmDelete(value) {
      this._setOption('confirmDelete', value);
    }
    get editColumnName() {
      return this._getOption('editColumnName');
    }
    set editColumnName(value) {
      this._setOption('editColumnName', value);
    }
    get editRowKey() {
      return this._getOption('editRowKey');
    }
    set editRowKey(value) {
      this._setOption('editRowKey', value);
    }
    get form() {
      return this._getOption('form');
    }
    set form(value) {
      this._setOption('form', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get newRowPosition() {
      return this._getOption('newRowPosition');
    }
    set newRowPosition(value) {
      this._setOption('newRowPosition', value);
    }
    get popup() {
      return this._getOption('popup');
    }
    set popup(value) {
      this._setOption('popup', value);
    }
    get refreshMode() {
      return this._getOption('refreshMode');
    }
    set refreshMode(value) {
      this._setOption('refreshMode', value);
    }
    get selectTextOnEditStart() {
      return this._getOption('selectTextOnEditStart');
    }
    set selectTextOnEditStart(value) {
      this._setOption('selectTextOnEditStart', value);
    }
    get startEditAction() {
      return this._getOption('startEditAction');
    }
    set startEditAction(value) {
      this._setOption('startEditAction', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get useIcons() {
      return this._getOption('useIcons');
    }
    set useIcons(value) {
      this._setOption('useIcons', value);
    }
    get allowAddShape() {
      return this._getOption('allowAddShape');
    }
    set allowAddShape(value) {
      this._setOption('allowAddShape', value);
    }
    get allowChangeConnection() {
      return this._getOption('allowChangeConnection');
    }
    set allowChangeConnection(value) {
      this._setOption('allowChangeConnection', value);
    }
    get allowChangeConnectorPoints() {
      return this._getOption('allowChangeConnectorPoints');
    }
    set allowChangeConnectorPoints(value) {
      this._setOption('allowChangeConnectorPoints', value);
    }
    get allowChangeConnectorText() {
      return this._getOption('allowChangeConnectorText');
    }
    set allowChangeConnectorText(value) {
      this._setOption('allowChangeConnectorText', value);
    }
    get allowChangeShapeText() {
      return this._getOption('allowChangeShapeText');
    }
    set allowChangeShapeText(value) {
      this._setOption('allowChangeShapeText', value);
    }
    get allowDeleteConnector() {
      return this._getOption('allowDeleteConnector');
    }
    set allowDeleteConnector(value) {
      this._setOption('allowDeleteConnector', value);
    }
    get allowDeleteShape() {
      return this._getOption('allowDeleteShape');
    }
    set allowDeleteShape(value) {
      this._setOption('allowDeleteShape', value);
    }
    get allowMoveShape() {
      return this._getOption('allowMoveShape');
    }
    set allowMoveShape(value) {
      this._setOption('allowMoveShape', value);
    }
    get allowResizeShape() {
      return this._getOption('allowResizeShape');
    }
    set allowResizeShape(value) {
      this._setOption('allowResizeShape', value);
    }
    get allowDependencyAdding() {
      return this._getOption('allowDependencyAdding');
    }
    set allowDependencyAdding(value) {
      this._setOption('allowDependencyAdding', value);
    }
    get allowDependencyDeleting() {
      return this._getOption('allowDependencyDeleting');
    }
    set allowDependencyDeleting(value) {
      this._setOption('allowDependencyDeleting', value);
    }
    get allowResourceAdding() {
      return this._getOption('allowResourceAdding');
    }
    set allowResourceAdding(value) {
      this._setOption('allowResourceAdding', value);
    }
    get allowResourceDeleting() {
      return this._getOption('allowResourceDeleting');
    }
    set allowResourceDeleting(value) {
      this._setOption('allowResourceDeleting', value);
    }
    get allowResourceUpdating() {
      return this._getOption('allowResourceUpdating');
    }
    set allowResourceUpdating(value) {
      this._setOption('allowResourceUpdating', value);
    }
    get allowTaskAdding() {
      return this._getOption('allowTaskAdding');
    }
    set allowTaskAdding(value) {
      this._setOption('allowTaskAdding', value);
    }
    get allowTaskDeleting() {
      return this._getOption('allowTaskDeleting');
    }
    set allowTaskDeleting(value) {
      this._setOption('allowTaskDeleting', value);
    }
    get allowTaskResourceUpdating() {
      return this._getOption('allowTaskResourceUpdating');
    }
    set allowTaskResourceUpdating(value) {
      this._setOption('allowTaskResourceUpdating', value);
    }
    get allowTaskUpdating() {
      return this._getOption('allowTaskUpdating');
    }
    set allowTaskUpdating(value) {
      this._setOption('allowTaskUpdating', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get allowResizing() {
      return this._getOption('allowResizing');
    }
    set allowResizing(value) {
      this._setOption('allowResizing', value);
    }
    get allowTimeZoneEditing() {
      return this._getOption('allowTimeZoneEditing');
    }
    set allowTimeZoneEditing(value) {
      this._setOption('allowTimeZoneEditing', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    changesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    editColumnNameChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    editRowKeyChange;
    get _optionPath() {
      return 'editing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'changesChange'
      }, {
        emit: 'editColumnNameChange'
      }, {
        emit: 'editRowKeyChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoEditingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoEditingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoEditingComponent,
      selectors: [["dxo-editing"]],
      contentQueries: function DxoEditingComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_changes, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._changesContentChildren = _t);
        }
      },
      inputs: {
        allowDeleting: "allowDeleting",
        allowUpdating: "allowUpdating",
        allowAdding: "allowAdding",
        changes: "changes",
        confirmDelete: "confirmDelete",
        editColumnName: "editColumnName",
        editRowKey: "editRowKey",
        form: "form",
        mode: "mode",
        newRowPosition: "newRowPosition",
        popup: "popup",
        refreshMode: "refreshMode",
        selectTextOnEditStart: "selectTextOnEditStart",
        startEditAction: "startEditAction",
        texts: "texts",
        useIcons: "useIcons",
        allowAddShape: "allowAddShape",
        allowChangeConnection: "allowChangeConnection",
        allowChangeConnectorPoints: "allowChangeConnectorPoints",
        allowChangeConnectorText: "allowChangeConnectorText",
        allowChangeShapeText: "allowChangeShapeText",
        allowDeleteConnector: "allowDeleteConnector",
        allowDeleteShape: "allowDeleteShape",
        allowMoveShape: "allowMoveShape",
        allowResizeShape: "allowResizeShape",
        allowDependencyAdding: "allowDependencyAdding",
        allowDependencyDeleting: "allowDependencyDeleting",
        allowResourceAdding: "allowResourceAdding",
        allowResourceDeleting: "allowResourceDeleting",
        allowResourceUpdating: "allowResourceUpdating",
        allowTaskAdding: "allowTaskAdding",
        allowTaskDeleting: "allowTaskDeleting",
        allowTaskResourceUpdating: "allowTaskResourceUpdating",
        allowTaskUpdating: "allowTaskUpdating",
        enabled: "enabled",
        allowDragging: "allowDragging",
        allowResizing: "allowResizing",
        allowTimeZoneEditing: "allowTimeZoneEditing"
      },
      outputs: {
        changesChange: "changesChange",
        editColumnNameChange: "editColumnNameChange",
        editRowKeyChange: "editRowKeyChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoEditingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoEditingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoEditingModule = /*#__PURE__*/(() => {
  class DxoEditingModule {
    /** @nocollapse */static ɵfac = function DxoEditingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoEditingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoEditingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoEditingComponent]
    });
  }
  return DxoEditingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoExportComponent = /*#__PURE__*/(() => {
  class DxoExportComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get printingEnabled() {
      return this._getOption('printingEnabled');
    }
    set printingEnabled(value) {
      this._setOption('printingEnabled', value);
    }
    get svgToCanvas() {
      return this._getOption('svgToCanvas');
    }
    set svgToCanvas(value) {
      this._setOption('svgToCanvas', value);
    }
    get allowExportSelectedData() {
      return this._getOption('allowExportSelectedData');
    }
    set allowExportSelectedData(value) {
      this._setOption('allowExportSelectedData', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoExportComponent,
      selectors: [["dxo-export"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        fileName: "fileName",
        formats: "formats",
        margin: "margin",
        printingEnabled: "printingEnabled",
        svgToCanvas: "svgToCanvas",
        allowExportSelectedData: "allowExportSelectedData",
        texts: "texts"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoExportComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoExportModule = /*#__PURE__*/(() => {
  class DxoExportModule {
    /** @nocollapse */static ɵfac = function DxoExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoExportComponent]
    });
  }
  return DxoExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFieldChooserComponent = /*#__PURE__*/(() => {
  class DxoFieldChooserComponent extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get applyChangesMode() {
      return this._getOption('applyChangesMode');
    }
    set applyChangesMode(value) {
      this._setOption('applyChangesMode', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get layout() {
      return this._getOption('layout');
    }
    set layout(value) {
      this._setOption('layout', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'fieldChooser';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFieldChooserComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFieldChooserComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFieldChooserComponent,
      selectors: [["dxo-field-chooser"]],
      inputs: {
        allowSearch: "allowSearch",
        applyChangesMode: "applyChangesMode",
        enabled: "enabled",
        height: "height",
        layout: "layout",
        searchTimeout: "searchTimeout",
        texts: "texts",
        title: "title",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFieldChooserComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFieldChooserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFieldChooserModule = /*#__PURE__*/(() => {
  class DxoFieldChooserModule {
    /** @nocollapse */static ɵfac = function DxoFieldChooserModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFieldChooserModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFieldChooserModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFieldChooserComponent]
    });
  }
  return DxoFieldChooserModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiFilterBuilderField = /*#__PURE__*/(() => {
  class DxiFilterBuilderField extends CollectionNestedOption {
    get calculateFilterExpression() {
      return this._getOption('calculateFilterExpression');
    }
    set calculateFilterExpression(value) {
      this._setOption('calculateFilterExpression', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get dataType() {
      return this._getOption('dataType');
    }
    set dataType(value) {
      this._setOption('dataType', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get editorTemplate() {
      return this._getOption('editorTemplate');
    }
    set editorTemplate(value) {
      this._setOption('editorTemplate', value);
    }
    get falseText() {
      return this._getOption('falseText');
    }
    set falseText(value) {
      this._setOption('falseText', value);
    }
    get filterOperations() {
      return this._getOption('filterOperations');
    }
    set filterOperations(value) {
      this._setOption('filterOperations', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get lookup() {
      return this._getOption('lookup');
    }
    set lookup(value) {
      this._setOption('lookup', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get trueText() {
      return this._getOption('trueText');
    }
    set trueText(value) {
      this._setOption('trueText', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiFilterBuilderField_BaseFactory;
      return function DxiFilterBuilderField_Factory(__ngFactoryType__) {
        return (ɵDxiFilterBuilderField_BaseFactory || (ɵDxiFilterBuilderField_BaseFactory = i0.ɵɵgetInheritedFactory(DxiFilterBuilderField)))(__ngFactoryType__ || DxiFilterBuilderField);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiFilterBuilderField,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiFilterBuilderField_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiFilterBuilderField;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiFieldComponent = /*#__PURE__*/(() => {
  class DxiFieldComponent extends DxiFilterBuilderField {
    get _optionPath() {
      return 'fields';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiFieldComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiFieldComponent,
      selectors: [["dxi-field"]],
      inputs: {
        calculateFilterExpression: "calculateFilterExpression",
        caption: "caption",
        customizeText: "customizeText",
        dataField: "dataField",
        dataType: "dataType",
        editorOptions: "editorOptions",
        editorTemplate: "editorTemplate",
        falseText: "falseText",
        filterOperations: "filterOperations",
        format: "format",
        lookup: "lookup",
        name: "name",
        trueText: "trueText"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_fields,
        useExisting: DxiFieldComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiFieldComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiFieldModule = /*#__PURE__*/(() => {
  class DxiFieldModule {
    /** @nocollapse */static ɵfac = function DxiFieldModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiFieldModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiFieldModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiFieldComponent]
    });
  }
  return DxiFieldModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFieldPanelComponent = /*#__PURE__*/(() => {
  class DxoFieldPanelComponent extends NestedOption {
    get allowFieldDragging() {
      return this._getOption('allowFieldDragging');
    }
    set allowFieldDragging(value) {
      this._setOption('allowFieldDragging', value);
    }
    get showColumnFields() {
      return this._getOption('showColumnFields');
    }
    set showColumnFields(value) {
      this._setOption('showColumnFields', value);
    }
    get showDataFields() {
      return this._getOption('showDataFields');
    }
    set showDataFields(value) {
      this._setOption('showDataFields', value);
    }
    get showFilterFields() {
      return this._getOption('showFilterFields');
    }
    set showFilterFields(value) {
      this._setOption('showFilterFields', value);
    }
    get showRowFields() {
      return this._getOption('showRowFields');
    }
    set showRowFields(value) {
      this._setOption('showRowFields', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'fieldPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFieldPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFieldPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFieldPanelComponent,
      selectors: [["dxo-field-panel"]],
      inputs: {
        allowFieldDragging: "allowFieldDragging",
        showColumnFields: "showColumnFields",
        showDataFields: "showDataFields",
        showFilterFields: "showFilterFields",
        showRowFields: "showRowFields",
        texts: "texts",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFieldPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFieldPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFieldPanelModule = /*#__PURE__*/(() => {
  class DxoFieldPanelModule {
    /** @nocollapse */static ɵfac = function DxoFieldPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFieldPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFieldPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFieldPanelComponent]
    });
  }
  return DxoFieldPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiFileManagerToolbarItem = /*#__PURE__*/(() => {
  class DxiFileManagerToolbarItem extends CollectionNestedOption {
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiFileManagerToolbarItem_BaseFactory;
      return function DxiFileManagerToolbarItem_Factory(__ngFactoryType__) {
        return (ɵDxiFileManagerToolbarItem_BaseFactory || (ɵDxiFileManagerToolbarItem_BaseFactory = i0.ɵɵgetInheritedFactory(DxiFileManagerToolbarItem)))(__ngFactoryType__ || DxiFileManagerToolbarItem);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiFileManagerToolbarItem,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiFileManagerToolbarItem_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiFileManagerToolbarItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiFileSelectionItemComponent = /*#__PURE__*/(() => {
  class DxiFileSelectionItemComponent extends DxiFileManagerToolbarItem {
    get _optionPath() {
      return 'fileSelectionItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiFileSelectionItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiFileSelectionItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiFileSelectionItemComponent,
      selectors: [["dxi-file-selection-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        icon: "icon",
        locateInMenu: "locateInMenu",
        location: "location",
        name: "name",
        options: "options",
        showText: "showText",
        text: "text",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_fileSelectionItems,
        useExisting: DxiFileSelectionItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiFileSelectionItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiFileSelectionItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiFileSelectionItemModule = /*#__PURE__*/(() => {
  class DxiFileSelectionItemModule {
    /** @nocollapse */static ɵfac = function DxiFileSelectionItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiFileSelectionItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiFileSelectionItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiFileSelectionItemComponent]
    });
  }
  return DxiFileSelectionItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFileUploaderOptions = /*#__PURE__*/(() => {
  class DxoFileUploaderOptions extends NestedOption {
    get abortUpload() {
      return this._getOption('abortUpload');
    }
    set abortUpload(value) {
      this._setOption('abortUpload', value);
    }
    get accept() {
      return this._getOption('accept');
    }
    set accept(value) {
      this._setOption('accept', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get allowCanceling() {
      return this._getOption('allowCanceling');
    }
    set allowCanceling(value) {
      this._setOption('allowCanceling', value);
    }
    get allowedFileExtensions() {
      return this._getOption('allowedFileExtensions');
    }
    set allowedFileExtensions(value) {
      this._setOption('allowedFileExtensions', value);
    }
    get chunkSize() {
      return this._getOption('chunkSize');
    }
    set chunkSize(value) {
      this._setOption('chunkSize', value);
    }
    get dialogTrigger() {
      return this._getOption('dialogTrigger');
    }
    set dialogTrigger(value) {
      this._setOption('dialogTrigger', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dropZone() {
      return this._getOption('dropZone');
    }
    set dropZone(value) {
      this._setOption('dropZone', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get inputAttr() {
      return this._getOption('inputAttr');
    }
    set inputAttr(value) {
      this._setOption('inputAttr', value);
    }
    get invalidFileExtensionMessage() {
      return this._getOption('invalidFileExtensionMessage');
    }
    set invalidFileExtensionMessage(value) {
      this._setOption('invalidFileExtensionMessage', value);
    }
    get invalidMaxFileSizeMessage() {
      return this._getOption('invalidMaxFileSizeMessage');
    }
    set invalidMaxFileSizeMessage(value) {
      this._setOption('invalidMaxFileSizeMessage', value);
    }
    get invalidMinFileSizeMessage() {
      return this._getOption('invalidMinFileSizeMessage');
    }
    set invalidMinFileSizeMessage(value) {
      this._setOption('invalidMinFileSizeMessage', value);
    }
    get isDirty() {
      return this._getOption('isDirty');
    }
    set isDirty(value) {
      this._setOption('isDirty', value);
    }
    get isValid() {
      return this._getOption('isValid');
    }
    set isValid(value) {
      this._setOption('isValid', value);
    }
    get labelText() {
      return this._getOption('labelText');
    }
    set labelText(value) {
      this._setOption('labelText', value);
    }
    get maxFileSize() {
      return this._getOption('maxFileSize');
    }
    set maxFileSize(value) {
      this._setOption('maxFileSize', value);
    }
    get minFileSize() {
      return this._getOption('minFileSize');
    }
    set minFileSize(value) {
      this._setOption('minFileSize', value);
    }
    get multiple() {
      return this._getOption('multiple');
    }
    set multiple(value) {
      this._setOption('multiple', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get onBeforeSend() {
      return this._getOption('onBeforeSend');
    }
    set onBeforeSend(value) {
      this._setOption('onBeforeSend', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onDropZoneEnter() {
      return this._getOption('onDropZoneEnter');
    }
    set onDropZoneEnter(value) {
      this._setOption('onDropZoneEnter', value);
    }
    get onDropZoneLeave() {
      return this._getOption('onDropZoneLeave');
    }
    set onDropZoneLeave(value) {
      this._setOption('onDropZoneLeave', value);
    }
    get onFilesUploaded() {
      return this._getOption('onFilesUploaded');
    }
    set onFilesUploaded(value) {
      this._setOption('onFilesUploaded', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onProgress() {
      return this._getOption('onProgress');
    }
    set onProgress(value) {
      this._setOption('onProgress', value);
    }
    get onUploadAborted() {
      return this._getOption('onUploadAborted');
    }
    set onUploadAborted(value) {
      this._setOption('onUploadAborted', value);
    }
    get onUploaded() {
      return this._getOption('onUploaded');
    }
    set onUploaded(value) {
      this._setOption('onUploaded', value);
    }
    get onUploadError() {
      return this._getOption('onUploadError');
    }
    set onUploadError(value) {
      this._setOption('onUploadError', value);
    }
    get onUploadStarted() {
      return this._getOption('onUploadStarted');
    }
    set onUploadStarted(value) {
      this._setOption('onUploadStarted', value);
    }
    get onValueChanged() {
      return this._getOption('onValueChanged');
    }
    set onValueChanged(value) {
      this._setOption('onValueChanged', value);
    }
    get progress() {
      return this._getOption('progress');
    }
    set progress(value) {
      this._setOption('progress', value);
    }
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    get readyToUploadMessage() {
      return this._getOption('readyToUploadMessage');
    }
    set readyToUploadMessage(value) {
      this._setOption('readyToUploadMessage', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get selectButtonText() {
      return this._getOption('selectButtonText');
    }
    set selectButtonText(value) {
      this._setOption('selectButtonText', value);
    }
    get showFileList() {
      return this._getOption('showFileList');
    }
    set showFileList(value) {
      this._setOption('showFileList', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get uploadAbortedMessage() {
      return this._getOption('uploadAbortedMessage');
    }
    set uploadAbortedMessage(value) {
      this._setOption('uploadAbortedMessage', value);
    }
    get uploadButtonText() {
      return this._getOption('uploadButtonText');
    }
    set uploadButtonText(value) {
      this._setOption('uploadButtonText', value);
    }
    get uploadChunk() {
      return this._getOption('uploadChunk');
    }
    set uploadChunk(value) {
      this._setOption('uploadChunk', value);
    }
    get uploadCustomData() {
      return this._getOption('uploadCustomData');
    }
    set uploadCustomData(value) {
      this._setOption('uploadCustomData', value);
    }
    get uploadedMessage() {
      return this._getOption('uploadedMessage');
    }
    set uploadedMessage(value) {
      this._setOption('uploadedMessage', value);
    }
    get uploadFailedMessage() {
      return this._getOption('uploadFailedMessage');
    }
    set uploadFailedMessage(value) {
      this._setOption('uploadFailedMessage', value);
    }
    get uploadFile() {
      return this._getOption('uploadFile');
    }
    set uploadFile(value) {
      this._setOption('uploadFile', value);
    }
    get uploadHeaders() {
      return this._getOption('uploadHeaders');
    }
    set uploadHeaders(value) {
      this._setOption('uploadHeaders', value);
    }
    get uploadMethod() {
      return this._getOption('uploadMethod');
    }
    set uploadMethod(value) {
      this._setOption('uploadMethod', value);
    }
    get uploadMode() {
      return this._getOption('uploadMode');
    }
    set uploadMode(value) {
      this._setOption('uploadMode', value);
    }
    get uploadUrl() {
      return this._getOption('uploadUrl');
    }
    set uploadUrl(value) {
      this._setOption('uploadUrl', value);
    }
    get validationError() {
      return this._getOption('validationError');
    }
    set validationError(value) {
      this._setOption('validationError', value);
    }
    get validationErrors() {
      return this._getOption('validationErrors');
    }
    set validationErrors(value) {
      this._setOption('validationErrors', value);
    }
    get validationStatus() {
      return this._getOption('validationStatus');
    }
    set validationStatus(value) {
      this._setOption('validationStatus', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFileUploaderOptions_BaseFactory;
      return function DxoFileUploaderOptions_Factory(__ngFactoryType__) {
        return (ɵDxoFileUploaderOptions_BaseFactory || (ɵDxoFileUploaderOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFileUploaderOptions)))(__ngFactoryType__ || DxoFileUploaderOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFileUploaderOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFileUploaderOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFileUploaderOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFileUploaderOptionsComponent = /*#__PURE__*/(() => {
  class DxoFileUploaderOptionsComponent extends DxoFileUploaderOptions {
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'fileUploaderOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFileUploaderOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFileUploaderOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFileUploaderOptionsComponent,
      selectors: [["dxo-file-uploader-options"]],
      inputs: {
        abortUpload: "abortUpload",
        accept: "accept",
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        allowCanceling: "allowCanceling",
        allowedFileExtensions: "allowedFileExtensions",
        chunkSize: "chunkSize",
        dialogTrigger: "dialogTrigger",
        disabled: "disabled",
        dropZone: "dropZone",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        inputAttr: "inputAttr",
        invalidFileExtensionMessage: "invalidFileExtensionMessage",
        invalidMaxFileSizeMessage: "invalidMaxFileSizeMessage",
        invalidMinFileSizeMessage: "invalidMinFileSizeMessage",
        isDirty: "isDirty",
        isValid: "isValid",
        labelText: "labelText",
        maxFileSize: "maxFileSize",
        minFileSize: "minFileSize",
        multiple: "multiple",
        name: "name",
        onBeforeSend: "onBeforeSend",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onDropZoneEnter: "onDropZoneEnter",
        onDropZoneLeave: "onDropZoneLeave",
        onFilesUploaded: "onFilesUploaded",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onProgress: "onProgress",
        onUploadAborted: "onUploadAborted",
        onUploaded: "onUploaded",
        onUploadError: "onUploadError",
        onUploadStarted: "onUploadStarted",
        onValueChanged: "onValueChanged",
        progress: "progress",
        readOnly: "readOnly",
        readyToUploadMessage: "readyToUploadMessage",
        rtlEnabled: "rtlEnabled",
        selectButtonText: "selectButtonText",
        showFileList: "showFileList",
        tabIndex: "tabIndex",
        uploadAbortedMessage: "uploadAbortedMessage",
        uploadButtonText: "uploadButtonText",
        uploadChunk: "uploadChunk",
        uploadCustomData: "uploadCustomData",
        uploadedMessage: "uploadedMessage",
        uploadFailedMessage: "uploadFailedMessage",
        uploadFile: "uploadFile",
        uploadHeaders: "uploadHeaders",
        uploadMethod: "uploadMethod",
        uploadMode: "uploadMode",
        uploadUrl: "uploadUrl",
        validationError: "validationError",
        validationErrors: "validationErrors",
        validationStatus: "validationStatus",
        value: "value",
        visible: "visible",
        width: "width"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFileUploaderOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFileUploaderOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFileUploaderOptionsModule = /*#__PURE__*/(() => {
  class DxoFileUploaderOptionsModule {
    /** @nocollapse */static ɵfac = function DxoFileUploaderOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFileUploaderOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFileUploaderOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFileUploaderOptionsComponent]
    });
  }
  return DxoFileUploaderOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFilterBuilderPopupComponent = /*#__PURE__*/(() => {
  class DxoFilterBuilderPopupComponent extends DxoPopupOptions {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'filterBuilderPopup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFilterBuilderPopupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterBuilderPopupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterBuilderPopupComponent,
      selectors: [["dxo-filter-builder-popup"]],
      contentQueries: function DxoFilterBuilderPopupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterBuilderPopupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFilterBuilderPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFilterBuilderPopupModule = /*#__PURE__*/(() => {
  class DxoFilterBuilderPopupModule {
    /** @nocollapse */static ɵfac = function DxoFilterBuilderPopupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterBuilderPopupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFilterBuilderPopupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFilterBuilderPopupComponent]
    });
  }
  return DxoFilterBuilderPopupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFilterBuilderOptions = /*#__PURE__*/(() => {
  class DxoFilterBuilderOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get allowHierarchicalFields() {
      return this._getOption('allowHierarchicalFields');
    }
    set allowHierarchicalFields(value) {
      this._setOption('allowHierarchicalFields', value);
    }
    get customOperations() {
      return this._getOption('customOperations');
    }
    set customOperations(value) {
      this._setOption('customOperations', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get fields() {
      return this._getOption('fields');
    }
    set fields(value) {
      this._setOption('fields', value);
    }
    get filterOperationDescriptions() {
      return this._getOption('filterOperationDescriptions');
    }
    set filterOperationDescriptions(value) {
      this._setOption('filterOperationDescriptions', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get groupOperationDescriptions() {
      return this._getOption('groupOperationDescriptions');
    }
    set groupOperationDescriptions(value) {
      this._setOption('groupOperationDescriptions', value);
    }
    get groupOperations() {
      return this._getOption('groupOperations');
    }
    set groupOperations(value) {
      this._setOption('groupOperations', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxGroupLevel() {
      return this._getOption('maxGroupLevel');
    }
    set maxGroupLevel(value) {
      this._setOption('maxGroupLevel', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onEditorPrepared() {
      return this._getOption('onEditorPrepared');
    }
    set onEditorPrepared(value) {
      this._setOption('onEditorPrepared', value);
    }
    get onEditorPreparing() {
      return this._getOption('onEditorPreparing');
    }
    set onEditorPreparing(value) {
      this._setOption('onEditorPreparing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onValueChanged() {
      return this._getOption('onValueChanged');
    }
    set onValueChanged(value) {
      this._setOption('onValueChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFilterBuilderOptions_BaseFactory;
      return function DxoFilterBuilderOptions_Factory(__ngFactoryType__) {
        return (ɵDxoFilterBuilderOptions_BaseFactory || (ɵDxoFilterBuilderOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFilterBuilderOptions)))(__ngFactoryType__ || DxoFilterBuilderOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterBuilderOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterBuilderOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFilterBuilderOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFilterBuilderComponent = /*#__PURE__*/(() => {
  class DxoFilterBuilderComponent extends DxoFilterBuilderOptions {
    set _customOperationsContentChildren(value) {
      this.setChildren('customOperations', value);
    }
    set _fieldsContentChildren(value) {
      this.setChildren('fields', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'filterBuilder';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFilterBuilderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterBuilderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterBuilderComponent,
      selectors: [["dxo-filter-builder"]],
      contentQueries: function DxoFilterBuilderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_customOperations, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_fields, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customOperationsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._fieldsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        allowHierarchicalFields: "allowHierarchicalFields",
        customOperations: "customOperations",
        disabled: "disabled",
        elementAttr: "elementAttr",
        fields: "fields",
        filterOperationDescriptions: "filterOperationDescriptions",
        focusStateEnabled: "focusStateEnabled",
        groupOperationDescriptions: "groupOperationDescriptions",
        groupOperations: "groupOperations",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxGroupLevel: "maxGroupLevel",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onEditorPrepared: "onEditorPrepared",
        onEditorPreparing: "onEditorPreparing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onValueChanged: "onValueChanged",
        rtlEnabled: "rtlEnabled",
        tabIndex: "tabIndex",
        value: "value",
        visible: "visible",
        width: "width"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterBuilderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFilterBuilderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFilterBuilderModule = /*#__PURE__*/(() => {
  class DxoFilterBuilderModule {
    /** @nocollapse */static ɵfac = function DxoFilterBuilderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterBuilderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFilterBuilderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFilterBuilderComponent]
    });
  }
  return DxoFilterBuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFilterOperationDescriptionsComponent = /*#__PURE__*/(() => {
  class DxoFilterOperationDescriptionsComponent extends NestedOption {
    get between() {
      return this._getOption('between');
    }
    set between(value) {
      this._setOption('between', value);
    }
    get contains() {
      return this._getOption('contains');
    }
    set contains(value) {
      this._setOption('contains', value);
    }
    get endsWith() {
      return this._getOption('endsWith');
    }
    set endsWith(value) {
      this._setOption('endsWith', value);
    }
    get equal() {
      return this._getOption('equal');
    }
    set equal(value) {
      this._setOption('equal', value);
    }
    get greaterThan() {
      return this._getOption('greaterThan');
    }
    set greaterThan(value) {
      this._setOption('greaterThan', value);
    }
    get greaterThanOrEqual() {
      return this._getOption('greaterThanOrEqual');
    }
    set greaterThanOrEqual(value) {
      this._setOption('greaterThanOrEqual', value);
    }
    get isBlank() {
      return this._getOption('isBlank');
    }
    set isBlank(value) {
      this._setOption('isBlank', value);
    }
    get isNotBlank() {
      return this._getOption('isNotBlank');
    }
    set isNotBlank(value) {
      this._setOption('isNotBlank', value);
    }
    get lessThan() {
      return this._getOption('lessThan');
    }
    set lessThan(value) {
      this._setOption('lessThan', value);
    }
    get lessThanOrEqual() {
      return this._getOption('lessThanOrEqual');
    }
    set lessThanOrEqual(value) {
      this._setOption('lessThanOrEqual', value);
    }
    get notContains() {
      return this._getOption('notContains');
    }
    set notContains(value) {
      this._setOption('notContains', value);
    }
    get notEqual() {
      return this._getOption('notEqual');
    }
    set notEqual(value) {
      this._setOption('notEqual', value);
    }
    get startsWith() {
      return this._getOption('startsWith');
    }
    set startsWith(value) {
      this._setOption('startsWith', value);
    }
    get _optionPath() {
      return 'filterOperationDescriptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFilterOperationDescriptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterOperationDescriptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterOperationDescriptionsComponent,
      selectors: [["dxo-filter-operation-descriptions"]],
      inputs: {
        between: "between",
        contains: "contains",
        endsWith: "endsWith",
        equal: "equal",
        greaterThan: "greaterThan",
        greaterThanOrEqual: "greaterThanOrEqual",
        isBlank: "isBlank",
        isNotBlank: "isNotBlank",
        lessThan: "lessThan",
        lessThanOrEqual: "lessThanOrEqual",
        notContains: "notContains",
        notEqual: "notEqual",
        startsWith: "startsWith"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterOperationDescriptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFilterOperationDescriptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFilterOperationDescriptionsModule = /*#__PURE__*/(() => {
  class DxoFilterOperationDescriptionsModule {
    /** @nocollapse */static ɵfac = function DxoFilterOperationDescriptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterOperationDescriptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFilterOperationDescriptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFilterOperationDescriptionsComponent]
    });
  }
  return DxoFilterOperationDescriptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFilterPanel = /*#__PURE__*/(() => {
  class DxoFilterPanel extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get filterEnabled() {
      return this._getOption('filterEnabled');
    }
    set filterEnabled(value) {
      this._setOption('filterEnabled', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFilterPanel_BaseFactory;
      return function DxoFilterPanel_Factory(__ngFactoryType__) {
        return (ɵDxoFilterPanel_BaseFactory || (ɵDxoFilterPanel_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFilterPanel)))(__ngFactoryType__ || DxoFilterPanel);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterPanel,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterPanel_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFilterPanel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFilterPanelComponent = /*#__PURE__*/(() => {
  class DxoFilterPanelComponent extends DxoFilterPanel {
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterEnabledChange;
    get _optionPath() {
      return 'filterPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'filterEnabledChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFilterPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterPanelComponent,
      selectors: [["dxo-filter-panel"]],
      inputs: {
        customizeText: "customizeText",
        filterEnabled: "filterEnabled",
        texts: "texts",
        visible: "visible"
      },
      outputs: {
        filterEnabledChange: "filterEnabledChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFilterPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFilterPanelModule = /*#__PURE__*/(() => {
  class DxoFilterPanelModule {
    /** @nocollapse */static ɵfac = function DxoFilterPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFilterPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFilterPanelComponent]
    });
  }
  return DxoFilterPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGanttFilterRow = /*#__PURE__*/(() => {
  class DxoGanttFilterRow extends NestedOption {
    get applyFilter() {
      return this._getOption('applyFilter');
    }
    set applyFilter(value) {
      this._setOption('applyFilter', value);
    }
    get applyFilterText() {
      return this._getOption('applyFilterText');
    }
    set applyFilterText(value) {
      this._setOption('applyFilterText', value);
    }
    get betweenEndText() {
      return this._getOption('betweenEndText');
    }
    set betweenEndText(value) {
      this._setOption('betweenEndText', value);
    }
    get betweenStartText() {
      return this._getOption('betweenStartText');
    }
    set betweenStartText(value) {
      this._setOption('betweenStartText', value);
    }
    get operationDescriptions() {
      return this._getOption('operationDescriptions');
    }
    set operationDescriptions(value) {
      this._setOption('operationDescriptions', value);
    }
    get resetOperationText() {
      return this._getOption('resetOperationText');
    }
    set resetOperationText(value) {
      this._setOption('resetOperationText', value);
    }
    get showAllText() {
      return this._getOption('showAllText');
    }
    set showAllText(value) {
      this._setOption('showAllText', value);
    }
    get showOperationChooser() {
      return this._getOption('showOperationChooser');
    }
    set showOperationChooser(value) {
      this._setOption('showOperationChooser', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoGanttFilterRow_BaseFactory;
      return function DxoGanttFilterRow_Factory(__ngFactoryType__) {
        return (ɵDxoGanttFilterRow_BaseFactory || (ɵDxoGanttFilterRow_BaseFactory = i0.ɵɵgetInheritedFactory(DxoGanttFilterRow)))(__ngFactoryType__ || DxoGanttFilterRow);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGanttFilterRow,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGanttFilterRow_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoGanttFilterRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFilterRowComponent = /*#__PURE__*/(() => {
  class DxoFilterRowComponent extends DxoGanttFilterRow {
    get _optionPath() {
      return 'filterRow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFilterRowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterRowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterRowComponent,
      selectors: [["dxo-filter-row"]],
      inputs: {
        applyFilter: "applyFilter",
        applyFilterText: "applyFilterText",
        betweenEndText: "betweenEndText",
        betweenStartText: "betweenStartText",
        operationDescriptions: "operationDescriptions",
        resetOperationText: "resetOperationText",
        showAllText: "showAllText",
        showOperationChooser: "showOperationChooser",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterRowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFilterRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFilterRowModule = /*#__PURE__*/(() => {
  class DxoFilterRowModule {
    /** @nocollapse */static ɵfac = function DxoFilterRowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFilterRowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFilterRowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFilterRowComponent]
    });
  }
  return DxoFilterRowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoVizFont = /*#__PURE__*/(() => {
  class DxoVizFont extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get family() {
      return this._getOption('family');
    }
    set family(value) {
      this._setOption('family', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoVizFont_BaseFactory;
      return function DxoVizFont_Factory(__ngFactoryType__) {
        return (ɵDxoVizFont_BaseFactory || (ɵDxoVizFont_BaseFactory = i0.ɵɵgetInheritedFactory(DxoVizFont)))(__ngFactoryType__ || DxoVizFont);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoVizFont,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoVizFont_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoVizFont;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFontComponent = /*#__PURE__*/(() => {
  class DxoFontComponent extends DxoVizFont {
    get _optionPath() {
      return 'font';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFontComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFontComponent,
      selectors: [["dxo-font"]],
      inputs: {
        color: "color",
        family: "family",
        opacity: "opacity",
        size: "size",
        weight: "weight"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFontComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFontComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFontModule = /*#__PURE__*/(() => {
  class DxoFontModule {
    /** @nocollapse */static ɵfac = function DxoFontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFontModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFontModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFontComponent]
    });
  }
  return DxoFontModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFormSimpleItem = /*#__PURE__*/(() => {
  class DxoFormSimpleItem extends NestedOption {
    get colSpan() {
      return this._getOption('colSpan');
    }
    set colSpan(value) {
      this._setOption('colSpan', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get editorType() {
      return this._getOption('editorType');
    }
    set editorType(value) {
      this._setOption('editorType', value);
    }
    get helpText() {
      return this._getOption('helpText');
    }
    set helpText(value) {
      this._setOption('helpText', value);
    }
    get isRequired() {
      return this._getOption('isRequired');
    }
    set isRequired(value) {
      this._setOption('isRequired', value);
    }
    get itemType() {
      return this._getOption('itemType');
    }
    set itemType(value) {
      this._setOption('itemType', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get validationRules() {
      return this._getOption('validationRules');
    }
    set validationRules(value) {
      this._setOption('validationRules', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visibleIndex() {
      return this._getOption('visibleIndex');
    }
    set visibleIndex(value) {
      this._setOption('visibleIndex', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFormSimpleItem_BaseFactory;
      return function DxoFormSimpleItem_Factory(__ngFactoryType__) {
        return (ɵDxoFormSimpleItem_BaseFactory || (ɵDxoFormSimpleItem_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFormSimpleItem)))(__ngFactoryType__ || DxoFormSimpleItem);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFormSimpleItem,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFormSimpleItem_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFormSimpleItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFormItemComponent = /*#__PURE__*/(() => {
  class DxoFormItemComponent extends DxoFormSimpleItem {
    set _validationRulesContentChildren(value) {
      this.setChildren('validationRules', value);
    }
    get _optionPath() {
      return 'formItem';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFormItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFormItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFormItemComponent,
      selectors: [["dxo-form-item"]],
      contentQueries: function DxoFormItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_validationRules, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._validationRulesContentChildren = _t);
        }
      },
      inputs: {
        colSpan: "colSpan",
        cssClass: "cssClass",
        dataField: "dataField",
        editorOptions: "editorOptions",
        editorType: "editorType",
        helpText: "helpText",
        isRequired: "isRequired",
        itemType: "itemType",
        label: "label",
        name: "name",
        template: "template",
        validationRules: "validationRules",
        visible: "visible",
        visibleIndex: "visibleIndex"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFormItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFormItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFormItemModule = /*#__PURE__*/(() => {
  class DxoFormItemModule {
    /** @nocollapse */static ɵfac = function DxoFormItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFormItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFormItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFormItemComponent]
    });
  }
  return DxoFormItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFormOptions = /*#__PURE__*/(() => {
  class DxoFormOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get alignItemLabels() {
      return this._getOption('alignItemLabels');
    }
    set alignItemLabels(value) {
      this._setOption('alignItemLabels', value);
    }
    get alignItemLabelsInAllGroups() {
      return this._getOption('alignItemLabelsInAllGroups');
    }
    set alignItemLabelsInAllGroups(value) {
      this._setOption('alignItemLabelsInAllGroups', value);
    }
    get colCount() {
      return this._getOption('colCount');
    }
    set colCount(value) {
      this._setOption('colCount', value);
    }
    get colCountByScreen() {
      return this._getOption('colCountByScreen');
    }
    set colCountByScreen(value) {
      this._setOption('colCountByScreen', value);
    }
    get customizeItem() {
      return this._getOption('customizeItem');
    }
    set customizeItem(value) {
      this._setOption('customizeItem', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get formData() {
      return this._getOption('formData');
    }
    set formData(value) {
      this._setOption('formData', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get isDirty() {
      return this._getOption('isDirty');
    }
    set isDirty(value) {
      this._setOption('isDirty', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get labelLocation() {
      return this._getOption('labelLocation');
    }
    set labelLocation(value) {
      this._setOption('labelLocation', value);
    }
    get labelMode() {
      return this._getOption('labelMode');
    }
    set labelMode(value) {
      this._setOption('labelMode', value);
    }
    get minColWidth() {
      return this._getOption('minColWidth');
    }
    set minColWidth(value) {
      this._setOption('minColWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onEditorEnterKey() {
      return this._getOption('onEditorEnterKey');
    }
    set onEditorEnterKey(value) {
      this._setOption('onEditorEnterKey', value);
    }
    get onFieldDataChanged() {
      return this._getOption('onFieldDataChanged');
    }
    set onFieldDataChanged(value) {
      this._setOption('onFieldDataChanged', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get optionalMark() {
      return this._getOption('optionalMark');
    }
    set optionalMark(value) {
      this._setOption('optionalMark', value);
    }
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    get requiredMark() {
      return this._getOption('requiredMark');
    }
    set requiredMark(value) {
      this._setOption('requiredMark', value);
    }
    get requiredMessage() {
      return this._getOption('requiredMessage');
    }
    set requiredMessage(value) {
      this._setOption('requiredMessage', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get screenByWidth() {
      return this._getOption('screenByWidth');
    }
    set screenByWidth(value) {
      this._setOption('screenByWidth', value);
    }
    get scrollingEnabled() {
      return this._getOption('scrollingEnabled');
    }
    set scrollingEnabled(value) {
      this._setOption('scrollingEnabled', value);
    }
    get showColonAfterLabel() {
      return this._getOption('showColonAfterLabel');
    }
    set showColonAfterLabel(value) {
      this._setOption('showColonAfterLabel', value);
    }
    get showOptionalMark() {
      return this._getOption('showOptionalMark');
    }
    set showOptionalMark(value) {
      this._setOption('showOptionalMark', value);
    }
    get showRequiredMark() {
      return this._getOption('showRequiredMark');
    }
    set showRequiredMark(value) {
      this._setOption('showRequiredMark', value);
    }
    get showValidationSummary() {
      return this._getOption('showValidationSummary');
    }
    set showValidationSummary(value) {
      this._setOption('showValidationSummary', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFormOptions_BaseFactory;
      return function DxoFormOptions_Factory(__ngFactoryType__) {
        return (ɵDxoFormOptions_BaseFactory || (ɵDxoFormOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFormOptions)))(__ngFactoryType__ || DxoFormOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFormOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFormOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFormOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFormComponent = /*#__PURE__*/(() => {
  class DxoFormComponent extends DxoFormOptions {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    formDataChange;
    get _optionPath() {
      return 'form';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'formDataChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFormComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFormComponent,
      selectors: [["dxo-form"]],
      contentQueries: function DxoFormComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        alignItemLabels: "alignItemLabels",
        alignItemLabelsInAllGroups: "alignItemLabelsInAllGroups",
        colCount: "colCount",
        colCountByScreen: "colCountByScreen",
        customizeItem: "customizeItem",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        formData: "formData",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        isDirty: "isDirty",
        items: "items",
        labelLocation: "labelLocation",
        labelMode: "labelMode",
        minColWidth: "minColWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onEditorEnterKey: "onEditorEnterKey",
        onFieldDataChanged: "onFieldDataChanged",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        optionalMark: "optionalMark",
        readOnly: "readOnly",
        requiredMark: "requiredMark",
        requiredMessage: "requiredMessage",
        rtlEnabled: "rtlEnabled",
        screenByWidth: "screenByWidth",
        scrollingEnabled: "scrollingEnabled",
        showColonAfterLabel: "showColonAfterLabel",
        showOptionalMark: "showOptionalMark",
        showRequiredMark: "showRequiredMark",
        showValidationSummary: "showValidationSummary",
        tabIndex: "tabIndex",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      outputs: {
        formDataChange: "formDataChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFormComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFormModule = /*#__PURE__*/(() => {
  class DxoFormModule {
    /** @nocollapse */static ɵfac = function DxoFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFormModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFormModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFormComponent]
    });
  }
  return DxoFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFormatComponent = /*#__PURE__*/(() => {
  class DxoFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFormatComponent,
      selectors: [["dxo-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFormatModule = /*#__PURE__*/(() => {
  class DxoFormatModule {
    /** @nocollapse */static ɵfac = function DxoFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFormatComponent]
    });
  }
  return DxoFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoAnimationState = /*#__PURE__*/(() => {
  class DxoAnimationState extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoAnimationState_BaseFactory;
      return function DxoAnimationState_Factory(__ngFactoryType__) {
        return (ɵDxoAnimationState_BaseFactory || (ɵDxoAnimationState_BaseFactory = i0.ɵɵgetInheritedFactory(DxoAnimationState)))(__ngFactoryType__ || DxoAnimationState);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoAnimationState,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoAnimationState_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoAnimationState;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFromComponent = /*#__PURE__*/(() => {
  class DxoFromComponent extends DxoAnimationState {
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFromComponent,
      selectors: [["dxo-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFromComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFromModule = /*#__PURE__*/(() => {
  class DxoFromModule {
    /** @nocollapse */static ɵfac = function DxoFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFromComponent]
    });
  }
  return DxoFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFullstackedareaComponent = /*#__PURE__*/(() => {
  class DxoFullstackedareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'fullstackedarea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFullstackedareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFullstackedareaComponent,
      selectors: [["dxo-fullstackedarea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFullstackedareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFullstackedareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFullstackedareaModule = /*#__PURE__*/(() => {
  class DxoFullstackedareaModule {
    /** @nocollapse */static ɵfac = function DxoFullstackedareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFullstackedareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFullstackedareaComponent]
    });
  }
  return DxoFullstackedareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFullstackedbarComponent = /*#__PURE__*/(() => {
  class DxoFullstackedbarComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'fullstackedbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFullstackedbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFullstackedbarComponent,
      selectors: [["dxo-fullstackedbar"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFullstackedbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFullstackedbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFullstackedbarModule = /*#__PURE__*/(() => {
  class DxoFullstackedbarModule {
    /** @nocollapse */static ɵfac = function DxoFullstackedbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFullstackedbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFullstackedbarComponent]
    });
  }
  return DxoFullstackedbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFullstackedlineComponent = /*#__PURE__*/(() => {
  class DxoFullstackedlineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'fullstackedline';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFullstackedlineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedlineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFullstackedlineComponent,
      selectors: [["dxo-fullstackedline"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFullstackedlineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFullstackedlineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFullstackedlineModule = /*#__PURE__*/(() => {
  class DxoFullstackedlineModule {
    /** @nocollapse */static ɵfac = function DxoFullstackedlineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedlineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFullstackedlineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFullstackedlineComponent]
    });
  }
  return DxoFullstackedlineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFullstackedsplineComponent = /*#__PURE__*/(() => {
  class DxoFullstackedsplineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'fullstackedspline';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFullstackedsplineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedsplineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFullstackedsplineComponent,
      selectors: [["dxo-fullstackedspline"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFullstackedsplineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFullstackedsplineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFullstackedsplineModule = /*#__PURE__*/(() => {
  class DxoFullstackedsplineModule {
    /** @nocollapse */static ɵfac = function DxoFullstackedsplineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedsplineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFullstackedsplineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFullstackedsplineComponent]
    });
  }
  return DxoFullstackedsplineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoFullstackedsplineareaComponent = /*#__PURE__*/(() => {
  class DxoFullstackedsplineareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'fullstackedsplinearea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoFullstackedsplineareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedsplineareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFullstackedsplineareaComponent,
      selectors: [["dxo-fullstackedsplinearea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFullstackedsplineareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoFullstackedsplineareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoFullstackedsplineareaModule = /*#__PURE__*/(() => {
  class DxoFullstackedsplineareaModule {
    /** @nocollapse */static ɵfac = function DxoFullstackedsplineareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoFullstackedsplineareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoFullstackedsplineareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoFullstackedsplineareaComponent]
    });
  }
  return DxoFullstackedsplineareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGeometryComponent = /*#__PURE__*/(() => {
  class DxoGeometryComponent extends NestedOption {
    get endAngle() {
      return this._getOption('endAngle');
    }
    set endAngle(value) {
      this._setOption('endAngle', value);
    }
    get startAngle() {
      return this._getOption('startAngle');
    }
    set startAngle(value) {
      this._setOption('startAngle', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get _optionPath() {
      return 'geometry';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGeometryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGeometryComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGeometryComponent,
      selectors: [["dxo-geometry"]],
      inputs: {
        endAngle: "endAngle",
        startAngle: "startAngle",
        orientation: "orientation"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGeometryComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGeometryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGeometryModule = /*#__PURE__*/(() => {
  class DxoGeometryModule {
    /** @nocollapse */static ɵfac = function DxoGeometryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGeometryModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGeometryModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGeometryComponent]
    });
  }
  return DxoGeometryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGridSizeComponent = /*#__PURE__*/(() => {
  class DxoGridSizeComponent extends NestedOption {
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'gridSize';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGridSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGridSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGridSizeComponent,
      selectors: [["dxo-grid-size"]],
      inputs: {
        items: "items",
        value: "value"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGridSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGridSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGridSizeModule = /*#__PURE__*/(() => {
  class DxoGridSizeModule {
    /** @nocollapse */static ɵfac = function DxoGridSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGridSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGridSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGridSizeComponent]
    });
  }
  return DxoGridSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGridComponent = /*#__PURE__*/(() => {
  class DxoGridComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'grid';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGridComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGridComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGridComponent,
      selectors: [["dxo-grid"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGridComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGridModule = /*#__PURE__*/(() => {
  class DxoGridModule {
    /** @nocollapse */static ɵfac = function DxoGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGridModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGridModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGridComponent]
    });
  }
  return DxoGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiGroupComponent = /*#__PURE__*/(() => {
  class DxiGroupComponent extends CollectionNestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get expanded() {
      return this._getOption('expanded');
    }
    set expanded(value) {
      this._setOption('expanded', value);
    }
    get shapes() {
      return this._getOption('shapes');
    }
    set shapes(value) {
      this._setOption('shapes', value);
    }
    get _optionPath() {
      return 'groups';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiGroupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiGroupComponent,
      selectors: [["dxi-group"]],
      contentQueries: function DxiGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        title: "title",
        category: "category",
        displayMode: "displayMode",
        expanded: "expanded",
        shapes: "shapes"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_groups,
        useExisting: DxiGroupComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiGroupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiGroupModule = /*#__PURE__*/(() => {
  class DxiGroupModule {
    /** @nocollapse */static ɵfac = function DxiGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiGroupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiGroupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiGroupComponent]
    });
  }
  return DxiGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiGroupItemComponent = /*#__PURE__*/(() => {
  class DxiGroupItemComponent extends CollectionNestedOption {
    get alignByColumn() {
      return this._getOption('alignByColumn');
    }
    set alignByColumn(value) {
      this._setOption('alignByColumn', value);
    }
    get column() {
      return this._getOption('column');
    }
    set column(value) {
      this._setOption('column', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get showInColumn() {
      return this._getOption('showInColumn');
    }
    set showInColumn(value) {
      this._setOption('showInColumn', value);
    }
    get showInGroupFooter() {
      return this._getOption('showInGroupFooter');
    }
    set showInGroupFooter(value) {
      this._setOption('showInGroupFooter', value);
    }
    get skipEmptyValues() {
      return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value) {
      this._setOption('skipEmptyValues', value);
    }
    get summaryType() {
      return this._getOption('summaryType');
    }
    set summaryType(value) {
      this._setOption('summaryType', value);
    }
    get valueFormat() {
      return this._getOption('valueFormat');
    }
    set valueFormat(value) {
      this._setOption('valueFormat', value);
    }
    get _optionPath() {
      return 'groupItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiGroupItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiGroupItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiGroupItemComponent,
      selectors: [["dxi-group-item"]],
      inputs: {
        alignByColumn: "alignByColumn",
        column: "column",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        name: "name",
        showInColumn: "showInColumn",
        showInGroupFooter: "showInGroupFooter",
        skipEmptyValues: "skipEmptyValues",
        summaryType: "summaryType",
        valueFormat: "valueFormat"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_groupItems,
        useExisting: DxiGroupItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiGroupItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiGroupItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiGroupItemModule = /*#__PURE__*/(() => {
  class DxiGroupItemModule {
    /** @nocollapse */static ɵfac = function DxiGroupItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiGroupItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiGroupItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiGroupItemComponent]
    });
  }
  return DxiGroupItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGroupOperationDescriptionsComponent = /*#__PURE__*/(() => {
  class DxoGroupOperationDescriptionsComponent extends NestedOption {
    get and() {
      return this._getOption('and');
    }
    set and(value) {
      this._setOption('and', value);
    }
    get notAnd() {
      return this._getOption('notAnd');
    }
    set notAnd(value) {
      this._setOption('notAnd', value);
    }
    get notOr() {
      return this._getOption('notOr');
    }
    set notOr(value) {
      this._setOption('notOr', value);
    }
    get or() {
      return this._getOption('or');
    }
    set or(value) {
      this._setOption('or', value);
    }
    get _optionPath() {
      return 'groupOperationDescriptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGroupOperationDescriptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupOperationDescriptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGroupOperationDescriptionsComponent,
      selectors: [["dxo-group-operation-descriptions"]],
      inputs: {
        and: "and",
        notAnd: "notAnd",
        notOr: "notOr",
        or: "or"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGroupOperationDescriptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGroupOperationDescriptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGroupOperationDescriptionsModule = /*#__PURE__*/(() => {
  class DxoGroupOperationDescriptionsModule {
    /** @nocollapse */static ɵfac = function DxoGroupOperationDescriptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupOperationDescriptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGroupOperationDescriptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGroupOperationDescriptionsComponent]
    });
  }
  return DxoGroupOperationDescriptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGroupPanelComponent = /*#__PURE__*/(() => {
  class DxoGroupPanelComponent extends NestedOption {
    get allowColumnDragging() {
      return this._getOption('allowColumnDragging');
    }
    set allowColumnDragging(value) {
      this._setOption('allowColumnDragging', value);
    }
    get emptyPanelText() {
      return this._getOption('emptyPanelText');
    }
    set emptyPanelText(value) {
      this._setOption('emptyPanelText', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    get _optionPath() {
      return 'groupPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'visibleChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGroupPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGroupPanelComponent,
      selectors: [["dxo-group-panel"]],
      inputs: {
        allowColumnDragging: "allowColumnDragging",
        emptyPanelText: "emptyPanelText",
        visible: "visible"
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGroupPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGroupPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGroupPanelModule = /*#__PURE__*/(() => {
  class DxoGroupPanelModule {
    /** @nocollapse */static ɵfac = function DxoGroupPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGroupPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGroupPanelComponent]
    });
  }
  return DxoGroupPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGroupComponent = /*#__PURE__*/(() => {
  class DxoGroupComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get headerHeight() {
      return this._getOption('headerHeight');
    }
    set headerHeight(value) {
      this._setOption('headerHeight', value);
    }
    get hoverEnabled() {
      return this._getOption('hoverEnabled');
    }
    set hoverEnabled(value) {
      this._setOption('hoverEnabled', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get padding() {
      return this._getOption('padding');
    }
    set padding(value) {
      this._setOption('padding', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get _optionPath() {
      return 'group';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGroupComponent,
      selectors: [["dxo-group"]],
      inputs: {
        border: "border",
        color: "color",
        headerHeight: "headerHeight",
        hoverEnabled: "hoverEnabled",
        hoverStyle: "hoverStyle",
        label: "label",
        padding: "padding",
        selectionStyle: "selectionStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGroupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGroupModule = /*#__PURE__*/(() => {
  class DxoGroupModule {
    /** @nocollapse */static ɵfac = function DxoGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGroupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGroupComponent]
    });
  }
  return DxoGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGroupingComponent = /*#__PURE__*/(() => {
  class DxoGroupingComponent extends NestedOption {
    get allowCollapsing() {
      return this._getOption('allowCollapsing');
    }
    set allowCollapsing(value) {
      this._setOption('allowCollapsing', value);
    }
    get autoExpandAll() {
      return this._getOption('autoExpandAll');
    }
    set autoExpandAll(value) {
      this._setOption('autoExpandAll', value);
    }
    get contextMenuEnabled() {
      return this._getOption('contextMenuEnabled');
    }
    set contextMenuEnabled(value) {
      this._setOption('contextMenuEnabled', value);
    }
    get expandMode() {
      return this._getOption('expandMode');
    }
    set expandMode(value) {
      this._setOption('expandMode', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get _optionPath() {
      return 'grouping';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoGroupingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGroupingComponent,
      selectors: [["dxo-grouping"]],
      inputs: {
        allowCollapsing: "allowCollapsing",
        autoExpandAll: "autoExpandAll",
        contextMenuEnabled: "contextMenuEnabled",
        expandMode: "expandMode",
        texts: "texts"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGroupingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoGroupingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoGroupingModule = /*#__PURE__*/(() => {
  class DxoGroupingModule {
    /** @nocollapse */static ɵfac = function DxoGroupingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoGroupingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoGroupingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoGroupingComponent]
    });
  }
  return DxoGroupingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHatchingComponent = /*#__PURE__*/(() => {
  class DxoHatchingComponent extends NestedOption {
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get step() {
      return this._getOption('step');
    }
    set step(value) {
      this._setOption('step', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'hatching';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHatchingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHatchingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHatchingComponent,
      selectors: [["dxo-hatching"]],
      inputs: {
        direction: "direction",
        opacity: "opacity",
        step: "step",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHatchingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHatchingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHatchingModule = /*#__PURE__*/(() => {
  class DxoHatchingModule {
    /** @nocollapse */static ɵfac = function DxoHatchingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHatchingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHatchingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHatchingComponent]
    });
  }
  return DxoHatchingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColumnHeaderFilter = /*#__PURE__*/(() => {
  class DxoColumnHeaderFilter extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get groupInterval() {
      return this._getOption('groupInterval');
    }
    set groupInterval(value) {
      this._setOption('groupInterval', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get search() {
      return this._getOption('search');
    }
    set search(value) {
      this._setOption('search', value);
    }
    get searchMode() {
      return this._getOption('searchMode');
    }
    set searchMode(value) {
      this._setOption('searchMode', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get showRelevantValues() {
      return this._getOption('showRelevantValues');
    }
    set showRelevantValues(value) {
      this._setOption('showRelevantValues', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoColumnHeaderFilter_BaseFactory;
      return function DxoColumnHeaderFilter_Factory(__ngFactoryType__) {
        return (ɵDxoColumnHeaderFilter_BaseFactory || (ɵDxoColumnHeaderFilter_BaseFactory = i0.ɵɵgetInheritedFactory(DxoColumnHeaderFilter)))(__ngFactoryType__ || DxoColumnHeaderFilter);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColumnHeaderFilter,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColumnHeaderFilter_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoColumnHeaderFilter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoHeaderFilterComponent = /*#__PURE__*/(() => {
  class DxoHeaderFilterComponent extends DxoColumnHeaderFilter {
    get _optionPath() {
      return 'headerFilter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHeaderFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHeaderFilterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHeaderFilterComponent,
      selectors: [["dxo-header-filter"]],
      inputs: {
        allowSearch: "allowSearch",
        allowSelectAll: "allowSelectAll",
        dataSource: "dataSource",
        groupInterval: "groupInterval",
        height: "height",
        search: "search",
        searchMode: "searchMode",
        width: "width",
        searchTimeout: "searchTimeout",
        texts: "texts",
        visible: "visible",
        showRelevantValues: "showRelevantValues"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHeaderFilterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHeaderFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHeaderFilterModule = /*#__PURE__*/(() => {
  class DxoHeaderFilterModule {
    /** @nocollapse */static ɵfac = function DxoHeaderFilterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHeaderFilterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHeaderFilterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHeaderFilterComponent]
    });
  }
  return DxoHeaderFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHeightComponent = /*#__PURE__*/(() => {
  class DxoHeightComponent extends NestedOption {
    get rangeMaxPoint() {
      return this._getOption('rangeMaxPoint');
    }
    set rangeMaxPoint(value) {
      this._setOption('rangeMaxPoint', value);
    }
    get rangeMinPoint() {
      return this._getOption('rangeMinPoint');
    }
    set rangeMinPoint(value) {
      this._setOption('rangeMinPoint', value);
    }
    get _optionPath() {
      return 'height';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHeightComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHeightComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHeightComponent,
      selectors: [["dxo-height"]],
      inputs: {
        rangeMaxPoint: "rangeMaxPoint",
        rangeMinPoint: "rangeMinPoint"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHeightComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHeightComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHeightModule = /*#__PURE__*/(() => {
  class DxoHeightModule {
    /** @nocollapse */static ɵfac = function DxoHeightModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHeightModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHeightModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHeightComponent]
    });
  }
  return DxoHeightModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHideEventComponent = /*#__PURE__*/(() => {
  class DxoHideEventComponent extends NestedOption {
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'hideEvent';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHideEventComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHideEventComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHideEventComponent,
      selectors: [["dxo-hide-event"]],
      inputs: {
        delay: "delay",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHideEventComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHideEventComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHideEventModule = /*#__PURE__*/(() => {
  class DxoHideEventModule {
    /** @nocollapse */static ɵfac = function DxoHideEventModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHideEventModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHideEventModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHideEventComponent]
    });
  }
  return DxoHideEventModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoHideComponent = /*#__PURE__*/(() => {
  class DxoHideComponent extends DxoAnimationConfig {
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHideComponent,
      selectors: [["dxo-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHideComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHideModule = /*#__PURE__*/(() => {
  class DxoHideModule {
    /** @nocollapse */static ɵfac = function DxoHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHideComponent]
    });
  }
  return DxoHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHistoryToolbarComponent = /*#__PURE__*/(() => {
  class DxoHistoryToolbarComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'historyToolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHistoryToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHistoryToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHistoryToolbarComponent,
      selectors: [["dxo-history-toolbar"]],
      contentQueries: function DxoHistoryToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHistoryToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHistoryToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHistoryToolbarModule = /*#__PURE__*/(() => {
  class DxoHistoryToolbarModule {
    /** @nocollapse */static ɵfac = function DxoHistoryToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHistoryToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHistoryToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHistoryToolbarComponent]
    });
  }
  return DxoHistoryToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHorizontalLineComponent = /*#__PURE__*/(() => {
  class DxoHorizontalLineComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'horizontalLine';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHorizontalLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHorizontalLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHorizontalLineComponent,
      selectors: [["dxo-horizontal-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHorizontalLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHorizontalLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHorizontalLineModule = /*#__PURE__*/(() => {
  class DxoHorizontalLineModule {
    /** @nocollapse */static ɵfac = function DxoHorizontalLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHorizontalLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHorizontalLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHorizontalLineComponent]
    });
  }
  return DxoHorizontalLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHoverStyleComponent,
      selectors: [["dxo-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width",
        size: "size",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoHoverStyleModule = /*#__PURE__*/(() => {
  class DxoHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoHoverStyleComponent]
    });
  }
  return DxoHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoIconsComponent = /*#__PURE__*/(() => {
  class DxoIconsComponent extends NestedOption {
    get fix() {
      return this._getOption('fix');
    }
    set fix(value) {
      this._setOption('fix', value);
    }
    get leftPosition() {
      return this._getOption('leftPosition');
    }
    set leftPosition(value) {
      this._setOption('leftPosition', value);
    }
    get rightPosition() {
      return this._getOption('rightPosition');
    }
    set rightPosition(value) {
      this._setOption('rightPosition', value);
    }
    get stickyPosition() {
      return this._getOption('stickyPosition');
    }
    set stickyPosition(value) {
      this._setOption('stickyPosition', value);
    }
    get unfix() {
      return this._getOption('unfix');
    }
    set unfix(value) {
      this._setOption('unfix', value);
    }
    get _optionPath() {
      return 'icons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoIconsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoIconsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoIconsComponent,
      selectors: [["dxo-icons"]],
      inputs: {
        fix: "fix",
        leftPosition: "leftPosition",
        rightPosition: "rightPosition",
        stickyPosition: "stickyPosition",
        unfix: "unfix"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoIconsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoIconsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoIconsModule = /*#__PURE__*/(() => {
  class DxoIconsModule {
    /** @nocollapse */static ɵfac = function DxoIconsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoIconsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoIconsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoIconsComponent]
    });
  }
  return DxoIconsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorImageUpload = /*#__PURE__*/(() => {
  class DxoHtmlEditorImageUpload extends NestedOption {
    get fileUploaderOptions() {
      return this._getOption('fileUploaderOptions');
    }
    set fileUploaderOptions(value) {
      this._setOption('fileUploaderOptions', value);
    }
    get fileUploadMode() {
      return this._getOption('fileUploadMode');
    }
    set fileUploadMode(value) {
      this._setOption('fileUploadMode', value);
    }
    get tabs() {
      return this._getOption('tabs');
    }
    set tabs(value) {
      this._setOption('tabs', value);
    }
    get uploadDirectory() {
      return this._getOption('uploadDirectory');
    }
    set uploadDirectory(value) {
      this._setOption('uploadDirectory', value);
    }
    get uploadUrl() {
      return this._getOption('uploadUrl');
    }
    set uploadUrl(value) {
      this._setOption('uploadUrl', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoHtmlEditorImageUpload_BaseFactory;
      return function DxoHtmlEditorImageUpload_Factory(__ngFactoryType__) {
        return (ɵDxoHtmlEditorImageUpload_BaseFactory || (ɵDxoHtmlEditorImageUpload_BaseFactory = i0.ɵɵgetInheritedFactory(DxoHtmlEditorImageUpload)))(__ngFactoryType__ || DxoHtmlEditorImageUpload);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorImageUpload,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorImageUpload_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorImageUpload;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoImageUploadComponent = /*#__PURE__*/(() => {
  class DxoImageUploadComponent extends DxoHtmlEditorImageUpload {
    set _tabsContentChildren(value) {
      this.setChildren('tabs', value);
    }
    get _optionPath() {
      return 'imageUpload';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoImageUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoImageUploadComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoImageUploadComponent,
      selectors: [["dxo-image-upload"]],
      contentQueries: function DxoImageUploadComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_tabs, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabsContentChildren = _t);
        }
      },
      inputs: {
        fileUploaderOptions: "fileUploaderOptions",
        fileUploadMode: "fileUploadMode",
        tabs: "tabs",
        uploadDirectory: "uploadDirectory",
        uploadUrl: "uploadUrl"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoImageUploadComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoImageUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoImageUploadModule = /*#__PURE__*/(() => {
  class DxoImageUploadModule {
    /** @nocollapse */static ɵfac = function DxoImageUploadModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoImageUploadModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoImageUploadModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoImageUploadComponent]
    });
  }
  return DxoImageUploadModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoImageComponent = /*#__PURE__*/(() => {
  class DxoImageComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get _optionPath() {
      return 'image';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoImageComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoImageComponent,
      selectors: [["dxo-image"]],
      inputs: {
        height: "height",
        url: "url",
        width: "width",
        location: "location"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoImageComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoImageModule = /*#__PURE__*/(() => {
  class DxoImageModule {
    /** @nocollapse */static ɵfac = function DxoImageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoImageModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoImageModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoImageComponent]
    });
  }
  return DxoImageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoIndentComponent = /*#__PURE__*/(() => {
  class DxoIndentComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get _optionPath() {
      return 'indent';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoIndentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoIndentComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoIndentComponent,
      selectors: [["dxo-indent"]],
      inputs: {
        left: "left",
        right: "right"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoIndentComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoIndentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoIndentModule = /*#__PURE__*/(() => {
  class DxoIndentModule {
    /** @nocollapse */static ɵfac = function DxoIndentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoIndentModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoIndentModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoIndentComponent]
    });
  }
  return DxoIndentModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSortableOptions = /*#__PURE__*/(() => {
  class DxoSortableOptions extends NestedOption {
    get allowDropInsideItem() {
      return this._getOption('allowDropInsideItem');
    }
    set allowDropInsideItem(value) {
      this._setOption('allowDropInsideItem', value);
    }
    get allowReordering() {
      return this._getOption('allowReordering');
    }
    set allowReordering(value) {
      this._setOption('allowReordering', value);
    }
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get cursorOffset() {
      return this._getOption('cursorOffset');
    }
    set cursorOffset(value) {
      this._setOption('cursorOffset', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get dragDirection() {
      return this._getOption('dragDirection');
    }
    set dragDirection(value) {
      this._setOption('dragDirection', value);
    }
    get dragTemplate() {
      return this._getOption('dragTemplate');
    }
    set dragTemplate(value) {
      this._setOption('dragTemplate', value);
    }
    get dropFeedbackMode() {
      return this._getOption('dropFeedbackMode');
    }
    set dropFeedbackMode(value) {
      this._setOption('dropFeedbackMode', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get filter() {
      return this._getOption('filter');
    }
    set filter(value) {
      this._setOption('filter', value);
    }
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    get handle() {
      return this._getOption('handle');
    }
    set handle(value) {
      this._setOption('handle', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get itemOrientation() {
      return this._getOption('itemOrientation');
    }
    set itemOrientation(value) {
      this._setOption('itemOrientation', value);
    }
    get moveItemOnDrop() {
      return this._getOption('moveItemOnDrop');
    }
    set moveItemOnDrop(value) {
      this._setOption('moveItemOnDrop', value);
    }
    get onAdd() {
      return this._getOption('onAdd');
    }
    set onAdd(value) {
      this._setOption('onAdd', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onDragChange() {
      return this._getOption('onDragChange');
    }
    set onDragChange(value) {
      this._setOption('onDragChange', value);
    }
    get onDragEnd() {
      return this._getOption('onDragEnd');
    }
    set onDragEnd(value) {
      this._setOption('onDragEnd', value);
    }
    get onDragMove() {
      return this._getOption('onDragMove');
    }
    set onDragMove(value) {
      this._setOption('onDragMove', value);
    }
    get onDragStart() {
      return this._getOption('onDragStart');
    }
    set onDragStart(value) {
      this._setOption('onDragStart', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onRemove() {
      return this._getOption('onRemove');
    }
    set onRemove(value) {
      this._setOption('onRemove', value);
    }
    get onReorder() {
      return this._getOption('onReorder');
    }
    set onReorder(value) {
      this._setOption('onReorder', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoSortableOptions_BaseFactory;
      return function DxoSortableOptions_Factory(__ngFactoryType__) {
        return (ɵDxoSortableOptions_BaseFactory || (ɵDxoSortableOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoSortableOptions)))(__ngFactoryType__ || DxoSortableOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSortableOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSortableOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSortableOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoItemDraggingComponent = /*#__PURE__*/(() => {
  class DxoItemDraggingComponent extends DxoSortableOptions {
    get _optionPath() {
      return 'itemDragging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoItemDraggingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemDraggingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoItemDraggingComponent,
      selectors: [["dxo-item-dragging"]],
      inputs: {
        allowDropInsideItem: "allowDropInsideItem",
        allowReordering: "allowReordering",
        autoScroll: "autoScroll",
        boundary: "boundary",
        container: "container",
        cursorOffset: "cursorOffset",
        data: "data",
        dragDirection: "dragDirection",
        dragTemplate: "dragTemplate",
        dropFeedbackMode: "dropFeedbackMode",
        elementAttr: "elementAttr",
        filter: "filter",
        group: "group",
        handle: "handle",
        height: "height",
        itemOrientation: "itemOrientation",
        moveItemOnDrop: "moveItemOnDrop",
        onAdd: "onAdd",
        onDisposing: "onDisposing",
        onDragChange: "onDragChange",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onRemove: "onRemove",
        onReorder: "onReorder",
        rtlEnabled: "rtlEnabled",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoItemDraggingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoItemDraggingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoItemDraggingModule = /*#__PURE__*/(() => {
  class DxoItemDraggingModule {
    /** @nocollapse */static ɵfac = function DxoItemDraggingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemDraggingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoItemDraggingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoItemDraggingComponent]
    });
  }
  return DxoItemDraggingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiButtonGroupItem = /*#__PURE__*/(() => {
  class DxiButtonGroupItem extends CollectionNestedOption {
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get baseSize() {
      return this._getOption('baseSize');
    }
    set baseSize(value) {
      this._setOption('baseSize', value);
    }
    get box() {
      return this._getOption('box');
    }
    set box(value) {
      this._setOption('box', value);
    }
    get ratio() {
      return this._getOption('ratio');
    }
    set ratio(value) {
      this._setOption('ratio', value);
    }
    get shrink() {
      return this._getOption('shrink');
    }
    set shrink(value) {
      this._setOption('shrink', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get alt() {
      return this._getOption('alt');
    }
    set alt(value) {
      this._setOption('alt', value);
    }
    get author() {
      return this._getOption('author');
    }
    set author(value) {
      this._setOption('author', value);
    }
    get id() {
      return this._getOption('id');
    }
    set id(value) {
      this._setOption('id', value);
    }
    get isDeleted() {
      return this._getOption('isDeleted');
    }
    set isDeleted(value) {
      this._setOption('isDeleted', value);
    }
    get isEdited() {
      return this._getOption('isEdited');
    }
    set isEdited(value) {
      this._setOption('isEdited', value);
    }
    get src() {
      return this._getOption('src');
    }
    set src(value) {
      this._setOption('src', value);
    }
    get timestamp() {
      return this._getOption('timestamp');
    }
    set timestamp(value) {
      this._setOption('timestamp', value);
    }
    get beginGroup() {
      return this._getOption('beginGroup');
    }
    set beginGroup(value) {
      this._setOption('beginGroup', value);
    }
    get closeMenuOnClick() {
      return this._getOption('closeMenuOnClick');
    }
    set closeMenuOnClick(value) {
      this._setOption('closeMenuOnClick', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get selectable() {
      return this._getOption('selectable');
    }
    set selectable(value) {
      this._setOption('selectable', value);
    }
    get selected() {
      return this._getOption('selected');
    }
    set selected(value) {
      this._setOption('selected', value);
    }
    get colSpan() {
      return this._getOption('colSpan');
    }
    set colSpan(value) {
      this._setOption('colSpan', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get editorType() {
      return this._getOption('editorType');
    }
    set editorType(value) {
      this._setOption('editorType', value);
    }
    get helpText() {
      return this._getOption('helpText');
    }
    set helpText(value) {
      this._setOption('helpText', value);
    }
    get isRequired() {
      return this._getOption('isRequired');
    }
    set isRequired(value) {
      this._setOption('isRequired', value);
    }
    get itemType() {
      return this._getOption('itemType');
    }
    set itemType(value) {
      this._setOption('itemType', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get validationRules() {
      return this._getOption('validationRules');
    }
    set validationRules(value) {
      this._setOption('validationRules', value);
    }
    get visibleIndex() {
      return this._getOption('visibleIndex');
    }
    set visibleIndex(value) {
      this._setOption('visibleIndex', value);
    }
    get alignItemLabels() {
      return this._getOption('alignItemLabels');
    }
    set alignItemLabels(value) {
      this._setOption('alignItemLabels', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get captionTemplate() {
      return this._getOption('captionTemplate');
    }
    set captionTemplate(value) {
      this._setOption('captionTemplate', value);
    }
    get colCount() {
      return this._getOption('colCount');
    }
    set colCount(value) {
      this._setOption('colCount', value);
    }
    get colCountByScreen() {
      return this._getOption('colCountByScreen');
    }
    set colCountByScreen(value) {
      this._setOption('colCountByScreen', value);
    }
    get tabPanelOptions() {
      return this._getOption('tabPanelOptions');
    }
    set tabPanelOptions(value) {
      this._setOption('tabPanelOptions', value);
    }
    get tabs() {
      return this._getOption('tabs');
    }
    set tabs(value) {
      this._setOption('tabs', value);
    }
    get badge() {
      return this._getOption('badge');
    }
    set badge(value) {
      this._setOption('badge', value);
    }
    get tabTemplate() {
      return this._getOption('tabTemplate');
    }
    set tabTemplate(value) {
      this._setOption('tabTemplate', value);
    }
    get buttonOptions() {
      return this._getOption('buttonOptions');
    }
    set buttonOptions(value) {
      this._setOption('buttonOptions', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get imageAlt() {
      return this._getOption('imageAlt');
    }
    set imageAlt(value) {
      this._setOption('imageAlt', value);
    }
    get imageSrc() {
      return this._getOption('imageSrc');
    }
    set imageSrc(value) {
      this._setOption('imageSrc', value);
    }
    get acceptedValues() {
      return this._getOption('acceptedValues');
    }
    set acceptedValues(value) {
      this._setOption('acceptedValues', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get key() {
      return this._getOption('key');
    }
    set key(value) {
      this._setOption('key', value);
    }
    get showChevron() {
      return this._getOption('showChevron');
    }
    set showChevron(value) {
      this._setOption('showChevron', value);
    }
    get linkAttr() {
      return this._getOption('linkAttr');
    }
    set linkAttr(value) {
      this._setOption('linkAttr', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get collapsed() {
      return this._getOption('collapsed');
    }
    set collapsed(value) {
      this._setOption('collapsed', value);
    }
    get collapsedSize() {
      return this._getOption('collapsedSize');
    }
    set collapsedSize(value) {
      this._setOption('collapsedSize', value);
    }
    get collapsible() {
      return this._getOption('collapsible');
    }
    set collapsible(value) {
      this._setOption('collapsible', value);
    }
    get maxSize() {
      return this._getOption('maxSize');
    }
    set maxSize(value) {
      this._setOption('maxSize', value);
    }
    get minSize() {
      return this._getOption('minSize');
    }
    set minSize(value) {
      this._setOption('minSize', value);
    }
    get resizable() {
      return this._getOption('resizable');
    }
    set resizable(value) {
      this._setOption('resizable', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get splitter() {
      return this._getOption('splitter');
    }
    set splitter(value) {
      this._setOption('splitter', value);
    }
    get heightRatio() {
      return this._getOption('heightRatio');
    }
    set heightRatio(value) {
      this._setOption('heightRatio', value);
    }
    get widthRatio() {
      return this._getOption('widthRatio');
    }
    set widthRatio(value) {
      this._setOption('widthRatio', value);
    }
    get expanded() {
      return this._getOption('expanded');
    }
    set expanded(value) {
      this._setOption('expanded', value);
    }
    get hasItems() {
      return this._getOption('hasItems');
    }
    set hasItems(value) {
      this._setOption('hasItems', value);
    }
    get parentId() {
      return this._getOption('parentId');
    }
    set parentId(value) {
      this._setOption('parentId', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiButtonGroupItem_BaseFactory;
      return function DxiButtonGroupItem_Factory(__ngFactoryType__) {
        return (ɵDxiButtonGroupItem_BaseFactory || (ɵDxiButtonGroupItem_BaseFactory = i0.ɵɵgetInheritedFactory(DxiButtonGroupItem)))(__ngFactoryType__ || DxiButtonGroupItem);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiButtonGroupItem,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiButtonGroupItem_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiButtonGroupItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiItemComponent = /*#__PURE__*/(() => {
  class DxiItemComponent extends DxiButtonGroupItem {
    renderer;
    document;
    element;
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    set _validationRulesContentChildren(value) {
      this.setChildren('validationRules', value);
    }
    set _tabsContentChildren(value) {
      this.setChildren('tabs', value);
    }
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    set _locationContentChildren(value) {
      this.setChildren('location', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiItemComponent,
      selectors: [["dxi-item"]],
      contentQueries: function DxiItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_validationRules, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_tabs, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_location, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._validationRulesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._locationContentChildren = _t);
        }
      },
      inputs: {
        disabled: "disabled",
        html: "html",
        icon: "icon",
        template: "template",
        text: "text",
        title: "title",
        titleTemplate: "titleTemplate",
        visible: "visible",
        onClick: "onClick",
        stylingMode: "stylingMode",
        type: "type",
        baseSize: "baseSize",
        box: "box",
        ratio: "ratio",
        shrink: "shrink",
        elementAttr: "elementAttr",
        hint: "hint",
        alt: "alt",
        author: "author",
        id: "id",
        isDeleted: "isDeleted",
        isEdited: "isEdited",
        src: "src",
        timestamp: "timestamp",
        beginGroup: "beginGroup",
        closeMenuOnClick: "closeMenuOnClick",
        items: "items",
        selectable: "selectable",
        selected: "selected",
        colSpan: "colSpan",
        cssClass: "cssClass",
        dataField: "dataField",
        editorOptions: "editorOptions",
        editorType: "editorType",
        helpText: "helpText",
        isRequired: "isRequired",
        itemType: "itemType",
        label: "label",
        name: "name",
        validationRules: "validationRules",
        visibleIndex: "visibleIndex",
        alignItemLabels: "alignItemLabels",
        caption: "caption",
        captionTemplate: "captionTemplate",
        colCount: "colCount",
        colCountByScreen: "colCountByScreen",
        tabPanelOptions: "tabPanelOptions",
        tabs: "tabs",
        badge: "badge",
        tabTemplate: "tabTemplate",
        buttonOptions: "buttonOptions",
        horizontalAlignment: "horizontalAlignment",
        verticalAlignment: "verticalAlignment",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        widget: "widget",
        height: "height",
        width: "width",
        imageAlt: "imageAlt",
        imageSrc: "imageSrc",
        acceptedValues: "acceptedValues",
        commands: "commands",
        key: "key",
        showChevron: "showChevron",
        linkAttr: "linkAttr",
        url: "url",
        collapsed: "collapsed",
        collapsedSize: "collapsedSize",
        collapsible: "collapsible",
        maxSize: "maxSize",
        minSize: "minSize",
        resizable: "resizable",
        size: "size",
        splitter: "splitter",
        heightRatio: "heightRatio",
        widthRatio: "widthRatio",
        expanded: "expanded",
        hasItems: "hasItems",
        parentId: "parentId"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiItemModule = /*#__PURE__*/(() => {
  class DxiItemModule {
    /** @nocollapse */static ɵfac = function DxiItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiItemComponent]
    });
  }
  return DxiItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoItemTextFormatComponent = /*#__PURE__*/(() => {
  class DxoItemTextFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'itemTextFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoItemTextFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemTextFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoItemTextFormatComponent,
      selectors: [["dxo-item-text-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoItemTextFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoItemTextFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoItemTextFormatModule = /*#__PURE__*/(() => {
  class DxoItemTextFormatModule {
    /** @nocollapse */static ɵfac = function DxoItemTextFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemTextFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoItemTextFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoItemTextFormatComponent]
    });
  }
  return DxoItemTextFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoItemViewComponent = /*#__PURE__*/(() => {
  class DxoItemViewComponent extends NestedOption {
    get details() {
      return this._getOption('details');
    }
    set details(value) {
      this._setOption('details', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get showFolders() {
      return this._getOption('showFolders');
    }
    set showFolders(value) {
      this._setOption('showFolders', value);
    }
    get showParentFolder() {
      return this._getOption('showParentFolder');
    }
    set showParentFolder(value) {
      this._setOption('showParentFolder', value);
    }
    get _optionPath() {
      return 'itemView';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoItemViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemViewComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoItemViewComponent,
      selectors: [["dxo-item-view"]],
      inputs: {
        details: "details",
        mode: "mode",
        showFolders: "showFolders",
        showParentFolder: "showParentFolder"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoItemViewComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoItemViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoItemViewModule = /*#__PURE__*/(() => {
  class DxoItemViewModule {
    /** @nocollapse */static ɵfac = function DxoItemViewModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemViewModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoItemViewModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoItemViewComponent]
    });
  }
  return DxoItemViewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoItemComponent = /*#__PURE__*/(() => {
  class DxoItemComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get _optionPath() {
      return 'item';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoItemComponent,
      selectors: [["dxo-item"]],
      inputs: {
        border: "border",
        hoverStyle: "hoverStyle",
        selectionStyle: "selectionStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoItemModule = /*#__PURE__*/(() => {
  class DxoItemModule {
    /** @nocollapse */static ɵfac = function DxoItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoItemComponent]
    });
  }
  return DxoItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoKeyboardNavigationComponent = /*#__PURE__*/(() => {
  class DxoKeyboardNavigationComponent extends NestedOption {
    get editOnKeyPress() {
      return this._getOption('editOnKeyPress');
    }
    set editOnKeyPress(value) {
      this._setOption('editOnKeyPress', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get enterKeyAction() {
      return this._getOption('enterKeyAction');
    }
    set enterKeyAction(value) {
      this._setOption('enterKeyAction', value);
    }
    get enterKeyDirection() {
      return this._getOption('enterKeyDirection');
    }
    set enterKeyDirection(value) {
      this._setOption('enterKeyDirection', value);
    }
    get _optionPath() {
      return 'keyboardNavigation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoKeyboardNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoKeyboardNavigationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoKeyboardNavigationComponent,
      selectors: [["dxo-keyboard-navigation"]],
      inputs: {
        editOnKeyPress: "editOnKeyPress",
        enabled: "enabled",
        enterKeyAction: "enterKeyAction",
        enterKeyDirection: "enterKeyDirection"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoKeyboardNavigationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoKeyboardNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoKeyboardNavigationModule = /*#__PURE__*/(() => {
  class DxoKeyboardNavigationModule {
    /** @nocollapse */static ɵfac = function DxoKeyboardNavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoKeyboardNavigationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoKeyboardNavigationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoKeyboardNavigationComponent]
    });
  }
  return DxoKeyboardNavigationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLabelComponent = /*#__PURE__*/(() => {
  class DxoLabelComponent extends NestedOption {
    renderer;
    document;
    element;
    get connectorColor() {
      return this._getOption('connectorColor');
    }
    set connectorColor(value) {
      this._setOption('connectorColor', value);
    }
    get connectorWidth() {
      return this._getOption('connectorWidth');
    }
    set connectorWidth(value) {
      this._setOption('connectorWidth', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indent() {
      return this._getOption('indent');
    }
    set indent(value) {
      this._setOption('indent', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get staggeringSpacing() {
      return this._getOption('staggeringSpacing');
    }
    set staggeringSpacing(value) {
      this._setOption('staggeringSpacing', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get connector() {
      return this._getOption('connector');
    }
    set connector(value) {
      this._setOption('connector', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get horizontalOffset() {
      return this._getOption('horizontalOffset');
    }
    set horizontalOffset(value) {
      this._setOption('horizontalOffset', value);
    }
    get showForZeroValues() {
      return this._getOption('showForZeroValues');
    }
    set showForZeroValues(value) {
      this._setOption('showForZeroValues', value);
    }
    get verticalOffset() {
      return this._getOption('verticalOffset');
    }
    set verticalOffset(value) {
      this._setOption('verticalOffset', value);
    }
    get hideFirstOrLast() {
      return this._getOption('hideFirstOrLast');
    }
    set hideFirstOrLast(value) {
      this._setOption('hideFirstOrLast', value);
    }
    get indentFromTick() {
      return this._getOption('indentFromTick');
    }
    set indentFromTick(value) {
      this._setOption('indentFromTick', value);
    }
    get useRangeColors() {
      return this._getOption('useRangeColors');
    }
    set useRangeColors(value) {
      this._setOption('useRangeColors', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get showColon() {
      return this._getOption('showColon');
    }
    set showColon(value) {
      this._setOption('showColon', value);
    }
    get radialOffset() {
      return this._getOption('radialOffset');
    }
    set radialOffset(value) {
      this._setOption('radialOffset', value);
    }
    get topIndent() {
      return this._getOption('topIndent');
    }
    set topIndent(value) {
      this._setOption('topIndent', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get useNodeColors() {
      return this._getOption('useNodeColors');
    }
    set useNodeColors(value) {
      this._setOption('useNodeColors', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLabelComponent,
      selectors: [["dxo-label"]],
      inputs: {
        connectorColor: "connectorColor",
        connectorWidth: "connectorWidth",
        customizeText: "customizeText",
        font: "font",
        format: "format",
        indent: "indent",
        visible: "visible",
        horizontalAlignment: "horizontalAlignment",
        position: "position",
        text: "text",
        verticalAlignment: "verticalAlignment",
        alignment: "alignment",
        customizeHint: "customizeHint",
        displayMode: "displayMode",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        rotationAngle: "rotationAngle",
        staggeringSpacing: "staggeringSpacing",
        template: "template",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap",
        argumentFormat: "argumentFormat",
        backgroundColor: "backgroundColor",
        border: "border",
        connector: "connector",
        displayFormat: "displayFormat",
        horizontalOffset: "horizontalOffset",
        showForZeroValues: "showForZeroValues",
        verticalOffset: "verticalOffset",
        hideFirstOrLast: "hideFirstOrLast",
        indentFromTick: "indentFromTick",
        useRangeColors: "useRangeColors",
        location: "location",
        showColon: "showColon",
        radialOffset: "radialOffset",
        topIndent: "topIndent",
        shadow: "shadow",
        useNodeColors: "useNodeColors",
        dataField: "dataField",
        enabled: "enabled"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLabelModule = /*#__PURE__*/(() => {
  class DxoLabelModule {
    /** @nocollapse */static ɵfac = function DxoLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLabelComponent]
    });
  }
  return DxoLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiLayerComponent = /*#__PURE__*/(() => {
  class DxiLayerComponent extends CollectionNestedOption {
    get borderColor() {
      return this._getOption('borderColor');
    }
    set borderColor(value) {
      this._setOption('borderColor', value);
    }
    get borderWidth() {
      return this._getOption('borderWidth');
    }
    set borderWidth(value) {
      this._setOption('borderWidth', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get colorGroupingField() {
      return this._getOption('colorGroupingField');
    }
    set colorGroupingField(value) {
      this._setOption('colorGroupingField', value);
    }
    get colorGroups() {
      return this._getOption('colorGroups');
    }
    set colorGroups(value) {
      this._setOption('colorGroups', value);
    }
    get customize() {
      return this._getOption('customize');
    }
    set customize(value) {
      this._setOption('customize', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get elementType() {
      return this._getOption('elementType');
    }
    set elementType(value) {
      this._setOption('elementType', value);
    }
    get hoveredBorderColor() {
      return this._getOption('hoveredBorderColor');
    }
    set hoveredBorderColor(value) {
      this._setOption('hoveredBorderColor', value);
    }
    get hoveredBorderWidth() {
      return this._getOption('hoveredBorderWidth');
    }
    set hoveredBorderWidth(value) {
      this._setOption('hoveredBorderWidth', value);
    }
    get hoveredColor() {
      return this._getOption('hoveredColor');
    }
    set hoveredColor(value) {
      this._setOption('hoveredColor', value);
    }
    get hoverEnabled() {
      return this._getOption('hoverEnabled');
    }
    set hoverEnabled(value) {
      this._setOption('hoverEnabled', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get maxSize() {
      return this._getOption('maxSize');
    }
    set maxSize(value) {
      this._setOption('maxSize', value);
    }
    get minSize() {
      return this._getOption('minSize');
    }
    set minSize(value) {
      this._setOption('minSize', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get paletteIndex() {
      return this._getOption('paletteIndex');
    }
    set paletteIndex(value) {
      this._setOption('paletteIndex', value);
    }
    get paletteSize() {
      return this._getOption('paletteSize');
    }
    set paletteSize(value) {
      this._setOption('paletteSize', value);
    }
    get selectedBorderColor() {
      return this._getOption('selectedBorderColor');
    }
    set selectedBorderColor(value) {
      this._setOption('selectedBorderColor', value);
    }
    get selectedBorderWidth() {
      return this._getOption('selectedBorderWidth');
    }
    set selectedBorderWidth(value) {
      this._setOption('selectedBorderWidth', value);
    }
    get selectedColor() {
      return this._getOption('selectedColor');
    }
    set selectedColor(value) {
      this._setOption('selectedColor', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get sizeGroupingField() {
      return this._getOption('sizeGroupingField');
    }
    set sizeGroupingField(value) {
      this._setOption('sizeGroupingField', value);
    }
    get sizeGroups() {
      return this._getOption('sizeGroups');
    }
    set sizeGroups(value) {
      this._setOption('sizeGroups', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'layers';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiLayerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLayerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiLayerComponent,
      selectors: [["dxi-layer"]],
      inputs: {
        borderColor: "borderColor",
        borderWidth: "borderWidth",
        color: "color",
        colorGroupingField: "colorGroupingField",
        colorGroups: "colorGroups",
        customize: "customize",
        dataField: "dataField",
        dataSource: "dataSource",
        elementType: "elementType",
        hoveredBorderColor: "hoveredBorderColor",
        hoveredBorderWidth: "hoveredBorderWidth",
        hoveredColor: "hoveredColor",
        hoverEnabled: "hoverEnabled",
        label: "label",
        maxSize: "maxSize",
        minSize: "minSize",
        name: "name",
        opacity: "opacity",
        palette: "palette",
        paletteIndex: "paletteIndex",
        paletteSize: "paletteSize",
        selectedBorderColor: "selectedBorderColor",
        selectedBorderWidth: "selectedBorderWidth",
        selectedColor: "selectedColor",
        selectionMode: "selectionMode",
        size: "size",
        sizeGroupingField: "sizeGroupingField",
        sizeGroups: "sizeGroups",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_layers,
        useExisting: DxiLayerComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiLayerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiLayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiLayerModule = /*#__PURE__*/(() => {
  class DxiLayerModule {
    /** @nocollapse */static ɵfac = function DxiLayerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLayerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiLayerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiLayerComponent]
    });
  }
  return DxiLayerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiLegendComponent = /*#__PURE__*/(() => {
  class DxiLegendComponent extends CollectionNestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get columnCount() {
      return this._getOption('columnCount');
    }
    set columnCount(value) {
      this._setOption('columnCount', value);
    }
    get columnItemSpacing() {
      return this._getOption('columnItemSpacing');
    }
    set columnItemSpacing(value) {
      this._setOption('columnItemSpacing', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeItems() {
      return this._getOption('customizeItems');
    }
    set customizeItems(value) {
      this._setOption('customizeItems', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get itemsAlignment() {
      return this._getOption('itemsAlignment');
    }
    set itemsAlignment(value) {
      this._setOption('itemsAlignment', value);
    }
    get itemTextPosition() {
      return this._getOption('itemTextPosition');
    }
    set itemTextPosition(value) {
      this._setOption('itemTextPosition', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get markerColor() {
      return this._getOption('markerColor');
    }
    set markerColor(value) {
      this._setOption('markerColor', value);
    }
    get markerShape() {
      return this._getOption('markerShape');
    }
    set markerShape(value) {
      this._setOption('markerShape', value);
    }
    get markerSize() {
      return this._getOption('markerSize');
    }
    set markerSize(value) {
      this._setOption('markerSize', value);
    }
    get markerTemplate() {
      return this._getOption('markerTemplate');
    }
    set markerTemplate(value) {
      this._setOption('markerTemplate', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get rowCount() {
      return this._getOption('rowCount');
    }
    set rowCount(value) {
      this._setOption('rowCount', value);
    }
    get rowItemSpacing() {
      return this._getOption('rowItemSpacing');
    }
    set rowItemSpacing(value) {
      this._setOption('rowItemSpacing', value);
    }
    get source() {
      return this._getOption('source');
    }
    set source(value) {
      this._setOption('source', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'legends';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiLegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLegendComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiLegendComponent,
      selectors: [["dxi-legend"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        columnCount: "columnCount",
        columnItemSpacing: "columnItemSpacing",
        customizeHint: "customizeHint",
        customizeItems: "customizeItems",
        customizeText: "customizeText",
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        itemsAlignment: "itemsAlignment",
        itemTextPosition: "itemTextPosition",
        margin: "margin",
        markerColor: "markerColor",
        markerShape: "markerShape",
        markerSize: "markerSize",
        markerTemplate: "markerTemplate",
        orientation: "orientation",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        rowCount: "rowCount",
        rowItemSpacing: "rowItemSpacing",
        source: "source",
        title: "title",
        verticalAlignment: "verticalAlignment",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_legends,
        useExisting: DxiLegendComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiLegendComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiLegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiLegendModule = /*#__PURE__*/(() => {
  class DxiLegendModule {
    /** @nocollapse */static ɵfac = function DxiLegendModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLegendModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiLegendModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiLegendComponent]
    });
  }
  return DxiLegendModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLegendComponent = /*#__PURE__*/(() => {
  class DxoLegendComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get columnCount() {
      return this._getOption('columnCount');
    }
    set columnCount(value) {
      this._setOption('columnCount', value);
    }
    get columnItemSpacing() {
      return this._getOption('columnItemSpacing');
    }
    set columnItemSpacing(value) {
      this._setOption('columnItemSpacing', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeItems() {
      return this._getOption('customizeItems');
    }
    set customizeItems(value) {
      this._setOption('customizeItems', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get itemsAlignment() {
      return this._getOption('itemsAlignment');
    }
    set itemsAlignment(value) {
      this._setOption('itemsAlignment', value);
    }
    get itemTextFormat() {
      return this._getOption('itemTextFormat');
    }
    set itemTextFormat(value) {
      this._setOption('itemTextFormat', value);
    }
    get itemTextPosition() {
      return this._getOption('itemTextPosition');
    }
    set itemTextPosition(value) {
      this._setOption('itemTextPosition', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get markerSize() {
      return this._getOption('markerSize');
    }
    set markerSize(value) {
      this._setOption('markerSize', value);
    }
    get markerTemplate() {
      return this._getOption('markerTemplate');
    }
    set markerTemplate(value) {
      this._setOption('markerTemplate', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get rowCount() {
      return this._getOption('rowCount');
    }
    set rowCount(value) {
      this._setOption('rowCount', value);
    }
    get rowItemSpacing() {
      return this._getOption('rowItemSpacing');
    }
    set rowItemSpacing(value) {
      this._setOption('rowItemSpacing', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get _optionPath() {
      return 'legend';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLegendComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLegendComponent,
      selectors: [["dxo-legend"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        columnCount: "columnCount",
        columnItemSpacing: "columnItemSpacing",
        customizeHint: "customizeHint",
        customizeItems: "customizeItems",
        customizeText: "customizeText",
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        itemsAlignment: "itemsAlignment",
        itemTextFormat: "itemTextFormat",
        itemTextPosition: "itemTextPosition",
        margin: "margin",
        markerSize: "markerSize",
        markerTemplate: "markerTemplate",
        orientation: "orientation",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        rowCount: "rowCount",
        rowItemSpacing: "rowItemSpacing",
        title: "title",
        verticalAlignment: "verticalAlignment",
        visible: "visible",
        hoverMode: "hoverMode",
        position: "position"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLegendComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoLegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLegendModule = /*#__PURE__*/(() => {
  class DxoLegendModule {
    /** @nocollapse */static ɵfac = function DxoLegendModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLegendModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLegendModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLegendComponent]
    });
  }
  return DxoLegendModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoLineComponent = /*#__PURE__*/(() => {
  class DxoLineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'line';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLineComponent,
      selectors: [["dxo-line"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLineModule = /*#__PURE__*/(() => {
  class DxoLineModule {
    /** @nocollapse */static ɵfac = function DxoLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLineComponent]
    });
  }
  return DxoLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinkComponent = /*#__PURE__*/(() => {
  class DxoLinkComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get colorMode() {
      return this._getOption('colorMode');
    }
    set colorMode(value) {
      this._setOption('colorMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'link';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinkComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinkComponent,
      selectors: [["dxo-link"]],
      inputs: {
        border: "border",
        color: "color",
        colorMode: "colorMode",
        hoverStyle: "hoverStyle",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinkComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinkModule = /*#__PURE__*/(() => {
  class DxoLinkModule {
    /** @nocollapse */static ɵfac = function DxoLinkModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinkModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinkModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLinkComponent]
    });
  }
  return DxoLinkModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadPanelComponent = /*#__PURE__*/(() => {
  class DxoLoadPanelComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get indicatorSrc() {
      return this._getOption('indicatorSrc');
    }
    set indicatorSrc(value) {
      this._setOption('indicatorSrc', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showIndicator() {
      return this._getOption('showIndicator');
    }
    set showIndicator(value) {
      this._setOption('showIndicator', value);
    }
    get showPane() {
      return this._getOption('showPane');
    }
    set showPane(value) {
      this._setOption('showPane', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'loadPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadPanelComponent,
      selectors: [["dxo-load-panel"]],
      inputs: {
        enabled: "enabled",
        height: "height",
        indicatorSrc: "indicatorSrc",
        shading: "shading",
        shadingColor: "shadingColor",
        showIndicator: "showIndicator",
        showPane: "showPane",
        text: "text",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoLoadPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadPanelModule = /*#__PURE__*/(() => {
  class DxoLoadPanelModule {
    /** @nocollapse */static ɵfac = function DxoLoadPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLoadPanelComponent]
    });
  }
  return DxoLoadPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class DxoLoadingIndicatorComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showChange;
    get _optionPath() {
      return 'loadingIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'showChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLoadingIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLoadingIndicatorComponent,
      selectors: [["dxo-loading-indicator"]],
      inputs: {
        backgroundColor: "backgroundColor",
        font: "font",
        show: "show",
        text: "text",
        enabled: "enabled"
      },
      outputs: {
        showChange: "showChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLoadingIndicatorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLoadingIndicatorModule = /*#__PURE__*/(() => {
  class DxoLoadingIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoLoadingIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLoadingIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLoadingIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLoadingIndicatorComponent]
    });
  }
  return DxoLoadingIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiLocationComponent = /*#__PURE__*/(() => {
  class DxiLocationComponent extends CollectionNestedOption {
    get lat() {
      return this._getOption('lat');
    }
    set lat(value) {
      this._setOption('lat', value);
    }
    get lng() {
      return this._getOption('lng');
    }
    set lng(value) {
      this._setOption('lng', value);
    }
    get col() {
      return this._getOption('col');
    }
    set col(value) {
      this._setOption('col', value);
    }
    get colspan() {
      return this._getOption('colspan');
    }
    set colspan(value) {
      this._setOption('colspan', value);
    }
    get row() {
      return this._getOption('row');
    }
    set row(value) {
      this._setOption('row', value);
    }
    get rowspan() {
      return this._getOption('rowspan');
    }
    set rowspan(value) {
      this._setOption('rowspan', value);
    }
    get screen() {
      return this._getOption('screen');
    }
    set screen(value) {
      this._setOption('screen', value);
    }
    get _optionPath() {
      return 'location';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiLocationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLocationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiLocationComponent,
      selectors: [["dxi-location"]],
      inputs: {
        lat: "lat",
        lng: "lng",
        col: "col",
        colspan: "colspan",
        row: "row",
        rowspan: "rowspan",
        screen: "screen"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_location,
        useExisting: DxiLocationComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiLocationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiLocationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiLocationModule = /*#__PURE__*/(() => {
  class DxiLocationModule {
    /** @nocollapse */static ɵfac = function DxiLocationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLocationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiLocationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiLocationComponent]
    });
  }
  return DxiLocationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLookupComponent = /*#__PURE__*/(() => {
  class DxoLookupComponent extends NestedOption {
    get allowClearing() {
      return this._getOption('allowClearing');
    }
    set allowClearing(value) {
      this._setOption('allowClearing', value);
    }
    get calculateCellValue() {
      return this._getOption('calculateCellValue');
    }
    set calculateCellValue(value) {
      this._setOption('calculateCellValue', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'lookup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLookupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLookupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLookupComponent,
      selectors: [["dxo-lookup"]],
      inputs: {
        allowClearing: "allowClearing",
        calculateCellValue: "calculateCellValue",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLookupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoLookupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLookupModule = /*#__PURE__*/(() => {
  class DxoLookupModule {
    /** @nocollapse */static ɵfac = function DxoLookupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLookupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLookupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoLookupComponent]
    });
  }
  return DxoLookupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMainToolbarComponent = /*#__PURE__*/(() => {
  class DxoMainToolbarComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'mainToolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMainToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMainToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMainToolbarComponent,
      selectors: [["dxo-main-toolbar"]],
      contentQueries: function DxoMainToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMainToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMainToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMainToolbarModule = /*#__PURE__*/(() => {
  class DxoMainToolbarModule {
    /** @nocollapse */static ɵfac = function DxoMainToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMainToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMainToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMainToolbarComponent]
    });
  }
  return DxoMainToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMarginComponent = /*#__PURE__*/(() => {
  class DxoMarginComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'margin';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMarginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMarginComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMarginComponent,
      selectors: [["dxo-margin"]],
      inputs: {
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMarginComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMarginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMarginModule = /*#__PURE__*/(() => {
  class DxoMarginModule {
    /** @nocollapse */static ɵfac = function DxoMarginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMarginModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMarginModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMarginComponent]
    });
  }
  return DxoMarginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiMarkerComponent = /*#__PURE__*/(() => {
  class DxiMarkerComponent extends CollectionNestedOption {
    set _locationContentChildren(value) {
      this.setChildren('location', value);
    }
    get iconSrc() {
      return this._getOption('iconSrc');
    }
    set iconSrc(value) {
      this._setOption('iconSrc', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get tooltip() {
      return this._getOption('tooltip');
    }
    set tooltip(value) {
      this._setOption('tooltip', value);
    }
    get _optionPath() {
      return 'markers';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiMarkerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiMarkerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiMarkerComponent,
      selectors: [["dxi-marker"]],
      contentQueries: function DxiMarkerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_location, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._locationContentChildren = _t);
        }
      },
      inputs: {
        iconSrc: "iconSrc",
        location: "location",
        onClick: "onClick",
        tooltip: "tooltip"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_markers,
        useExisting: DxiMarkerComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiMarkerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiMarkerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiMarkerModule = /*#__PURE__*/(() => {
  class DxiMarkerModule {
    /** @nocollapse */static ɵfac = function DxiMarkerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiMarkerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiMarkerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiMarkerComponent]
    });
  }
  return DxiMarkerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMarkerComponent = /*#__PURE__*/(() => {
  class DxoMarkerComponent extends NestedOption {
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get separatorHeight() {
      return this._getOption('separatorHeight');
    }
    set separatorHeight(value) {
      this._setOption('separatorHeight', value);
    }
    get textLeftIndent() {
      return this._getOption('textLeftIndent');
    }
    set textLeftIndent(value) {
      this._setOption('textLeftIndent', value);
    }
    get textTopIndent() {
      return this._getOption('textTopIndent');
    }
    set textTopIndent(value) {
      this._setOption('textTopIndent', value);
    }
    get topIndent() {
      return this._getOption('topIndent');
    }
    set topIndent(value) {
      this._setOption('topIndent', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'marker';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMarkerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMarkerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMarkerComponent,
      selectors: [["dxo-marker"]],
      inputs: {
        label: "label",
        separatorHeight: "separatorHeight",
        textLeftIndent: "textLeftIndent",
        textTopIndent: "textTopIndent",
        topIndent: "topIndent",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMarkerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMarkerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMarkerModule = /*#__PURE__*/(() => {
  class DxoMarkerModule {
    /** @nocollapse */static ɵfac = function DxoMarkerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMarkerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMarkerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMarkerComponent]
    });
  }
  return DxoMarkerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMasterDetailComponent = /*#__PURE__*/(() => {
  class DxoMasterDetailComponent extends NestedOption {
    renderer;
    document;
    element;
    get autoExpandAll() {
      return this._getOption('autoExpandAll');
    }
    set autoExpandAll(value) {
      this._setOption('autoExpandAll', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get _optionPath() {
      return 'masterDetail';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMasterDetailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMasterDetailComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMasterDetailComponent,
      selectors: [["dxo-master-detail"]],
      inputs: {
        autoExpandAll: "autoExpandAll",
        enabled: "enabled",
        template: "template"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoMasterDetailComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoMasterDetailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMasterDetailModule = /*#__PURE__*/(() => {
  class DxoMasterDetailModule {
    /** @nocollapse */static ɵfac = function DxoMasterDetailModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMasterDetailModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMasterDetailModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMasterDetailComponent]
    });
  }
  return DxoMasterDetailModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMaxRangeComponent = /*#__PURE__*/(() => {
  class DxoMaxRangeComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'maxRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMaxRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMaxRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMaxRangeComponent,
      selectors: [["dxo-max-range"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMaxRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMaxRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMaxRangeModule = /*#__PURE__*/(() => {
  class DxoMaxRangeModule {
    /** @nocollapse */static ɵfac = function DxoMaxRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMaxRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMaxRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMaxRangeComponent]
    });
  }
  return DxoMaxRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorMediaResizing = /*#__PURE__*/(() => {
  class DxoHtmlEditorMediaResizing extends NestedOption {
    get allowedTargets() {
      return this._getOption('allowedTargets');
    }
    set allowedTargets(value) {
      this._setOption('allowedTargets', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoHtmlEditorMediaResizing_BaseFactory;
      return function DxoHtmlEditorMediaResizing_Factory(__ngFactoryType__) {
        return (ɵDxoHtmlEditorMediaResizing_BaseFactory || (ɵDxoHtmlEditorMediaResizing_BaseFactory = i0.ɵɵgetInheritedFactory(DxoHtmlEditorMediaResizing)))(__ngFactoryType__ || DxoHtmlEditorMediaResizing);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorMediaResizing,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorMediaResizing_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorMediaResizing;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoMediaResizingComponent = /*#__PURE__*/(() => {
  class DxoMediaResizingComponent extends DxoHtmlEditorMediaResizing {
    get _optionPath() {
      return 'mediaResizing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMediaResizingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMediaResizingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMediaResizingComponent,
      selectors: [["dxo-media-resizing"]],
      inputs: {
        allowedTargets: "allowedTargets",
        enabled: "enabled"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMediaResizingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMediaResizingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMediaResizingModule = /*#__PURE__*/(() => {
  class DxoMediaResizingModule {
    /** @nocollapse */static ɵfac = function DxoMediaResizingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMediaResizingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMediaResizingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMediaResizingComponent]
    });
  }
  return DxoMediaResizingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorMention = /*#__PURE__*/(() => {
  class DxiHtmlEditorMention extends CollectionNestedOption {
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get itemTemplate() {
      return this._getOption('itemTemplate');
    }
    set itemTemplate(value) {
      this._setOption('itemTemplate', value);
    }
    get marker() {
      return this._getOption('marker');
    }
    set marker(value) {
      this._setOption('marker', value);
    }
    get minSearchLength() {
      return this._getOption('minSearchLength');
    }
    set minSearchLength(value) {
      this._setOption('minSearchLength', value);
    }
    get searchExpr() {
      return this._getOption('searchExpr');
    }
    set searchExpr(value) {
      this._setOption('searchExpr', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiHtmlEditorMention_BaseFactory;
      return function DxiHtmlEditorMention_Factory(__ngFactoryType__) {
        return (ɵDxiHtmlEditorMention_BaseFactory || (ɵDxiHtmlEditorMention_BaseFactory = i0.ɵɵgetInheritedFactory(DxiHtmlEditorMention)))(__ngFactoryType__ || DxiHtmlEditorMention);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorMention,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiHtmlEditorMention_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiHtmlEditorMention;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiMentionComponent = /*#__PURE__*/(() => {
  class DxiMentionComponent extends DxiHtmlEditorMention {
    get _optionPath() {
      return 'mentions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiMentionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiMentionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiMentionComponent,
      selectors: [["dxi-mention"]],
      inputs: {
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        itemTemplate: "itemTemplate",
        marker: "marker",
        minSearchLength: "minSearchLength",
        searchExpr: "searchExpr",
        searchTimeout: "searchTimeout",
        template: "template",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_mentions,
        useExisting: DxiMentionComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiMentionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiMentionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiMentionModule = /*#__PURE__*/(() => {
  class DxiMentionModule {
    /** @nocollapse */static ɵfac = function DxiMentionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiMentionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiMentionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiMentionComponent]
    });
  }
  return DxiMentionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiMenuItemComponent = /*#__PURE__*/(() => {
  class DxiMenuItemComponent extends CollectionNestedOption {
    get action() {
      return this._getOption('action');
    }
    set action(value) {
      this._setOption('action', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'menuItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiMenuItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiMenuItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiMenuItemComponent,
      selectors: [["dxi-menu-item"]],
      inputs: {
        action: "action",
        text: "text"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_menuItems,
        useExisting: DxiMenuItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiMenuItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiMenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiMenuItemModule = /*#__PURE__*/(() => {
  class DxiMenuItemModule {
    /** @nocollapse */static ɵfac = function DxiMenuItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiMenuItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiMenuItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiMenuItemComponent]
    });
  }
  return DxiMenuItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoMessageTimestampFormatComponent = /*#__PURE__*/(() => {
  class DxoMessageTimestampFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'messageTimestampFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMessageTimestampFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMessageTimestampFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMessageTimestampFormatComponent,
      selectors: [["dxo-message-timestamp-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMessageTimestampFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMessageTimestampFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMessageTimestampFormatModule = /*#__PURE__*/(() => {
  class DxoMessageTimestampFormatModule {
    /** @nocollapse */static ɵfac = function DxoMessageTimestampFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMessageTimestampFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMessageTimestampFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMessageTimestampFormatComponent]
    });
  }
  return DxoMessageTimestampFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMinRangeComponent = /*#__PURE__*/(() => {
  class DxoMinRangeComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMinRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMinRangeComponent,
      selectors: [["dxo-min-range"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMinRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMinRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMinRangeModule = /*#__PURE__*/(() => {
  class DxoMinRangeModule {
    /** @nocollapse */static ɵfac = function DxoMinRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMinRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMinRangeComponent]
    });
  }
  return DxoMinRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMinVisualRangeLengthComponent = /*#__PURE__*/(() => {
  class DxoMinVisualRangeLengthComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minVisualRangeLength';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMinVisualRangeLengthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinVisualRangeLengthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMinVisualRangeLengthComponent,
      selectors: [["dxo-min-visual-range-length"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMinVisualRangeLengthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMinVisualRangeLengthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMinVisualRangeLengthModule = /*#__PURE__*/(() => {
  class DxoMinVisualRangeLengthModule {
    /** @nocollapse */static ɵfac = function DxoMinVisualRangeLengthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinVisualRangeLengthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMinVisualRangeLengthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMinVisualRangeLengthComponent]
    });
  }
  return DxoMinVisualRangeLengthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMinorGridComponent = /*#__PURE__*/(() => {
  class DxoMinorGridComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorGrid';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMinorGridComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinorGridComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMinorGridComponent,
      selectors: [["dxo-minor-grid"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMinorGridComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMinorGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMinorGridModule = /*#__PURE__*/(() => {
  class DxoMinorGridModule {
    /** @nocollapse */static ɵfac = function DxoMinorGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinorGridModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMinorGridModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMinorGridComponent]
    });
  }
  return DxoMinorGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMinorTickIntervalComponent = /*#__PURE__*/(() => {
  class DxoMinorTickIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minorTickInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMinorTickIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinorTickIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMinorTickIntervalComponent,
      selectors: [["dxo-minor-tick-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMinorTickIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMinorTickIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMinorTickIntervalModule = /*#__PURE__*/(() => {
  class DxoMinorTickIntervalModule {
    /** @nocollapse */static ɵfac = function DxoMinorTickIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinorTickIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMinorTickIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMinorTickIntervalComponent]
    });
  }
  return DxoMinorTickIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMinorTickComponent = /*#__PURE__*/(() => {
  class DxoMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMinorTickComponent,
      selectors: [["dxo-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMinorTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMinorTickModule = /*#__PURE__*/(() => {
  class DxoMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMinorTickComponent]
    });
  }
  return DxoMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoMyComponent = /*#__PURE__*/(() => {
  class DxoMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoMyComponent,
      selectors: [["dxo-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoMyComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoMyModule = /*#__PURE__*/(() => {
  class DxoMyModule {
    /** @nocollapse */static ɵfac = function DxoMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoMyComponent]
    });
  }
  return DxoMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoNodeComponent = /*#__PURE__*/(() => {
  class DxoNodeComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get padding() {
      return this._getOption('padding');
    }
    set padding(value) {
      this._setOption('padding', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'node';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoNodeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoNodeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoNodeComponent,
      selectors: [["dxo-node"]],
      inputs: {
        border: "border",
        color: "color",
        hoverStyle: "hoverStyle",
        opacity: "opacity",
        padding: "padding",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoNodeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoNodeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoNodeModule = /*#__PURE__*/(() => {
  class DxoNodeModule {
    /** @nocollapse */static ɵfac = function DxoNodeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoNodeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoNodeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoNodeComponent]
    });
  }
  return DxoNodeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoNodesComponent = /*#__PURE__*/(() => {
  class DxoNodesComponent extends NestedOption {
    get autoLayout() {
      return this._getOption('autoLayout');
    }
    set autoLayout(value) {
      this._setOption('autoLayout', value);
    }
    get autoSizeEnabled() {
      return this._getOption('autoSizeEnabled');
    }
    set autoSizeEnabled(value) {
      this._setOption('autoSizeEnabled', value);
    }
    get containerChildrenExpr() {
      return this._getOption('containerChildrenExpr');
    }
    set containerChildrenExpr(value) {
      this._setOption('containerChildrenExpr', value);
    }
    get containerKeyExpr() {
      return this._getOption('containerKeyExpr');
    }
    set containerKeyExpr(value) {
      this._setOption('containerKeyExpr', value);
    }
    get customDataExpr() {
      return this._getOption('customDataExpr');
    }
    set customDataExpr(value) {
      this._setOption('customDataExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get heightExpr() {
      return this._getOption('heightExpr');
    }
    set heightExpr(value) {
      this._setOption('heightExpr', value);
    }
    get imageUrlExpr() {
      return this._getOption('imageUrlExpr');
    }
    set imageUrlExpr(value) {
      this._setOption('imageUrlExpr', value);
    }
    get itemsExpr() {
      return this._getOption('itemsExpr');
    }
    set itemsExpr(value) {
      this._setOption('itemsExpr', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get leftExpr() {
      return this._getOption('leftExpr');
    }
    set leftExpr(value) {
      this._setOption('leftExpr', value);
    }
    get lockedExpr() {
      return this._getOption('lockedExpr');
    }
    set lockedExpr(value) {
      this._setOption('lockedExpr', value);
    }
    get parentKeyExpr() {
      return this._getOption('parentKeyExpr');
    }
    set parentKeyExpr(value) {
      this._setOption('parentKeyExpr', value);
    }
    get styleExpr() {
      return this._getOption('styleExpr');
    }
    set styleExpr(value) {
      this._setOption('styleExpr', value);
    }
    get textExpr() {
      return this._getOption('textExpr');
    }
    set textExpr(value) {
      this._setOption('textExpr', value);
    }
    get textStyleExpr() {
      return this._getOption('textStyleExpr');
    }
    set textStyleExpr(value) {
      this._setOption('textStyleExpr', value);
    }
    get topExpr() {
      return this._getOption('topExpr');
    }
    set topExpr(value) {
      this._setOption('topExpr', value);
    }
    get typeExpr() {
      return this._getOption('typeExpr');
    }
    set typeExpr(value) {
      this._setOption('typeExpr', value);
    }
    get widthExpr() {
      return this._getOption('widthExpr');
    }
    set widthExpr(value) {
      this._setOption('widthExpr', value);
    }
    get zIndexExpr() {
      return this._getOption('zIndexExpr');
    }
    set zIndexExpr(value) {
      this._setOption('zIndexExpr', value);
    }
    get _optionPath() {
      return 'nodes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoNodesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoNodesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoNodesComponent,
      selectors: [["dxo-nodes"]],
      inputs: {
        autoLayout: "autoLayout",
        autoSizeEnabled: "autoSizeEnabled",
        containerChildrenExpr: "containerChildrenExpr",
        containerKeyExpr: "containerKeyExpr",
        customDataExpr: "customDataExpr",
        dataSource: "dataSource",
        heightExpr: "heightExpr",
        imageUrlExpr: "imageUrlExpr",
        itemsExpr: "itemsExpr",
        keyExpr: "keyExpr",
        leftExpr: "leftExpr",
        lockedExpr: "lockedExpr",
        parentKeyExpr: "parentKeyExpr",
        styleExpr: "styleExpr",
        textExpr: "textExpr",
        textStyleExpr: "textStyleExpr",
        topExpr: "topExpr",
        typeExpr: "typeExpr",
        widthExpr: "widthExpr",
        zIndexExpr: "zIndexExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoNodesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoNodesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoNodesModule = /*#__PURE__*/(() => {
  class DxoNodesModule {
    /** @nocollapse */static ɵfac = function DxoNodesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoNodesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoNodesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoNodesComponent]
    });
  }
  return DxoNodesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoNotificationsComponent = /*#__PURE__*/(() => {
  class DxoNotificationsComponent extends NestedOption {
    get showPanel() {
      return this._getOption('showPanel');
    }
    set showPanel(value) {
      this._setOption('showPanel', value);
    }
    get showPopup() {
      return this._getOption('showPopup');
    }
    set showPopup(value) {
      this._setOption('showPopup', value);
    }
    get _optionPath() {
      return 'notifications';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoNotificationsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoNotificationsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoNotificationsComponent,
      selectors: [["dxo-notifications"]],
      inputs: {
        showPanel: "showPanel",
        showPopup: "showPopup"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoNotificationsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoNotificationsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoNotificationsModule = /*#__PURE__*/(() => {
  class DxoNotificationsModule {
    /** @nocollapse */static ɵfac = function DxoNotificationsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoNotificationsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoNotificationsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoNotificationsComponent]
    });
  }
  return DxoNotificationsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoOffsetComponent = /*#__PURE__*/(() => {
  class DxoOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoOffsetComponent,
      selectors: [["dxo-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoOffsetModule = /*#__PURE__*/(() => {
  class DxoOffsetModule {
    /** @nocollapse */static ɵfac = function DxoOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoOffsetComponent]
    });
  }
  return DxoOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGanttFilterRowOperationDescriptions = /*#__PURE__*/(() => {
  class DxoGanttFilterRowOperationDescriptions extends NestedOption {
    get between() {
      return this._getOption('between');
    }
    set between(value) {
      this._setOption('between', value);
    }
    get contains() {
      return this._getOption('contains');
    }
    set contains(value) {
      this._setOption('contains', value);
    }
    get endsWith() {
      return this._getOption('endsWith');
    }
    set endsWith(value) {
      this._setOption('endsWith', value);
    }
    get equal() {
      return this._getOption('equal');
    }
    set equal(value) {
      this._setOption('equal', value);
    }
    get greaterThan() {
      return this._getOption('greaterThan');
    }
    set greaterThan(value) {
      this._setOption('greaterThan', value);
    }
    get greaterThanOrEqual() {
      return this._getOption('greaterThanOrEqual');
    }
    set greaterThanOrEqual(value) {
      this._setOption('greaterThanOrEqual', value);
    }
    get lessThan() {
      return this._getOption('lessThan');
    }
    set lessThan(value) {
      this._setOption('lessThan', value);
    }
    get lessThanOrEqual() {
      return this._getOption('lessThanOrEqual');
    }
    set lessThanOrEqual(value) {
      this._setOption('lessThanOrEqual', value);
    }
    get notContains() {
      return this._getOption('notContains');
    }
    set notContains(value) {
      this._setOption('notContains', value);
    }
    get notEqual() {
      return this._getOption('notEqual');
    }
    set notEqual(value) {
      this._setOption('notEqual', value);
    }
    get startsWith() {
      return this._getOption('startsWith');
    }
    set startsWith(value) {
      this._setOption('startsWith', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoGanttFilterRowOperationDescriptions_BaseFactory;
      return function DxoGanttFilterRowOperationDescriptions_Factory(__ngFactoryType__) {
        return (ɵDxoGanttFilterRowOperationDescriptions_BaseFactory || (ɵDxoGanttFilterRowOperationDescriptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoGanttFilterRowOperationDescriptions)))(__ngFactoryType__ || DxoGanttFilterRowOperationDescriptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGanttFilterRowOperationDescriptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGanttFilterRowOperationDescriptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoGanttFilterRowOperationDescriptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoOperationDescriptionsComponent = /*#__PURE__*/(() => {
  class DxoOperationDescriptionsComponent extends DxoGanttFilterRowOperationDescriptions {
    get _optionPath() {
      return 'operationDescriptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoOperationDescriptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoOperationDescriptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoOperationDescriptionsComponent,
      selectors: [["dxo-operation-descriptions"]],
      inputs: {
        between: "between",
        contains: "contains",
        endsWith: "endsWith",
        equal: "equal",
        greaterThan: "greaterThan",
        greaterThanOrEqual: "greaterThanOrEqual",
        lessThan: "lessThan",
        lessThanOrEqual: "lessThanOrEqual",
        notContains: "notContains",
        notEqual: "notEqual",
        startsWith: "startsWith"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoOperationDescriptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoOperationDescriptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoOperationDescriptionsModule = /*#__PURE__*/(() => {
  class DxoOperationDescriptionsModule {
    /** @nocollapse */static ɵfac = function DxoOperationDescriptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoOperationDescriptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoOperationDescriptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoOperationDescriptionsComponent]
    });
  }
  return DxoOperationDescriptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoOptionsComponent = /*#__PURE__*/(() => {
  class DxoOptionsComponent extends DxoButtonOptions {
    get _optionPath() {
      return 'options';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoOptionsComponent,
      selectors: [["dxo-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        icon: "icon",
        onClick: "onClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        template: "template",
        text: "text",
        type: "type",
        useSubmitBehavior: "useSubmitBehavior",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoOptionsModule = /*#__PURE__*/(() => {
  class DxoOptionsModule {
    /** @nocollapse */static ɵfac = function DxoOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoOptionsComponent]
    });
  }
  return DxoOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPageSizeComponent = /*#__PURE__*/(() => {
  class DxoPageSizeComponent extends NestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'pageSize';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPageSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPageSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPageSizeComponent,
      selectors: [["dxo-page-size"]],
      contentQueries: function DxoPageSizeComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        height: "height",
        items: "items",
        width: "width"
      },
      outputs: {
        heightChange: "heightChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPageSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPageSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPageSizeModule = /*#__PURE__*/(() => {
  class DxoPageSizeModule {
    /** @nocollapse */static ɵfac = function DxoPageSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPageSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPageSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPageSizeComponent]
    });
  }
  return DxoPageSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPager = /*#__PURE__*/(() => {
  class DxoPager extends NestedOption {
    get allowedPageSizes() {
      return this._getOption('allowedPageSizes');
    }
    set allowedPageSizes(value) {
      this._setOption('allowedPageSizes', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get infoText() {
      return this._getOption('infoText');
    }
    set infoText(value) {
      this._setOption('infoText', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get showInfo() {
      return this._getOption('showInfo');
    }
    set showInfo(value) {
      this._setOption('showInfo', value);
    }
    get showNavigationButtons() {
      return this._getOption('showNavigationButtons');
    }
    set showNavigationButtons(value) {
      this._setOption('showNavigationButtons', value);
    }
    get showPageSizeSelector() {
      return this._getOption('showPageSizeSelector');
    }
    set showPageSizeSelector(value) {
      this._setOption('showPageSizeSelector', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoPager_BaseFactory;
      return function DxoPager_Factory(__ngFactoryType__) {
        return (ɵDxoPager_BaseFactory || (ɵDxoPager_BaseFactory = i0.ɵɵgetInheritedFactory(DxoPager)))(__ngFactoryType__ || DxoPager);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPager,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPager_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPager;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoPagerComponent = /*#__PURE__*/(() => {
  class DxoPagerComponent extends DxoPager {
    get _optionPath() {
      return 'pager';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPagerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPagerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPagerComponent,
      selectors: [["dxo-pager"]],
      inputs: {
        allowedPageSizes: "allowedPageSizes",
        displayMode: "displayMode",
        infoText: "infoText",
        label: "label",
        showInfo: "showInfo",
        showNavigationButtons: "showNavigationButtons",
        showPageSizeSelector: "showPageSizeSelector",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPagerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPagerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPagerModule = /*#__PURE__*/(() => {
  class DxoPagerModule {
    /** @nocollapse */static ɵfac = function DxoPagerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPagerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPagerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPagerComponent]
    });
  }
  return DxoPagerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPagingComponent = /*#__PURE__*/(() => {
  class DxoPagingComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get pageIndex() {
      return this._getOption('pageIndex');
    }
    set pageIndex(value) {
      this._setOption('pageIndex', value);
    }
    get pageSize() {
      return this._getOption('pageSize');
    }
    set pageSize(value) {
      this._setOption('pageSize', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageSizeChange;
    get _optionPath() {
      return 'paging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'pageIndexChange'
      }, {
        emit: 'pageSizeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPagingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPagingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPagingComponent,
      selectors: [["dxo-paging"]],
      inputs: {
        enabled: "enabled",
        pageIndex: "pageIndex",
        pageSize: "pageSize"
      },
      outputs: {
        pageIndexChange: "pageIndexChange",
        pageSizeChange: "pageSizeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPagingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPagingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPagingModule = /*#__PURE__*/(() => {
  class DxoPagingModule {
    /** @nocollapse */static ɵfac = function DxoPagingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPagingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPagingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPagingComponent]
    });
  }
  return DxoPagingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPaneComponent = /*#__PURE__*/(() => {
  class DxiPaneComponent extends CollectionNestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'panes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPaneComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPaneComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPaneComponent,
      selectors: [["dxi-pane"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        height: "height",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_panes,
        useExisting: DxiPaneComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiPaneComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiPaneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPaneModule = /*#__PURE__*/(() => {
  class DxiPaneModule {
    /** @nocollapse */static ɵfac = function DxiPaneModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPaneModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPaneModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiPaneComponent]
    });
  }
  return DxiPaneModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPermissionsComponent = /*#__PURE__*/(() => {
  class DxoPermissionsComponent extends NestedOption {
    get copy() {
      return this._getOption('copy');
    }
    set copy(value) {
      this._setOption('copy', value);
    }
    get create() {
      return this._getOption('create');
    }
    set create(value) {
      this._setOption('create', value);
    }
    get delete() {
      return this._getOption('delete');
    }
    set delete(value) {
      this._setOption('delete', value);
    }
    get download() {
      return this._getOption('download');
    }
    set download(value) {
      this._setOption('download', value);
    }
    get move() {
      return this._getOption('move');
    }
    set move(value) {
      this._setOption('move', value);
    }
    get rename() {
      return this._getOption('rename');
    }
    set rename(value) {
      this._setOption('rename', value);
    }
    get upload() {
      return this._getOption('upload');
    }
    set upload(value) {
      this._setOption('upload', value);
    }
    get _optionPath() {
      return 'permissions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPermissionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPermissionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPermissionsComponent,
      selectors: [["dxo-permissions"]],
      inputs: {
        copy: "copy",
        create: "create",
        delete: "delete",
        download: "download",
        move: "move",
        rename: "rename",
        upload: "upload"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPermissionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPermissionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPermissionsModule = /*#__PURE__*/(() => {
  class DxoPermissionsModule {
    /** @nocollapse */static ɵfac = function DxoPermissionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPermissionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPermissionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPermissionsComponent]
    });
  }
  return DxoPermissionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPointComponent = /*#__PURE__*/(() => {
  class DxoPointComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get symbol() {
      return this._getOption('symbol');
    }
    set symbol(value) {
      this._setOption('symbol', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'point';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPointComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPointComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPointComponent,
      selectors: [["dxo-point"]],
      inputs: {
        border: "border",
        color: "color",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        image: "image",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        size: "size",
        symbol: "symbol",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPointComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPointComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPointModule = /*#__PURE__*/(() => {
  class DxoPointModule {
    /** @nocollapse */static ɵfac = function DxoPointModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPointModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPointModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPointComponent]
    });
  }
  return DxoPointModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoPopupComponent = /*#__PURE__*/(() => {
  class DxoPopupComponent extends DxoPopupOptions {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'popup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPopupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPopupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPopupComponent,
      selectors: [["dxo-popup"]],
      contentQueries: function DxoPopupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPopupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPopupModule = /*#__PURE__*/(() => {
  class DxoPopupModule {
    /** @nocollapse */static ɵfac = function DxoPopupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPopupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPopupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPopupComponent]
    });
  }
  return DxoPopupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPositionConfig = /*#__PURE__*/(() => {
  class DxoPositionConfig extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoPositionConfig_BaseFactory;
      return function DxoPositionConfig_Factory(__ngFactoryType__) {
        return (ɵDxoPositionConfig_BaseFactory || (ɵDxoPositionConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxoPositionConfig)))(__ngFactoryType__ || DxoPositionConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPositionConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPositionConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoPositionConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoPositionComponent = /*#__PURE__*/(() => {
  class DxoPositionComponent extends DxoPositionConfig {
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPositionComponent,
      selectors: [["dxo-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPositionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPositionModule = /*#__PURE__*/(() => {
  class DxoPositionModule {
    /** @nocollapse */static ɵfac = function DxoPositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPositionComponent]
    });
  }
  return DxoPositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoVectorMapProjectionConfig = /*#__PURE__*/(() => {
  class DxoVectorMapProjectionConfig extends NestedOption {
    get aspectRatio() {
      return this._getOption('aspectRatio');
    }
    set aspectRatio(value) {
      this._setOption('aspectRatio', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoVectorMapProjectionConfig_BaseFactory;
      return function DxoVectorMapProjectionConfig_Factory(__ngFactoryType__) {
        return (ɵDxoVectorMapProjectionConfig_BaseFactory || (ɵDxoVectorMapProjectionConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxoVectorMapProjectionConfig)))(__ngFactoryType__ || DxoVectorMapProjectionConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoVectorMapProjectionConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoVectorMapProjectionConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoVectorMapProjectionConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoProjectionComponent = /*#__PURE__*/(() => {
  class DxoProjectionComponent extends DxoVectorMapProjectionConfig {
    get _optionPath() {
      return 'projection';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoProjectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoProjectionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoProjectionComponent,
      selectors: [["dxo-projection"]],
      inputs: {
        aspectRatio: "aspectRatio",
        from: "from",
        to: "to"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoProjectionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoProjectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoProjectionModule = /*#__PURE__*/(() => {
  class DxoProjectionModule {
    /** @nocollapse */static ɵfac = function DxoProjectionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoProjectionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoProjectionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoProjectionComponent]
    });
  }
  return DxoProjectionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPropertiesPanelComponent = /*#__PURE__*/(() => {
  class DxoPropertiesPanelComponent extends NestedOption {
    set _tabsContentChildren(value) {
      this.setChildren('tabs', value);
    }
    get tabs() {
      return this._getOption('tabs');
    }
    set tabs(value) {
      this._setOption('tabs', value);
    }
    get visibility() {
      return this._getOption('visibility');
    }
    set visibility(value) {
      this._setOption('visibility', value);
    }
    get _optionPath() {
      return 'propertiesPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPropertiesPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPropertiesPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPropertiesPanelComponent,
      selectors: [["dxo-properties-panel"]],
      contentQueries: function DxoPropertiesPanelComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_tabs, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabsContentChildren = _t);
        }
      },
      inputs: {
        tabs: "tabs",
        visibility: "visibility"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPropertiesPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPropertiesPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPropertiesPanelModule = /*#__PURE__*/(() => {
  class DxoPropertiesPanelModule {
    /** @nocollapse */static ɵfac = function DxoPropertiesPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPropertiesPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPropertiesPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPropertiesPanelComponent]
    });
  }
  return DxoPropertiesPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoProviderConfigComponent = /*#__PURE__*/(() => {
  class DxoProviderConfigComponent extends NestedOption {
    get mapId() {
      return this._getOption('mapId');
    }
    set mapId(value) {
      this._setOption('mapId', value);
    }
    get useAdvancedMarkers() {
      return this._getOption('useAdvancedMarkers');
    }
    set useAdvancedMarkers(value) {
      this._setOption('useAdvancedMarkers', value);
    }
    get _optionPath() {
      return 'providerConfig';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoProviderConfigComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoProviderConfigComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoProviderConfigComponent,
      selectors: [["dxo-provider-config"]],
      inputs: {
        mapId: "mapId",
        useAdvancedMarkers: "useAdvancedMarkers"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoProviderConfigComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoProviderConfigComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoProviderConfigModule = /*#__PURE__*/(() => {
  class DxoProviderConfigModule {
    /** @nocollapse */static ɵfac = function DxoProviderConfigModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoProviderConfigModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoProviderConfigModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoProviderConfigComponent]
    });
  }
  return DxoProviderConfigModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoRangeContainerComponent = /*#__PURE__*/(() => {
  class DxoRangeContainerComponent extends NestedOption {
    set _rangesContentChildren(value) {
      this.setChildren('ranges', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get paletteExtensionMode() {
      return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value) {
      this._setOption('paletteExtensionMode', value);
    }
    get ranges() {
      return this._getOption('ranges');
    }
    set ranges(value) {
      this._setOption('ranges', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get _optionPath() {
      return 'rangeContainer';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoRangeContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRangeContainerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoRangeContainerComponent,
      selectors: [["dxo-range-container"]],
      contentQueries: function DxoRangeContainerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_ranges, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._rangesContentChildren = _t);
        }
      },
      inputs: {
        backgroundColor: "backgroundColor",
        offset: "offset",
        orientation: "orientation",
        palette: "palette",
        paletteExtensionMode: "paletteExtensionMode",
        ranges: "ranges",
        width: "width",
        horizontalOrientation: "horizontalOrientation",
        verticalOrientation: "verticalOrientation"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoRangeContainerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoRangeContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoRangeContainerModule = /*#__PURE__*/(() => {
  class DxoRangeContainerModule {
    /** @nocollapse */static ɵfac = function DxoRangeContainerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRangeContainerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoRangeContainerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoRangeContainerComponent]
    });
  }
  return DxoRangeContainerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiRangeComponent = /*#__PURE__*/(() => {
  class DxiRangeComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'ranges';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiRangeComponent,
      selectors: [["dxi-range"]],
      inputs: {
        color: "color",
        endValue: "endValue",
        startValue: "startValue"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_ranges,
        useExisting: DxiRangeComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiRangeModule = /*#__PURE__*/(() => {
  class DxiRangeModule {
    /** @nocollapse */static ɵfac = function DxiRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiRangeComponent]
    });
  }
  return DxiRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoRangeareaComponent = /*#__PURE__*/(() => {
  class DxoRangeareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'rangearea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoRangeareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRangeareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoRangeareaComponent,
      selectors: [["dxo-rangearea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoRangeareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoRangeareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoRangeareaModule = /*#__PURE__*/(() => {
  class DxoRangeareaModule {
    /** @nocollapse */static ɵfac = function DxoRangeareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRangeareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoRangeareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoRangeareaComponent]
    });
  }
  return DxoRangeareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoRangebarComponent = /*#__PURE__*/(() => {
  class DxoRangebarComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'rangebar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoRangebarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRangebarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoRangebarComponent,
      selectors: [["dxo-rangebar"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoRangebarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoRangebarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoRangebarModule = /*#__PURE__*/(() => {
  class DxoRangebarModule {
    /** @nocollapse */static ɵfac = function DxoRangebarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRangebarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoRangebarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoRangebarComponent]
    });
  }
  return DxoRangebarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoReductionComponent = /*#__PURE__*/(() => {
  class DxoReductionComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get level() {
      return this._getOption('level');
    }
    set level(value) {
      this._setOption('level', value);
    }
    get _optionPath() {
      return 'reduction';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoReductionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoReductionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoReductionComponent,
      selectors: [["dxo-reduction"]],
      inputs: {
        color: "color",
        level: "level"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoReductionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoReductionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoReductionModule = /*#__PURE__*/(() => {
  class DxoReductionModule {
    /** @nocollapse */static ɵfac = function DxoReductionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoReductionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoReductionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoReductionComponent]
    });
  }
  return DxoReductionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoRemoteOperationsComponent = /*#__PURE__*/(() => {
  class DxoRemoteOperationsComponent extends NestedOption {
    get filtering() {
      return this._getOption('filtering');
    }
    set filtering(value) {
      this._setOption('filtering', value);
    }
    get grouping() {
      return this._getOption('grouping');
    }
    set grouping(value) {
      this._setOption('grouping', value);
    }
    get groupPaging() {
      return this._getOption('groupPaging');
    }
    set groupPaging(value) {
      this._setOption('groupPaging', value);
    }
    get paging() {
      return this._getOption('paging');
    }
    set paging(value) {
      this._setOption('paging', value);
    }
    get sorting() {
      return this._getOption('sorting');
    }
    set sorting(value) {
      this._setOption('sorting', value);
    }
    get summary() {
      return this._getOption('summary');
    }
    set summary(value) {
      this._setOption('summary', value);
    }
    get _optionPath() {
      return 'remoteOperations';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoRemoteOperationsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRemoteOperationsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoRemoteOperationsComponent,
      selectors: [["dxo-remote-operations"]],
      inputs: {
        filtering: "filtering",
        grouping: "grouping",
        groupPaging: "groupPaging",
        paging: "paging",
        sorting: "sorting",
        summary: "summary"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoRemoteOperationsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoRemoteOperationsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoRemoteOperationsModule = /*#__PURE__*/(() => {
  class DxoRemoteOperationsModule {
    /** @nocollapse */static ɵfac = function DxoRemoteOperationsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRemoteOperationsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoRemoteOperationsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoRemoteOperationsComponent]
    });
  }
  return DxoRemoteOperationsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoResourceAssignmentsComponent = /*#__PURE__*/(() => {
  class DxoResourceAssignmentsComponent extends NestedOption {
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get resourceIdExpr() {
      return this._getOption('resourceIdExpr');
    }
    set resourceIdExpr(value) {
      this._setOption('resourceIdExpr', value);
    }
    get taskIdExpr() {
      return this._getOption('taskIdExpr');
    }
    set taskIdExpr(value) {
      this._setOption('taskIdExpr', value);
    }
    get _optionPath() {
      return 'resourceAssignments';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoResourceAssignmentsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoResourceAssignmentsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoResourceAssignmentsComponent,
      selectors: [["dxo-resource-assignments"]],
      inputs: {
        dataSource: "dataSource",
        keyExpr: "keyExpr",
        resourceIdExpr: "resourceIdExpr",
        taskIdExpr: "taskIdExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoResourceAssignmentsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoResourceAssignmentsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoResourceAssignmentsModule = /*#__PURE__*/(() => {
  class DxoResourceAssignmentsModule {
    /** @nocollapse */static ɵfac = function DxoResourceAssignmentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoResourceAssignmentsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoResourceAssignmentsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoResourceAssignmentsComponent]
    });
  }
  return DxoResourceAssignmentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiResourceComponent = /*#__PURE__*/(() => {
  class DxiResourceComponent extends CollectionNestedOption {
    get allowMultiple() {
      return this._getOption('allowMultiple');
    }
    set allowMultiple(value) {
      this._setOption('allowMultiple', value);
    }
    get colorExpr() {
      return this._getOption('colorExpr');
    }
    set colorExpr(value) {
      this._setOption('colorExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get fieldExpr() {
      return this._getOption('fieldExpr');
    }
    set fieldExpr(value) {
      this._setOption('fieldExpr', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get useColorAsDefault() {
      return this._getOption('useColorAsDefault');
    }
    set useColorAsDefault(value) {
      this._setOption('useColorAsDefault', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'resources';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiResourceComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiResourceComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiResourceComponent,
      selectors: [["dxi-resource"]],
      inputs: {
        allowMultiple: "allowMultiple",
        colorExpr: "colorExpr",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        fieldExpr: "fieldExpr",
        label: "label",
        useColorAsDefault: "useColorAsDefault",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_resources,
        useExisting: DxiResourceComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiResourceComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiResourceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiResourceModule = /*#__PURE__*/(() => {
  class DxiResourceModule {
    /** @nocollapse */static ɵfac = function DxiResourceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiResourceModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiResourceModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiResourceComponent]
    });
  }
  return DxiResourceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoResourcesComponent = /*#__PURE__*/(() => {
  class DxoResourcesComponent extends NestedOption {
    get colorExpr() {
      return this._getOption('colorExpr');
    }
    set colorExpr(value) {
      this._setOption('colorExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get textExpr() {
      return this._getOption('textExpr');
    }
    set textExpr(value) {
      this._setOption('textExpr', value);
    }
    get _optionPath() {
      return 'resources';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoResourcesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoResourcesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoResourcesComponent,
      selectors: [["dxo-resources"]],
      inputs: {
        colorExpr: "colorExpr",
        dataSource: "dataSource",
        keyExpr: "keyExpr",
        textExpr: "textExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoResourcesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoResourcesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoResourcesModule = /*#__PURE__*/(() => {
  class DxoResourcesModule {
    /** @nocollapse */static ɵfac = function DxoResourcesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoResourcesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoResourcesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoResourcesComponent]
    });
  }
  return DxoResourcesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiRouteComponent = /*#__PURE__*/(() => {
  class DxiRouteComponent extends CollectionNestedOption {
    set _locationsContentChildren(value) {
      this.setChildren('locations', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get locations() {
      return this._getOption('locations');
    }
    set locations(value) {
      this._setOption('locations', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    get _optionPath() {
      return 'routes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiRouteComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiRouteComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiRouteComponent,
      selectors: [["dxi-route"]],
      contentQueries: function DxiRouteComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_locations, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._locationsContentChildren = _t);
        }
      },
      inputs: {
        color: "color",
        locations: "locations",
        mode: "mode",
        opacity: "opacity",
        weight: "weight"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_routes,
        useExisting: DxiRouteComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiRouteComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiRouteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiRouteModule = /*#__PURE__*/(() => {
  class DxiRouteModule {
    /** @nocollapse */static ɵfac = function DxiRouteModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiRouteModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiRouteModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiRouteComponent]
    });
  }
  return DxiRouteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoRowDraggingComponent = /*#__PURE__*/(() => {
  class DxoRowDraggingComponent extends NestedOption {
    get allowDropInsideItem() {
      return this._getOption('allowDropInsideItem');
    }
    set allowDropInsideItem(value) {
      this._setOption('allowDropInsideItem', value);
    }
    get allowReordering() {
      return this._getOption('allowReordering');
    }
    set allowReordering(value) {
      this._setOption('allowReordering', value);
    }
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get cursorOffset() {
      return this._getOption('cursorOffset');
    }
    set cursorOffset(value) {
      this._setOption('cursorOffset', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get dragDirection() {
      return this._getOption('dragDirection');
    }
    set dragDirection(value) {
      this._setOption('dragDirection', value);
    }
    get dragTemplate() {
      return this._getOption('dragTemplate');
    }
    set dragTemplate(value) {
      this._setOption('dragTemplate', value);
    }
    get dropFeedbackMode() {
      return this._getOption('dropFeedbackMode');
    }
    set dropFeedbackMode(value) {
      this._setOption('dropFeedbackMode', value);
    }
    get filter() {
      return this._getOption('filter');
    }
    set filter(value) {
      this._setOption('filter', value);
    }
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    get handle() {
      return this._getOption('handle');
    }
    set handle(value) {
      this._setOption('handle', value);
    }
    get onAdd() {
      return this._getOption('onAdd');
    }
    set onAdd(value) {
      this._setOption('onAdd', value);
    }
    get onDragChange() {
      return this._getOption('onDragChange');
    }
    set onDragChange(value) {
      this._setOption('onDragChange', value);
    }
    get onDragEnd() {
      return this._getOption('onDragEnd');
    }
    set onDragEnd(value) {
      this._setOption('onDragEnd', value);
    }
    get onDragMove() {
      return this._getOption('onDragMove');
    }
    set onDragMove(value) {
      this._setOption('onDragMove', value);
    }
    get onDragStart() {
      return this._getOption('onDragStart');
    }
    set onDragStart(value) {
      this._setOption('onDragStart', value);
    }
    get onRemove() {
      return this._getOption('onRemove');
    }
    set onRemove(value) {
      this._setOption('onRemove', value);
    }
    get onReorder() {
      return this._getOption('onReorder');
    }
    set onReorder(value) {
      this._setOption('onReorder', value);
    }
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    get showDragIcons() {
      return this._getOption('showDragIcons');
    }
    set showDragIcons(value) {
      this._setOption('showDragIcons', value);
    }
    get _optionPath() {
      return 'rowDragging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoRowDraggingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRowDraggingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoRowDraggingComponent,
      selectors: [["dxo-row-dragging"]],
      inputs: {
        allowDropInsideItem: "allowDropInsideItem",
        allowReordering: "allowReordering",
        autoScroll: "autoScroll",
        boundary: "boundary",
        container: "container",
        cursorOffset: "cursorOffset",
        data: "data",
        dragDirection: "dragDirection",
        dragTemplate: "dragTemplate",
        dropFeedbackMode: "dropFeedbackMode",
        filter: "filter",
        group: "group",
        handle: "handle",
        onAdd: "onAdd",
        onDragChange: "onDragChange",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onRemove: "onRemove",
        onReorder: "onReorder",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed",
        showDragIcons: "showDragIcons"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoRowDraggingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoRowDraggingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoRowDraggingModule = /*#__PURE__*/(() => {
  class DxoRowDraggingModule {
    /** @nocollapse */static ɵfac = function DxoRowDraggingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoRowDraggingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoRowDraggingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoRowDraggingComponent]
    });
  }
  return DxoRowDraggingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiRowComponent = /*#__PURE__*/(() => {
  class DxiRowComponent extends CollectionNestedOption {
    get baseSize() {
      return this._getOption('baseSize');
    }
    set baseSize(value) {
      this._setOption('baseSize', value);
    }
    get ratio() {
      return this._getOption('ratio');
    }
    set ratio(value) {
      this._setOption('ratio', value);
    }
    get screen() {
      return this._getOption('screen');
    }
    set screen(value) {
      this._setOption('screen', value);
    }
    get shrink() {
      return this._getOption('shrink');
    }
    set shrink(value) {
      this._setOption('shrink', value);
    }
    get _optionPath() {
      return 'rows';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiRowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiRowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiRowComponent,
      selectors: [["dxi-row"]],
      inputs: {
        baseSize: "baseSize",
        ratio: "ratio",
        screen: "screen",
        shrink: "shrink"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_rows,
        useExisting: DxiRowComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiRowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiRowModule = /*#__PURE__*/(() => {
  class DxiRowModule {
    /** @nocollapse */static ɵfac = function DxiRowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiRowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiRowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiRowComponent]
    });
  }
  return DxiRowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoScaleTypeRangeComponent = /*#__PURE__*/(() => {
  class DxoScaleTypeRangeComponent extends NestedOption {
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get _optionPath() {
      return 'scaleTypeRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoScaleTypeRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScaleTypeRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoScaleTypeRangeComponent,
      selectors: [["dxo-scale-type-range"]],
      inputs: {
        max: "max",
        min: "min"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoScaleTypeRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoScaleTypeRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoScaleTypeRangeModule = /*#__PURE__*/(() => {
  class DxoScaleTypeRangeModule {
    /** @nocollapse */static ɵfac = function DxoScaleTypeRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScaleTypeRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoScaleTypeRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoScaleTypeRangeComponent]
    });
  }
  return DxoScaleTypeRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoScaleComponent = /*#__PURE__*/(() => {
  class DxoScaleComponent extends NestedOption {
    set _breaksContentChildren(value) {
      this.setChildren('breaks', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get customMinorTicks() {
      return this._getOption('customMinorTicks');
    }
    set customMinorTicks(value) {
      this._setOption('customMinorTicks', value);
    }
    get customTicks() {
      return this._getOption('customTicks');
    }
    set customTicks(value) {
      this._setOption('customTicks', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get scaleDivisionFactor() {
      return this._getOption('scaleDivisionFactor');
    }
    set scaleDivisionFactor(value) {
      this._setOption('scaleDivisionFactor', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get aggregationGroupWidth() {
      return this._getOption('aggregationGroupWidth');
    }
    set aggregationGroupWidth(value) {
      this._setOption('aggregationGroupWidth', value);
    }
    get aggregationInterval() {
      return this._getOption('aggregationInterval');
    }
    set aggregationInterval(value) {
      this._setOption('aggregationInterval', value);
    }
    get breaks() {
      return this._getOption('breaks');
    }
    set breaks(value) {
      this._setOption('breaks', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get holidays() {
      return this._getOption('holidays');
    }
    set holidays(value) {
      this._setOption('holidays', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get marker() {
      return this._getOption('marker');
    }
    set marker(value) {
      this._setOption('marker', value);
    }
    get maxRange() {
      return this._getOption('maxRange');
    }
    set maxRange(value) {
      this._setOption('maxRange', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minRange() {
      return this._getOption('minRange');
    }
    set minRange(value) {
      this._setOption('minRange', value);
    }
    get placeholderHeight() {
      return this._getOption('placeholderHeight');
    }
    set placeholderHeight(value) {
      this._setOption('placeholderHeight', value);
    }
    get showCustomBoundaryTicks() {
      return this._getOption('showCustomBoundaryTicks');
    }
    set showCustomBoundaryTicks(value) {
      this._setOption('showCustomBoundaryTicks', value);
    }
    get singleWorkdays() {
      return this._getOption('singleWorkdays');
    }
    set singleWorkdays(value) {
      this._setOption('singleWorkdays', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueType() {
      return this._getOption('valueType');
    }
    set valueType(value) {
      this._setOption('valueType', value);
    }
    get workdaysOnly() {
      return this._getOption('workdaysOnly');
    }
    set workdaysOnly(value) {
      this._setOption('workdaysOnly', value);
    }
    get workWeek() {
      return this._getOption('workWeek');
    }
    set workWeek(value) {
      this._setOption('workWeek', value);
    }
    get _optionPath() {
      return 'scale';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoScaleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScaleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoScaleComponent,
      selectors: [["dxo-scale"]],
      contentQueries: function DxoScaleComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_breaks, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._breaksContentChildren = _t);
        }
      },
      inputs: {
        allowDecimals: "allowDecimals",
        customMinorTicks: "customMinorTicks",
        customTicks: "customTicks",
        endValue: "endValue",
        label: "label",
        minorTick: "minorTick",
        minorTickInterval: "minorTickInterval",
        orientation: "orientation",
        scaleDivisionFactor: "scaleDivisionFactor",
        startValue: "startValue",
        tick: "tick",
        tickInterval: "tickInterval",
        horizontalOrientation: "horizontalOrientation",
        verticalOrientation: "verticalOrientation",
        aggregationGroupWidth: "aggregationGroupWidth",
        aggregationInterval: "aggregationInterval",
        breaks: "breaks",
        breakStyle: "breakStyle",
        categories: "categories",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        holidays: "holidays",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        marker: "marker",
        maxRange: "maxRange",
        minorTickCount: "minorTickCount",
        minRange: "minRange",
        placeholderHeight: "placeholderHeight",
        showCustomBoundaryTicks: "showCustomBoundaryTicks",
        singleWorkdays: "singleWorkdays",
        type: "type",
        valueType: "valueType",
        workdaysOnly: "workdaysOnly",
        workWeek: "workWeek"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoScaleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoScaleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoScaleModule = /*#__PURE__*/(() => {
  class DxoScaleModule {
    /** @nocollapse */static ɵfac = function DxoScaleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScaleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoScaleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoScaleComponent]
    });
  }
  return DxoScaleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoScatterComponent = /*#__PURE__*/(() => {
  class DxoScatterComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'scatter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoScatterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScatterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoScatterComponent,
      selectors: [["dxo-scatter"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoScatterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoScatterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoScatterModule = /*#__PURE__*/(() => {
  class DxoScatterModule {
    /** @nocollapse */static ɵfac = function DxoScatterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScatterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoScatterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoScatterComponent]
    });
  }
  return DxoScatterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoScrollBarComponent = /*#__PURE__*/(() => {
  class DxoScrollBarComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'scrollBar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoScrollBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScrollBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoScrollBarComponent,
      selectors: [["dxo-scroll-bar"]],
      inputs: {
        color: "color",
        offset: "offset",
        opacity: "opacity",
        position: "position",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoScrollBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoScrollBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoScrollBarModule = /*#__PURE__*/(() => {
  class DxoScrollBarModule {
    /** @nocollapse */static ɵfac = function DxoScrollBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScrollBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoScrollBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoScrollBarComponent]
    });
  }
  return DxoScrollBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerScrolling = /*#__PURE__*/(() => {
  class DxoSchedulerScrolling extends NestedOption {
    get columnRenderingMode() {
      return this._getOption('columnRenderingMode');
    }
    set columnRenderingMode(value) {
      this._setOption('columnRenderingMode', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get preloadEnabled() {
      return this._getOption('preloadEnabled');
    }
    set preloadEnabled(value) {
      this._setOption('preloadEnabled', value);
    }
    get renderAsync() {
      return this._getOption('renderAsync');
    }
    set renderAsync(value) {
      this._setOption('renderAsync', value);
    }
    get rowRenderingMode() {
      return this._getOption('rowRenderingMode');
    }
    set rowRenderingMode(value) {
      this._setOption('rowRenderingMode', value);
    }
    get scrollByContent() {
      return this._getOption('scrollByContent');
    }
    set scrollByContent(value) {
      this._setOption('scrollByContent', value);
    }
    get scrollByThumb() {
      return this._getOption('scrollByThumb');
    }
    set scrollByThumb(value) {
      this._setOption('scrollByThumb', value);
    }
    get showScrollbar() {
      return this._getOption('showScrollbar');
    }
    set showScrollbar(value) {
      this._setOption('showScrollbar', value);
    }
    get useNative() {
      return this._getOption('useNative');
    }
    set useNative(value) {
      this._setOption('useNative', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoSchedulerScrolling_BaseFactory;
      return function DxoSchedulerScrolling_Factory(__ngFactoryType__) {
        return (ɵDxoSchedulerScrolling_BaseFactory || (ɵDxoSchedulerScrolling_BaseFactory = i0.ɵɵgetInheritedFactory(DxoSchedulerScrolling)))(__ngFactoryType__ || DxoSchedulerScrolling);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerScrolling,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerScrolling_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSchedulerScrolling;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoScrollingComponent = /*#__PURE__*/(() => {
  class DxoScrollingComponent extends DxoSchedulerScrolling {
    get _optionPath() {
      return 'scrolling';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoScrollingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScrollingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoScrollingComponent,
      selectors: [["dxo-scrolling"]],
      inputs: {
        columnRenderingMode: "columnRenderingMode",
        mode: "mode",
        preloadEnabled: "preloadEnabled",
        renderAsync: "renderAsync",
        rowRenderingMode: "rowRenderingMode",
        scrollByContent: "scrollByContent",
        scrollByThumb: "scrollByThumb",
        showScrollbar: "showScrollbar",
        useNative: "useNative"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoScrollingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoScrollingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoScrollingModule = /*#__PURE__*/(() => {
  class DxoScrollingModule {
    /** @nocollapse */static ɵfac = function DxoScrollingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoScrollingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoScrollingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoScrollingComponent]
    });
  }
  return DxoScrollingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTextBoxOptions = /*#__PURE__*/(() => {
  class DxoTextBoxOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get buttons() {
      return this._getOption('buttons');
    }
    set buttons(value) {
      this._setOption('buttons', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get inputAttr() {
      return this._getOption('inputAttr');
    }
    set inputAttr(value) {
      this._setOption('inputAttr', value);
    }
    get isDirty() {
      return this._getOption('isDirty');
    }
    set isDirty(value) {
      this._setOption('isDirty', value);
    }
    get isValid() {
      return this._getOption('isValid');
    }
    set isValid(value) {
      this._setOption('isValid', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get labelMode() {
      return this._getOption('labelMode');
    }
    set labelMode(value) {
      this._setOption('labelMode', value);
    }
    get mask() {
      return this._getOption('mask');
    }
    set mask(value) {
      this._setOption('mask', value);
    }
    get maskChar() {
      return this._getOption('maskChar');
    }
    set maskChar(value) {
      this._setOption('maskChar', value);
    }
    get maskInvalidMessage() {
      return this._getOption('maskInvalidMessage');
    }
    set maskInvalidMessage(value) {
      this._setOption('maskInvalidMessage', value);
    }
    get maskRules() {
      return this._getOption('maskRules');
    }
    set maskRules(value) {
      this._setOption('maskRules', value);
    }
    get maxLength() {
      return this._getOption('maxLength');
    }
    set maxLength(value) {
      this._setOption('maxLength', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get onChange() {
      return this._getOption('onChange');
    }
    set onChange(value) {
      this._setOption('onChange', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onCopy() {
      return this._getOption('onCopy');
    }
    set onCopy(value) {
      this._setOption('onCopy', value);
    }
    get onCut() {
      return this._getOption('onCut');
    }
    set onCut(value) {
      this._setOption('onCut', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onEnterKey() {
      return this._getOption('onEnterKey');
    }
    set onEnterKey(value) {
      this._setOption('onEnterKey', value);
    }
    get onFocusIn() {
      return this._getOption('onFocusIn');
    }
    set onFocusIn(value) {
      this._setOption('onFocusIn', value);
    }
    get onFocusOut() {
      return this._getOption('onFocusOut');
    }
    set onFocusOut(value) {
      this._setOption('onFocusOut', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onInput() {
      return this._getOption('onInput');
    }
    set onInput(value) {
      this._setOption('onInput', value);
    }
    get onKeyDown() {
      return this._getOption('onKeyDown');
    }
    set onKeyDown(value) {
      this._setOption('onKeyDown', value);
    }
    get onKeyUp() {
      return this._getOption('onKeyUp');
    }
    set onKeyUp(value) {
      this._setOption('onKeyUp', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onPaste() {
      return this._getOption('onPaste');
    }
    set onPaste(value) {
      this._setOption('onPaste', value);
    }
    get onValueChanged() {
      return this._getOption('onValueChanged');
    }
    set onValueChanged(value) {
      this._setOption('onValueChanged', value);
    }
    get placeholder() {
      return this._getOption('placeholder');
    }
    set placeholder(value) {
      this._setOption('placeholder', value);
    }
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get showClearButton() {
      return this._getOption('showClearButton');
    }
    set showClearButton(value) {
      this._setOption('showClearButton', value);
    }
    get showMaskMode() {
      return this._getOption('showMaskMode');
    }
    set showMaskMode(value) {
      this._setOption('showMaskMode', value);
    }
    get spellcheck() {
      return this._getOption('spellcheck');
    }
    set spellcheck(value) {
      this._setOption('spellcheck', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get useMaskedValue() {
      return this._getOption('useMaskedValue');
    }
    set useMaskedValue(value) {
      this._setOption('useMaskedValue', value);
    }
    get validationError() {
      return this._getOption('validationError');
    }
    set validationError(value) {
      this._setOption('validationError', value);
    }
    get validationErrors() {
      return this._getOption('validationErrors');
    }
    set validationErrors(value) {
      this._setOption('validationErrors', value);
    }
    get validationMessageMode() {
      return this._getOption('validationMessageMode');
    }
    set validationMessageMode(value) {
      this._setOption('validationMessageMode', value);
    }
    get validationMessagePosition() {
      return this._getOption('validationMessagePosition');
    }
    set validationMessagePosition(value) {
      this._setOption('validationMessagePosition', value);
    }
    get validationStatus() {
      return this._getOption('validationStatus');
    }
    set validationStatus(value) {
      this._setOption('validationStatus', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get valueChangeEvent() {
      return this._getOption('valueChangeEvent');
    }
    set valueChangeEvent(value) {
      this._setOption('valueChangeEvent', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoTextBoxOptions_BaseFactory;
      return function DxoTextBoxOptions_Factory(__ngFactoryType__) {
        return (ɵDxoTextBoxOptions_BaseFactory || (ɵDxoTextBoxOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoTextBoxOptions)))(__ngFactoryType__ || DxoTextBoxOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTextBoxOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTextBoxOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTextBoxOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSearchEditorOptionsComponent = /*#__PURE__*/(() => {
  class DxoSearchEditorOptionsComponent extends DxoTextBoxOptions {
    set _buttonsContentChildren(value) {
      this.setChildren('buttons', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    textChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'searchEditorOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'textChange'
      }, {
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSearchEditorOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSearchEditorOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSearchEditorOptionsComponent,
      selectors: [["dxo-search-editor-options"]],
      contentQueries: function DxoSearchEditorOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_buttons, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._buttonsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        buttons: "buttons",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        inputAttr: "inputAttr",
        isDirty: "isDirty",
        isValid: "isValid",
        label: "label",
        labelMode: "labelMode",
        mask: "mask",
        maskChar: "maskChar",
        maskInvalidMessage: "maskInvalidMessage",
        maskRules: "maskRules",
        maxLength: "maxLength",
        mode: "mode",
        name: "name",
        onChange: "onChange",
        onContentReady: "onContentReady",
        onCopy: "onCopy",
        onCut: "onCut",
        onDisposing: "onDisposing",
        onEnterKey: "onEnterKey",
        onFocusIn: "onFocusIn",
        onFocusOut: "onFocusOut",
        onInitialized: "onInitialized",
        onInput: "onInput",
        onKeyDown: "onKeyDown",
        onKeyUp: "onKeyUp",
        onOptionChanged: "onOptionChanged",
        onPaste: "onPaste",
        onValueChanged: "onValueChanged",
        placeholder: "placeholder",
        readOnly: "readOnly",
        rtlEnabled: "rtlEnabled",
        showClearButton: "showClearButton",
        showMaskMode: "showMaskMode",
        spellcheck: "spellcheck",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        text: "text",
        useMaskedValue: "useMaskedValue",
        validationError: "validationError",
        validationErrors: "validationErrors",
        validationMessageMode: "validationMessageMode",
        validationMessagePosition: "validationMessagePosition",
        validationStatus: "validationStatus",
        value: "value",
        valueChangeEvent: "valueChangeEvent",
        visible: "visible",
        width: "width"
      },
      outputs: {
        textChange: "textChange",
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSearchEditorOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSearchEditorOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSearchEditorOptionsModule = /*#__PURE__*/(() => {
  class DxoSearchEditorOptionsModule {
    /** @nocollapse */static ɵfac = function DxoSearchEditorOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSearchEditorOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSearchEditorOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSearchEditorOptionsComponent]
    });
  }
  return DxoSearchEditorOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSearchPanel = /*#__PURE__*/(() => {
  class DxoSearchPanel extends NestedOption {
    get highlightCaseSensitive() {
      return this._getOption('highlightCaseSensitive');
    }
    set highlightCaseSensitive(value) {
      this._setOption('highlightCaseSensitive', value);
    }
    get highlightSearchText() {
      return this._getOption('highlightSearchText');
    }
    set highlightSearchText(value) {
      this._setOption('highlightSearchText', value);
    }
    get placeholder() {
      return this._getOption('placeholder');
    }
    set placeholder(value) {
      this._setOption('placeholder', value);
    }
    get searchVisibleColumnsOnly() {
      return this._getOption('searchVisibleColumnsOnly');
    }
    set searchVisibleColumnsOnly(value) {
      this._setOption('searchVisibleColumnsOnly', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoSearchPanel_BaseFactory;
      return function DxoSearchPanel_Factory(__ngFactoryType__) {
        return (ɵDxoSearchPanel_BaseFactory || (ɵDxoSearchPanel_BaseFactory = i0.ɵɵgetInheritedFactory(DxoSearchPanel)))(__ngFactoryType__ || DxoSearchPanel);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSearchPanel,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSearchPanel_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSearchPanel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSearchPanelComponent = /*#__PURE__*/(() => {
  class DxoSearchPanelComponent extends DxoSearchPanel {
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    textChange;
    get _optionPath() {
      return 'searchPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'textChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSearchPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSearchPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSearchPanelComponent,
      selectors: [["dxo-search-panel"]],
      inputs: {
        highlightCaseSensitive: "highlightCaseSensitive",
        highlightSearchText: "highlightSearchText",
        placeholder: "placeholder",
        searchVisibleColumnsOnly: "searchVisibleColumnsOnly",
        text: "text",
        visible: "visible",
        width: "width"
      },
      outputs: {
        textChange: "textChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSearchPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSearchPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSearchPanelModule = /*#__PURE__*/(() => {
  class DxoSearchPanelModule {
    /** @nocollapse */static ɵfac = function DxoSearchPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSearchPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSearchPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSearchPanelComponent]
    });
  }
  return DxoSearchPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColumnChooserSearchConfig = /*#__PURE__*/(() => {
  class DxoColumnChooserSearchConfig extends NestedOption {
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get timeout() {
      return this._getOption('timeout');
    }
    set timeout(value) {
      this._setOption('timeout', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get searchExpr() {
      return this._getOption('searchExpr');
    }
    set searchExpr(value) {
      this._setOption('searchExpr', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoColumnChooserSearchConfig_BaseFactory;
      return function DxoColumnChooserSearchConfig_Factory(__ngFactoryType__) {
        return (ɵDxoColumnChooserSearchConfig_BaseFactory || (ɵDxoColumnChooserSearchConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxoColumnChooserSearchConfig)))(__ngFactoryType__ || DxoColumnChooserSearchConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColumnChooserSearchConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColumnChooserSearchConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoColumnChooserSearchConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSearchComponent = /*#__PURE__*/(() => {
  class DxoSearchComponent extends DxoColumnChooserSearchConfig {
    get _optionPath() {
      return 'search';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSearchComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSearchComponent,
      selectors: [["dxo-search"]],
      inputs: {
        editorOptions: "editorOptions",
        enabled: "enabled",
        timeout: "timeout",
        mode: "mode",
        searchExpr: "searchExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSearchComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSearchModule = /*#__PURE__*/(() => {
  class DxoSearchModule {
    /** @nocollapse */static ɵfac = function DxoSearchModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSearchModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSearchModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSearchComponent]
    });
  }
  return DxoSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSelectionStyleComponent,
      selectors: [["dxo-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSelectionStyleComponent]
    });
  }
  return DxoSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoColumnChooserSelectionConfig = /*#__PURE__*/(() => {
  class DxoColumnChooserSelectionConfig extends NestedOption {
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get recursive() {
      return this._getOption('recursive');
    }
    set recursive(value) {
      this._setOption('recursive', value);
    }
    get selectByClick() {
      return this._getOption('selectByClick');
    }
    set selectByClick(value) {
      this._setOption('selectByClick', value);
    }
    get deferred() {
      return this._getOption('deferred');
    }
    set deferred(value) {
      this._setOption('deferred', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get selectAllMode() {
      return this._getOption('selectAllMode');
    }
    set selectAllMode(value) {
      this._setOption('selectAllMode', value);
    }
    get sensitivity() {
      return this._getOption('sensitivity');
    }
    set sensitivity(value) {
      this._setOption('sensitivity', value);
    }
    get showCheckBoxesMode() {
      return this._getOption('showCheckBoxesMode');
    }
    set showCheckBoxesMode(value) {
      this._setOption('showCheckBoxesMode', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoColumnChooserSelectionConfig_BaseFactory;
      return function DxoColumnChooserSelectionConfig_Factory(__ngFactoryType__) {
        return (ɵDxoColumnChooserSelectionConfig_BaseFactory || (ɵDxoColumnChooserSelectionConfig_BaseFactory = i0.ɵɵgetInheritedFactory(DxoColumnChooserSelectionConfig)))(__ngFactoryType__ || DxoColumnChooserSelectionConfig);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoColumnChooserSelectionConfig,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoColumnChooserSelectionConfig_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoColumnChooserSelectionConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSelectionComponent = /*#__PURE__*/(() => {
  class DxoSelectionComponent extends DxoColumnChooserSelectionConfig {
    get _optionPath() {
      return 'selection';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSelectionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSelectionComponent,
      selectors: [["dxo-selection"]],
      inputs: {
        allowSelectAll: "allowSelectAll",
        recursive: "recursive",
        selectByClick: "selectByClick",
        deferred: "deferred",
        mode: "mode",
        selectAllMode: "selectAllMode",
        sensitivity: "sensitivity",
        showCheckBoxesMode: "showCheckBoxesMode"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSelectionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSelectionModule = /*#__PURE__*/(() => {
  class DxoSelectionModule {
    /** @nocollapse */static ɵfac = function DxoSelectionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSelectionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSelectionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSelectionComponent]
    });
  }
  return DxoSelectionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiChartSeries = /*#__PURE__*/(() => {
  class DxiChartSeries extends CollectionNestedOption {
    get aggregation() {
      return this._getOption('aggregation');
    }
    set aggregation(value) {
      this._setOption('aggregation', value);
    }
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get axis() {
      return this._getOption('axis');
    }
    set axis(value) {
      this._setOption('axis', value);
    }
    get barOverlapGroup() {
      return this._getOption('barOverlapGroup');
    }
    set barOverlapGroup(value) {
      this._setOption('barOverlapGroup', value);
    }
    get barPadding() {
      return this._getOption('barPadding');
    }
    set barPadding(value) {
      this._setOption('barPadding', value);
    }
    get barWidth() {
      return this._getOption('barWidth');
    }
    set barWidth(value) {
      this._setOption('barWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get closeValueField() {
      return this._getOption('closeValueField');
    }
    set closeValueField(value) {
      this._setOption('closeValueField', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get ignoreEmptyPoints() {
      return this._getOption('ignoreEmptyPoints');
    }
    set ignoreEmptyPoints(value) {
      this._setOption('ignoreEmptyPoints', value);
    }
    get innerColor() {
      return this._getOption('innerColor');
    }
    set innerColor(value) {
      this._setOption('innerColor', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minBarSize() {
      return this._getOption('minBarSize');
    }
    set minBarSize(value) {
      this._setOption('minBarSize', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get openValueField() {
      return this._getOption('openValueField');
    }
    set openValueField(value) {
      this._setOption('openValueField', value);
    }
    get pane() {
      return this._getOption('pane');
    }
    set pane(value) {
      this._setOption('pane', value);
    }
    get point() {
      return this._getOption('point');
    }
    set point(value) {
      this._setOption('point', value);
    }
    get rangeValue1Field() {
      return this._getOption('rangeValue1Field');
    }
    set rangeValue1Field(value) {
      this._setOption('rangeValue1Field', value);
    }
    get rangeValue2Field() {
      return this._getOption('rangeValue2Field');
    }
    set rangeValue2Field(value) {
      this._setOption('rangeValue2Field', value);
    }
    get reduction() {
      return this._getOption('reduction');
    }
    set reduction(value) {
      this._setOption('reduction', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get showInLegend() {
      return this._getOption('showInLegend');
    }
    set showInLegend(value) {
      this._setOption('showInLegend', value);
    }
    get sizeField() {
      return this._getOption('sizeField');
    }
    set sizeField(value) {
      this._setOption('sizeField', value);
    }
    get stack() {
      return this._getOption('stack');
    }
    set stack(value) {
      this._setOption('stack', value);
    }
    get tag() {
      return this._getOption('tag');
    }
    set tag(value) {
      this._setOption('tag', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueErrorBar() {
      return this._getOption('valueErrorBar');
    }
    set valueErrorBar(value) {
      this._setOption('valueErrorBar', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get minSegmentSize() {
      return this._getOption('minSegmentSize');
    }
    set minSegmentSize(value) {
      this._setOption('minSegmentSize', value);
    }
    get smallValuesGrouping() {
      return this._getOption('smallValuesGrouping');
    }
    set smallValuesGrouping(value) {
      this._setOption('smallValuesGrouping', value);
    }
    get closed() {
      return this._getOption('closed');
    }
    set closed(value) {
      this._setOption('closed', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiChartSeries_BaseFactory;
      return function DxiChartSeries_Factory(__ngFactoryType__) {
        return (ɵDxiChartSeries_BaseFactory || (ɵDxiChartSeries_BaseFactory = i0.ɵɵgetInheritedFactory(DxiChartSeries)))(__ngFactoryType__ || DxiChartSeries);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiChartSeries,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiChartSeries_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiChartSeries;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiSeriesComponent = /*#__PURE__*/(() => {
  class DxiSeriesComponent extends DxiChartSeries {
    get _optionPath() {
      return 'series';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSeriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSeriesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSeriesComponent,
      selectors: [["dxi-series"]],
      inputs: {
        aggregation: "aggregation",
        argumentField: "argumentField",
        axis: "axis",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        name: "name",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        stack: "stack",
        tag: "tag",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        argumentType: "argumentType",
        minSegmentSize: "minSegmentSize",
        smallValuesGrouping: "smallValuesGrouping",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_series,
        useExisting: DxiSeriesComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiSeriesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiSeriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSeriesModule = /*#__PURE__*/(() => {
  class DxiSeriesModule {
    /** @nocollapse */static ɵfac = function DxiSeriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSeriesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSeriesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSeriesComponent]
    });
  }
  return DxiSeriesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSeriesTemplateComponent = /*#__PURE__*/(() => {
  class DxoSeriesTemplateComponent extends NestedOption {
    get customizeSeries() {
      return this._getOption('customizeSeries');
    }
    set customizeSeries(value) {
      this._setOption('customizeSeries', value);
    }
    get nameField() {
      return this._getOption('nameField');
    }
    set nameField(value) {
      this._setOption('nameField', value);
    }
    get _optionPath() {
      return 'seriesTemplate';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSeriesTemplateComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSeriesTemplateComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSeriesTemplateComponent,
      selectors: [["dxo-series-template"]],
      inputs: {
        customizeSeries: "customizeSeries",
        nameField: "nameField"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSeriesTemplateComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSeriesTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSeriesTemplateModule = /*#__PURE__*/(() => {
  class DxoSeriesTemplateModule {
    /** @nocollapse */static ɵfac = function DxoSeriesTemplateModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSeriesTemplateModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSeriesTemplateModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSeriesTemplateComponent]
    });
  }
  return DxoSeriesTemplateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoShadowComponent = /*#__PURE__*/(() => {
  class DxoShadowComponent extends NestedOption {
    get blur() {
      return this._getOption('blur');
    }
    set blur(value) {
      this._setOption('blur', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shadow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoShadowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShadowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoShadowComponent,
      selectors: [["dxo-shadow"]],
      inputs: {
        blur: "blur",
        color: "color",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoShadowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoShadowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoShadowModule = /*#__PURE__*/(() => {
  class DxoShadowModule {
    /** @nocollapse */static ɵfac = function DxoShadowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShadowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoShadowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoShadowComponent]
    });
  }
  return DxoShadowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoShowEventComponent = /*#__PURE__*/(() => {
  class DxoShowEventComponent extends NestedOption {
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'showEvent';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoShowEventComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowEventComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoShowEventComponent,
      selectors: [["dxo-show-event"]],
      inputs: {
        delay: "delay",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoShowEventComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoShowEventComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoShowEventModule = /*#__PURE__*/(() => {
  class DxoShowEventModule {
    /** @nocollapse */static ɵfac = function DxoShowEventModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowEventModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoShowEventModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoShowEventComponent]
    });
  }
  return DxoShowEventModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoShowFirstSubmenuModeComponent = /*#__PURE__*/(() => {
  class DxoShowFirstSubmenuModeComponent extends NestedOption {
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'showFirstSubmenuMode';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoShowFirstSubmenuModeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowFirstSubmenuModeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoShowFirstSubmenuModeComponent,
      selectors: [["dxo-show-first-submenu-mode"]],
      inputs: {
        delay: "delay",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoShowFirstSubmenuModeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoShowFirstSubmenuModeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoShowFirstSubmenuModeModule = /*#__PURE__*/(() => {
  class DxoShowFirstSubmenuModeModule {
    /** @nocollapse */static ɵfac = function DxoShowFirstSubmenuModeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowFirstSubmenuModeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoShowFirstSubmenuModeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoShowFirstSubmenuModeComponent]
    });
  }
  return DxoShowFirstSubmenuModeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoShowSubmenuModeComponent = /*#__PURE__*/(() => {
  class DxoShowSubmenuModeComponent extends NestedOption {
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'showSubmenuMode';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoShowSubmenuModeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowSubmenuModeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoShowSubmenuModeComponent,
      selectors: [["dxo-show-submenu-mode"]],
      inputs: {
        delay: "delay",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoShowSubmenuModeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoShowSubmenuModeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoShowSubmenuModeModule = /*#__PURE__*/(() => {
  class DxoShowSubmenuModeModule {
    /** @nocollapse */static ɵfac = function DxoShowSubmenuModeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowSubmenuModeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoShowSubmenuModeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoShowSubmenuModeComponent]
    });
  }
  return DxoShowSubmenuModeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoShowComponent = /*#__PURE__*/(() => {
  class DxoShowComponent extends DxoAnimationConfig {
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoShowComponent,
      selectors: [["dxo-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoShowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoShowModule = /*#__PURE__*/(() => {
  class DxoShowModule {
    /** @nocollapse */static ɵfac = function DxoShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoShowComponent]
    });
  }
  return DxoShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoShutterComponent = /*#__PURE__*/(() => {
  class DxoShutterComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shutter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoShutterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShutterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoShutterComponent,
      selectors: [["dxo-shutter"]],
      inputs: {
        color: "color",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoShutterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoShutterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoShutterModule = /*#__PURE__*/(() => {
  class DxoShutterModule {
    /** @nocollapse */static ɵfac = function DxoShutterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoShutterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoShutterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoShutterComponent]
    });
  }
  return DxoShutterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSizeComponent = /*#__PURE__*/(() => {
  class DxoSizeComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'size';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSizeComponent,
      selectors: [["dxo-size"]],
      inputs: {
        height: "height",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSizeModule = /*#__PURE__*/(() => {
  class DxoSizeModule {
    /** @nocollapse */static ɵfac = function DxoSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSizeComponent]
    });
  }
  return DxoSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSliderHandleComponent = /*#__PURE__*/(() => {
  class DxoSliderHandleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'sliderHandle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSliderHandleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSliderHandleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSliderHandleComponent,
      selectors: [["dxo-slider-handle"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSliderHandleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSliderHandleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSliderHandleModule = /*#__PURE__*/(() => {
  class DxoSliderHandleModule {
    /** @nocollapse */static ɵfac = function DxoSliderHandleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSliderHandleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSliderHandleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSliderHandleComponent]
    });
  }
  return DxoSliderHandleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSliderMarkerComponent = /*#__PURE__*/(() => {
  class DxoSliderMarkerComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get invalidRangeColor() {
      return this._getOption('invalidRangeColor');
    }
    set invalidRangeColor(value) {
      this._setOption('invalidRangeColor', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get placeholderHeight() {
      return this._getOption('placeholderHeight');
    }
    set placeholderHeight(value) {
      this._setOption('placeholderHeight', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'sliderMarker';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSliderMarkerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSliderMarkerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSliderMarkerComponent,
      selectors: [["dxo-slider-marker"]],
      inputs: {
        color: "color",
        customizeText: "customizeText",
        font: "font",
        format: "format",
        invalidRangeColor: "invalidRangeColor",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        placeholderHeight: "placeholderHeight",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSliderMarkerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSliderMarkerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSliderMarkerModule = /*#__PURE__*/(() => {
  class DxoSliderMarkerModule {
    /** @nocollapse */static ɵfac = function DxoSliderMarkerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSliderMarkerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSliderMarkerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSliderMarkerComponent]
    });
  }
  return DxoSliderMarkerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSmallValuesGroupingComponent = /*#__PURE__*/(() => {
  class DxoSmallValuesGroupingComponent extends NestedOption {
    get groupName() {
      return this._getOption('groupName');
    }
    set groupName(value) {
      this._setOption('groupName', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get threshold() {
      return this._getOption('threshold');
    }
    set threshold(value) {
      this._setOption('threshold', value);
    }
    get topCount() {
      return this._getOption('topCount');
    }
    set topCount(value) {
      this._setOption('topCount', value);
    }
    get _optionPath() {
      return 'smallValuesGrouping';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSmallValuesGroupingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSmallValuesGroupingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSmallValuesGroupingComponent,
      selectors: [["dxo-small-values-grouping"]],
      inputs: {
        groupName: "groupName",
        mode: "mode",
        threshold: "threshold",
        topCount: "topCount"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSmallValuesGroupingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSmallValuesGroupingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSmallValuesGroupingModule = /*#__PURE__*/(() => {
  class DxoSmallValuesGroupingModule {
    /** @nocollapse */static ɵfac = function DxoSmallValuesGroupingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSmallValuesGroupingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSmallValuesGroupingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSmallValuesGroupingComponent]
    });
  }
  return DxoSmallValuesGroupingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSortByGroupSummaryInfoComponent = /*#__PURE__*/(() => {
  class DxiSortByGroupSummaryInfoComponent extends CollectionNestedOption {
    get groupColumn() {
      return this._getOption('groupColumn');
    }
    set groupColumn(value) {
      this._setOption('groupColumn', value);
    }
    get sortOrder() {
      return this._getOption('sortOrder');
    }
    set sortOrder(value) {
      this._setOption('sortOrder', value);
    }
    get summaryItem() {
      return this._getOption('summaryItem');
    }
    set summaryItem(value) {
      this._setOption('summaryItem', value);
    }
    get _optionPath() {
      return 'sortByGroupSummaryInfo';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSortByGroupSummaryInfoComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSortByGroupSummaryInfoComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSortByGroupSummaryInfoComponent,
      selectors: [["dxi-sort-by-group-summary-info"]],
      inputs: {
        groupColumn: "groupColumn",
        sortOrder: "sortOrder",
        summaryItem: "summaryItem"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_sortByGroupSummaryInfo,
        useExisting: DxiSortByGroupSummaryInfoComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiSortByGroupSummaryInfoComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiSortByGroupSummaryInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSortByGroupSummaryInfoModule = /*#__PURE__*/(() => {
  class DxiSortByGroupSummaryInfoModule {
    /** @nocollapse */static ɵfac = function DxiSortByGroupSummaryInfoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSortByGroupSummaryInfoModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSortByGroupSummaryInfoModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiSortByGroupSummaryInfoComponent]
    });
  }
  return DxiSortByGroupSummaryInfoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSorting = /*#__PURE__*/(() => {
  class DxoSorting extends NestedOption {
    get ascendingText() {
      return this._getOption('ascendingText');
    }
    set ascendingText(value) {
      this._setOption('ascendingText', value);
    }
    get clearText() {
      return this._getOption('clearText');
    }
    set clearText(value) {
      this._setOption('clearText', value);
    }
    get descendingText() {
      return this._getOption('descendingText');
    }
    set descendingText(value) {
      this._setOption('descendingText', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get showSortIndexes() {
      return this._getOption('showSortIndexes');
    }
    set showSortIndexes(value) {
      this._setOption('showSortIndexes', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoSorting_BaseFactory;
      return function DxoSorting_Factory(__ngFactoryType__) {
        return (ɵDxoSorting_BaseFactory || (ɵDxoSorting_BaseFactory = i0.ɵɵgetInheritedFactory(DxoSorting)))(__ngFactoryType__ || DxoSorting);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSorting,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSorting_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSorting;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSortingComponent = /*#__PURE__*/(() => {
  class DxoSortingComponent extends DxoSorting {
    get _optionPath() {
      return 'sorting';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSortingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSortingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSortingComponent,
      selectors: [["dxo-sorting"]],
      inputs: {
        ascendingText: "ascendingText",
        clearText: "clearText",
        descendingText: "descendingText",
        mode: "mode",
        showSortIndexes: "showSortIndexes"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSortingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSortingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSortingModule = /*#__PURE__*/(() => {
  class DxoSortingModule {
    /** @nocollapse */static ɵfac = function DxoSortingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSortingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSortingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSortingComponent]
    });
  }
  return DxoSortingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSourceComponent = /*#__PURE__*/(() => {
  class DxoSourceComponent extends NestedOption {
    get grouping() {
      return this._getOption('grouping');
    }
    set grouping(value) {
      this._setOption('grouping', value);
    }
    get layer() {
      return this._getOption('layer');
    }
    set layer(value) {
      this._setOption('layer', value);
    }
    get _optionPath() {
      return 'source';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSourceComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSourceComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSourceComponent,
      selectors: [["dxo-source"]],
      inputs: {
        grouping: "grouping",
        layer: "layer"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSourceComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSourceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSourceModule = /*#__PURE__*/(() => {
  class DxoSourceModule {
    /** @nocollapse */static ɵfac = function DxoSourceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSourceModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSourceModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSourceComponent]
    });
  }
  return DxoSourceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSplineComponent = /*#__PURE__*/(() => {
  class DxoSplineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'spline';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSplineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSplineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSplineComponent,
      selectors: [["dxo-spline"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSplineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSplineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSplineModule = /*#__PURE__*/(() => {
  class DxoSplineModule {
    /** @nocollapse */static ɵfac = function DxoSplineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSplineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSplineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSplineComponent]
    });
  }
  return DxoSplineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSplineareaComponent = /*#__PURE__*/(() => {
  class DxoSplineareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'splinearea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSplineareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSplineareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSplineareaComponent,
      selectors: [["dxo-splinearea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSplineareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSplineareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSplineareaModule = /*#__PURE__*/(() => {
  class DxoSplineareaModule {
    /** @nocollapse */static ɵfac = function DxoSplineareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSplineareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSplineareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSplineareaComponent]
    });
  }
  return DxoSplineareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSplitterOptions = /*#__PURE__*/(() => {
  class DxoSplitterOptions extends NestedOption {
    get allowKeyboardNavigation() {
      return this._getOption('allowKeyboardNavigation');
    }
    set allowKeyboardNavigation(value) {
      this._setOption('allowKeyboardNavigation', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get itemTemplate() {
      return this._getOption('itemTemplate');
    }
    set itemTemplate(value) {
      this._setOption('itemTemplate', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onItemClick() {
      return this._getOption('onItemClick');
    }
    set onItemClick(value) {
      this._setOption('onItemClick', value);
    }
    get onItemCollapsed() {
      return this._getOption('onItemCollapsed');
    }
    set onItemCollapsed(value) {
      this._setOption('onItemCollapsed', value);
    }
    get onItemContextMenu() {
      return this._getOption('onItemContextMenu');
    }
    set onItemContextMenu(value) {
      this._setOption('onItemContextMenu', value);
    }
    get onItemExpanded() {
      return this._getOption('onItemExpanded');
    }
    set onItemExpanded(value) {
      this._setOption('onItemExpanded', value);
    }
    get onItemRendered() {
      return this._getOption('onItemRendered');
    }
    set onItemRendered(value) {
      this._setOption('onItemRendered', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get separatorSize() {
      return this._getOption('separatorSize');
    }
    set separatorSize(value) {
      this._setOption('separatorSize', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoSplitterOptions_BaseFactory;
      return function DxoSplitterOptions_Factory(__ngFactoryType__) {
        return (ɵDxoSplitterOptions_BaseFactory || (ɵDxoSplitterOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoSplitterOptions)))(__ngFactoryType__ || DxoSplitterOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSplitterOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSplitterOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSplitterOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSplitterComponent = /*#__PURE__*/(() => {
  class DxoSplitterComponent extends DxoSplitterOptions {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemsChange;
    get _optionPath() {
      return 'splitter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'itemsChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSplitterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSplitterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSplitterComponent,
      selectors: [["dxo-splitter"]],
      contentQueries: function DxoSplitterComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        allowKeyboardNavigation: "allowKeyboardNavigation",
        dataSource: "dataSource",
        disabled: "disabled",
        elementAttr: "elementAttr",
        height: "height",
        hoverStateEnabled: "hoverStateEnabled",
        items: "items",
        itemTemplate: "itemTemplate",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onItemCollapsed: "onItemCollapsed",
        onItemContextMenu: "onItemContextMenu",
        onItemExpanded: "onItemExpanded",
        onItemRendered: "onItemRendered",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        orientation: "orientation",
        rtlEnabled: "rtlEnabled",
        separatorSize: "separatorSize",
        visible: "visible",
        width: "width"
      },
      outputs: {
        itemsChange: "itemsChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSplitterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSplitterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSplitterModule = /*#__PURE__*/(() => {
  class DxoSplitterModule {
    /** @nocollapse */static ɵfac = function DxoSplitterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSplitterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSplitterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSplitterComponent]
    });
  }
  return DxoSplitterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStackedareaComponent = /*#__PURE__*/(() => {
  class DxoStackedareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stackedarea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStackedareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStackedareaComponent,
      selectors: [["dxo-stackedarea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStackedareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStackedareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStackedareaModule = /*#__PURE__*/(() => {
  class DxoStackedareaModule {
    /** @nocollapse */static ɵfac = function DxoStackedareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStackedareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStackedareaComponent]
    });
  }
  return DxoStackedareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStackedbarComponent = /*#__PURE__*/(() => {
  class DxoStackedbarComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stackedbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStackedbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStackedbarComponent,
      selectors: [["dxo-stackedbar"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width",
        closed: "closed"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStackedbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStackedbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStackedbarModule = /*#__PURE__*/(() => {
  class DxoStackedbarModule {
    /** @nocollapse */static ɵfac = function DxoStackedbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStackedbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStackedbarComponent]
    });
  }
  return DxoStackedbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStackedlineComponent = /*#__PURE__*/(() => {
  class DxoStackedlineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stackedline';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStackedlineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedlineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStackedlineComponent,
      selectors: [["dxo-stackedline"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStackedlineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStackedlineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStackedlineModule = /*#__PURE__*/(() => {
  class DxoStackedlineModule {
    /** @nocollapse */static ɵfac = function DxoStackedlineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedlineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStackedlineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStackedlineComponent]
    });
  }
  return DxoStackedlineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStackedsplineComponent = /*#__PURE__*/(() => {
  class DxoStackedsplineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stackedspline';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStackedsplineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedsplineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStackedsplineComponent,
      selectors: [["dxo-stackedspline"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStackedsplineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStackedsplineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStackedsplineModule = /*#__PURE__*/(() => {
  class DxoStackedsplineModule {
    /** @nocollapse */static ɵfac = function DxoStackedsplineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedsplineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStackedsplineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStackedsplineComponent]
    });
  }
  return DxoStackedsplineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStackedsplineareaComponent = /*#__PURE__*/(() => {
  class DxoStackedsplineareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stackedsplinearea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStackedsplineareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedsplineareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStackedsplineareaComponent,
      selectors: [["dxo-stackedsplinearea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStackedsplineareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStackedsplineareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStackedsplineareaModule = /*#__PURE__*/(() => {
  class DxoStackedsplineareaModule {
    /** @nocollapse */static ɵfac = function DxoStackedsplineareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStackedsplineareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStackedsplineareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStackedsplineareaComponent]
    });
  }
  return DxoStackedsplineareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoStateStoringComponent = /*#__PURE__*/(() => {
  class DxoStateStoringComponent extends NestedOption {
    get customLoad() {
      return this._getOption('customLoad');
    }
    set customLoad(value) {
      this._setOption('customLoad', value);
    }
    get customSave() {
      return this._getOption('customSave');
    }
    set customSave(value) {
      this._setOption('customSave', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get savingTimeout() {
      return this._getOption('savingTimeout');
    }
    set savingTimeout(value) {
      this._setOption('savingTimeout', value);
    }
    get storageKey() {
      return this._getOption('storageKey');
    }
    set storageKey(value) {
      this._setOption('storageKey', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'stateStoring';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStateStoringComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStateStoringComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStateStoringComponent,
      selectors: [["dxo-state-storing"]],
      inputs: {
        customLoad: "customLoad",
        customSave: "customSave",
        enabled: "enabled",
        savingTimeout: "savingTimeout",
        storageKey: "storageKey",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStateStoringComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStateStoringComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStateStoringModule = /*#__PURE__*/(() => {
  class DxoStateStoringModule {
    /** @nocollapse */static ɵfac = function DxoStateStoringModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStateStoringModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStateStoringModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStateStoringComponent]
    });
  }
  return DxoStateStoringModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStepareaComponent = /*#__PURE__*/(() => {
  class DxoStepareaComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'steparea';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStepareaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStepareaComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStepareaComponent,
      selectors: [["dxo-steparea"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStepareaComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStepareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStepareaModule = /*#__PURE__*/(() => {
  class DxoStepareaModule {
    /** @nocollapse */static ɵfac = function DxoStepareaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStepareaModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStepareaModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStepareaComponent]
    });
  }
  return DxoStepareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSteplineComponent = /*#__PURE__*/(() => {
  class DxoSteplineComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stepline';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSteplineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSteplineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSteplineComponent,
      selectors: [["dxo-stepline"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSteplineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSteplineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSteplineModule = /*#__PURE__*/(() => {
  class DxoSteplineModule {
    /** @nocollapse */static ɵfac = function DxoSteplineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSteplineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSteplineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSteplineComponent]
    });
  }
  return DxoSteplineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoStockComponent = /*#__PURE__*/(() => {
  class DxoStockComponent extends DxoChartCommonSeriesSettings {
    get _optionPath() {
      return 'stock';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStockComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStockComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStockComponent,
      selectors: [["dxo-stock"]],
      inputs: {
        aggregation: "aggregation",
        area: "area",
        argumentField: "argumentField",
        axis: "axis",
        bar: "bar",
        barOverlapGroup: "barOverlapGroup",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        bubble: "bubble",
        candlestick: "candlestick",
        closeValueField: "closeValueField",
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        fullstackedarea: "fullstackedarea",
        fullstackedbar: "fullstackedbar",
        fullstackedline: "fullstackedline",
        fullstackedspline: "fullstackedspline",
        fullstackedsplinearea: "fullstackedsplinearea",
        highValueField: "highValueField",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        innerColor: "innerColor",
        label: "label",
        line: "line",
        lowValueField: "lowValueField",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        openValueField: "openValueField",
        pane: "pane",
        point: "point",
        rangearea: "rangearea",
        rangebar: "rangebar",
        rangeValue1Field: "rangeValue1Field",
        rangeValue2Field: "rangeValue2Field",
        reduction: "reduction",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        sizeField: "sizeField",
        spline: "spline",
        splinearea: "splinearea",
        stack: "stack",
        stackedarea: "stackedarea",
        stackedbar: "stackedbar",
        stackedline: "stackedline",
        stackedspline: "stackedspline",
        stackedsplinearea: "stackedsplinearea",
        steparea: "steparea",
        stepline: "stepline",
        stock: "stock",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStockComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStockComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStockModule = /*#__PURE__*/(() => {
  class DxoStockModule {
    /** @nocollapse */static ɵfac = function DxoStockModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStockModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStockModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStockComponent]
    });
  }
  return DxoStockModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiStripComponent = /*#__PURE__*/(() => {
  class DxiStripComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'strips';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiStripComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiStripComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiStripComponent,
      selectors: [["dxi-strip"]],
      inputs: {
        color: "color",
        endValue: "endValue",
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        startValue: "startValue"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_strips,
        useExisting: DxiStripComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiStripComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiStripComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiStripModule = /*#__PURE__*/(() => {
  class DxiStripModule {
    /** @nocollapse */static ɵfac = function DxiStripModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiStripModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiStripModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiStripComponent]
    });
  }
  return DxiStripModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiGanttStripLine = /*#__PURE__*/(() => {
  class DxiGanttStripLine extends CollectionNestedOption {
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get end() {
      return this._getOption('end');
    }
    set end(value) {
      this._setOption('end', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiGanttStripLine_BaseFactory;
      return function DxiGanttStripLine_Factory(__ngFactoryType__) {
        return (ɵDxiGanttStripLine_BaseFactory || (ɵDxiGanttStripLine_BaseFactory = i0.ɵɵgetInheritedFactory(DxiGanttStripLine)))(__ngFactoryType__ || DxiGanttStripLine);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiGanttStripLine,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiGanttStripLine_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiGanttStripLine;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiStripLineComponent = /*#__PURE__*/(() => {
  class DxiStripLineComponent extends DxiGanttStripLine {
    get _optionPath() {
      return 'stripLines';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiStripLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiStripLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiStripLineComponent,
      selectors: [["dxi-strip-line"]],
      inputs: {
        cssClass: "cssClass",
        end: "end",
        start: "start",
        title: "title"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_stripLines,
        useExisting: DxiStripLineComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiStripLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiStripLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiStripLineModule = /*#__PURE__*/(() => {
  class DxiStripLineModule {
    /** @nocollapse */static ɵfac = function DxiStripLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiStripLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiStripLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiStripLineComponent]
    });
  }
  return DxiStripLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoStripStyleComponent = /*#__PURE__*/(() => {
  class DxoStripStyleComponent extends NestedOption {
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get _optionPath() {
      return 'stripStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoStripStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStripStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoStripStyleComponent,
      selectors: [["dxo-strip-style"]],
      inputs: {
        label: "label",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoStripStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoStripStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoStripStyleModule = /*#__PURE__*/(() => {
  class DxoStripStyleModule {
    /** @nocollapse */static ɵfac = function DxoStripStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoStripStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoStripStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoStripStyleComponent]
    });
  }
  return DxoStripStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSubtitleComponent = /*#__PURE__*/(() => {
  class DxoSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSubtitleComponent,
      selectors: [["dxo-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSubtitleModule = /*#__PURE__*/(() => {
  class DxoSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSubtitleComponent]
    });
  }
  return DxoSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoGaugeIndicator = /*#__PURE__*/(() => {
  class DxoGaugeIndicator extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get baseValue() {
      return this._getOption('baseValue');
    }
    set baseValue(value) {
      this._setOption('baseValue', value);
    }
    get beginAdaptingAtRadius() {
      return this._getOption('beginAdaptingAtRadius');
    }
    set beginAdaptingAtRadius(value) {
      this._setOption('beginAdaptingAtRadius', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get indentFromCenter() {
      return this._getOption('indentFromCenter');
    }
    set indentFromCenter(value) {
      this._setOption('indentFromCenter', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get secondColor() {
      return this._getOption('secondColor');
    }
    set secondColor(value) {
      this._setOption('secondColor', value);
    }
    get secondFraction() {
      return this._getOption('secondFraction');
    }
    set secondFraction(value) {
      this._setOption('secondFraction', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get spindleGapSize() {
      return this._getOption('spindleGapSize');
    }
    set spindleGapSize(value) {
      this._setOption('spindleGapSize', value);
    }
    get spindleSize() {
      return this._getOption('spindleSize');
    }
    set spindleSize(value) {
      this._setOption('spindleSize', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoGaugeIndicator_BaseFactory;
      return function DxoGaugeIndicator_Factory(__ngFactoryType__) {
        return (ɵDxoGaugeIndicator_BaseFactory || (ɵDxoGaugeIndicator_BaseFactory = i0.ɵɵgetInheritedFactory(DxoGaugeIndicator)))(__ngFactoryType__ || DxoGaugeIndicator);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoGaugeIndicator,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoGaugeIndicator_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoGaugeIndicator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoSubvalueIndicatorComponent = /*#__PURE__*/(() => {
  class DxoSubvalueIndicatorComponent extends DxoGaugeIndicator {
    get _optionPath() {
      return 'subvalueIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSubvalueIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSubvalueIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSubvalueIndicatorComponent,
      selectors: [["dxo-subvalue-indicator"]],
      inputs: {
        arrowLength: "arrowLength",
        backgroundColor: "backgroundColor",
        baseValue: "baseValue",
        beginAdaptingAtRadius: "beginAdaptingAtRadius",
        color: "color",
        horizontalOrientation: "horizontalOrientation",
        indentFromCenter: "indentFromCenter",
        length: "length",
        offset: "offset",
        palette: "palette",
        secondColor: "secondColor",
        secondFraction: "secondFraction",
        size: "size",
        spindleGapSize: "spindleGapSize",
        spindleSize: "spindleSize",
        text: "text",
        type: "type",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSubvalueIndicatorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSubvalueIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSubvalueIndicatorModule = /*#__PURE__*/(() => {
  class DxoSubvalueIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoSubvalueIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSubvalueIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSubvalueIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSubvalueIndicatorComponent]
    });
  }
  return DxoSubvalueIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSummaryComponent = /*#__PURE__*/(() => {
  class DxoSummaryComponent extends NestedOption {
    set _groupItemsContentChildren(value) {
      this.setChildren('groupItems', value);
    }
    set _totalItemsContentChildren(value) {
      this.setChildren('totalItems', value);
    }
    get calculateCustomSummary() {
      return this._getOption('calculateCustomSummary');
    }
    set calculateCustomSummary(value) {
      this._setOption('calculateCustomSummary', value);
    }
    get groupItems() {
      return this._getOption('groupItems');
    }
    set groupItems(value) {
      this._setOption('groupItems', value);
    }
    get recalculateWhileEditing() {
      return this._getOption('recalculateWhileEditing');
    }
    set recalculateWhileEditing(value) {
      this._setOption('recalculateWhileEditing', value);
    }
    get skipEmptyValues() {
      return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value) {
      this._setOption('skipEmptyValues', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get totalItems() {
      return this._getOption('totalItems');
    }
    set totalItems(value) {
      this._setOption('totalItems', value);
    }
    get _optionPath() {
      return 'summary';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSummaryComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSummaryComponent,
      selectors: [["dxo-summary"]],
      contentQueries: function DxoSummaryComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groupItems, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_totalItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupItemsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._totalItemsContentChildren = _t);
        }
      },
      inputs: {
        calculateCustomSummary: "calculateCustomSummary",
        groupItems: "groupItems",
        recalculateWhileEditing: "recalculateWhileEditing",
        skipEmptyValues: "skipEmptyValues",
        texts: "texts",
        totalItems: "totalItems"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSummaryComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoSummaryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSummaryModule = /*#__PURE__*/(() => {
  class DxoSummaryModule {
    /** @nocollapse */static ɵfac = function DxoSummaryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSummaryModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSummaryModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoSummaryComponent]
    });
  }
  return DxoSummaryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiHtmlEditorImageUploadTabItem = /*#__PURE__*/(() => {
  class DxiHtmlEditorImageUploadTabItem extends CollectionNestedOption {
    get alignItemLabels() {
      return this._getOption('alignItemLabels');
    }
    set alignItemLabels(value) {
      this._setOption('alignItemLabels', value);
    }
    get badge() {
      return this._getOption('badge');
    }
    set badge(value) {
      this._setOption('badge', value);
    }
    get colCount() {
      return this._getOption('colCount');
    }
    set colCount(value) {
      this._setOption('colCount', value);
    }
    get colCountByScreen() {
      return this._getOption('colCountByScreen');
    }
    set colCountByScreen(value) {
      this._setOption('colCountByScreen', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get tabTemplate() {
      return this._getOption('tabTemplate');
    }
    set tabTemplate(value) {
      this._setOption('tabTemplate', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiHtmlEditorImageUploadTabItem_BaseFactory;
      return function DxiHtmlEditorImageUploadTabItem_Factory(__ngFactoryType__) {
        return (ɵDxiHtmlEditorImageUploadTabItem_BaseFactory || (ɵDxiHtmlEditorImageUploadTabItem_BaseFactory = i0.ɵɵgetInheritedFactory(DxiHtmlEditorImageUploadTabItem)))(__ngFactoryType__ || DxiHtmlEditorImageUploadTabItem);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiHtmlEditorImageUploadTabItem,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiHtmlEditorImageUploadTabItem_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiHtmlEditorImageUploadTabItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiTabComponent = /*#__PURE__*/(() => {
  class DxiTabComponent extends DxiHtmlEditorImageUploadTabItem {
    renderer;
    document;
    element;
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    set _groupsContentChildren(value) {
      this.setChildren('groups', value);
    }
    get _optionPath() {
      return 'tabs';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTabComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTabComponent,
      selectors: [["dxi-tab"]],
      contentQueries: function DxiTabComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groups, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupsContentChildren = _t);
        }
      },
      inputs: {
        alignItemLabels: "alignItemLabels",
        badge: "badge",
        colCount: "colCount",
        colCountByScreen: "colCountByScreen",
        disabled: "disabled",
        icon: "icon",
        items: "items",
        tabTemplate: "tabTemplate",
        template: "template",
        title: "title",
        commands: "commands",
        groups: "groups",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_tabs,
        useExisting: DxiTabComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiTabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTabModule = /*#__PURE__*/(() => {
  class DxiTabModule {
    /** @nocollapse */static ɵfac = function DxiTabModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTabModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTabModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiTabComponent]
    });
  }
  return DxiTabModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTabPanelOptions = /*#__PURE__*/(() => {
  class DxoTabPanelOptions extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get animationEnabled() {
      return this._getOption('animationEnabled');
    }
    set animationEnabled(value) {
      this._setOption('animationEnabled', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get iconPosition() {
      return this._getOption('iconPosition');
    }
    set iconPosition(value) {
      this._setOption('iconPosition', value);
    }
    get itemHoldTimeout() {
      return this._getOption('itemHoldTimeout');
    }
    set itemHoldTimeout(value) {
      this._setOption('itemHoldTimeout', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get itemTemplate() {
      return this._getOption('itemTemplate');
    }
    set itemTemplate(value) {
      this._setOption('itemTemplate', value);
    }
    get itemTitleTemplate() {
      return this._getOption('itemTitleTemplate');
    }
    set itemTitleTemplate(value) {
      this._setOption('itemTitleTemplate', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get loop() {
      return this._getOption('loop');
    }
    set loop(value) {
      this._setOption('loop', value);
    }
    get noDataText() {
      return this._getOption('noDataText');
    }
    set noDataText(value) {
      this._setOption('noDataText', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onItemClick() {
      return this._getOption('onItemClick');
    }
    set onItemClick(value) {
      this._setOption('onItemClick', value);
    }
    get onItemContextMenu() {
      return this._getOption('onItemContextMenu');
    }
    set onItemContextMenu(value) {
      this._setOption('onItemContextMenu', value);
    }
    get onItemHold() {
      return this._getOption('onItemHold');
    }
    set onItemHold(value) {
      this._setOption('onItemHold', value);
    }
    get onItemRendered() {
      return this._getOption('onItemRendered');
    }
    set onItemRendered(value) {
      this._setOption('onItemRendered', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onSelectionChanged() {
      return this._getOption('onSelectionChanged');
    }
    set onSelectionChanged(value) {
      this._setOption('onSelectionChanged', value);
    }
    get onSelectionChanging() {
      return this._getOption('onSelectionChanging');
    }
    set onSelectionChanging(value) {
      this._setOption('onSelectionChanging', value);
    }
    get onTitleClick() {
      return this._getOption('onTitleClick');
    }
    set onTitleClick(value) {
      this._setOption('onTitleClick', value);
    }
    get onTitleHold() {
      return this._getOption('onTitleHold');
    }
    set onTitleHold(value) {
      this._setOption('onTitleHold', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get repaintChangesOnly() {
      return this._getOption('repaintChangesOnly');
    }
    set repaintChangesOnly(value) {
      this._setOption('repaintChangesOnly', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get scrollByContent() {
      return this._getOption('scrollByContent');
    }
    set scrollByContent(value) {
      this._setOption('scrollByContent', value);
    }
    get scrollingEnabled() {
      return this._getOption('scrollingEnabled');
    }
    set scrollingEnabled(value) {
      this._setOption('scrollingEnabled', value);
    }
    get selectedIndex() {
      return this._getOption('selectedIndex');
    }
    set selectedIndex(value) {
      this._setOption('selectedIndex', value);
    }
    get selectedItem() {
      return this._getOption('selectedItem');
    }
    set selectedItem(value) {
      this._setOption('selectedItem', value);
    }
    get showNavButtons() {
      return this._getOption('showNavButtons');
    }
    set showNavButtons(value) {
      this._setOption('showNavButtons', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get swipeEnabled() {
      return this._getOption('swipeEnabled');
    }
    set swipeEnabled(value) {
      this._setOption('swipeEnabled', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get tabsPosition() {
      return this._getOption('tabsPosition');
    }
    set tabsPosition(value) {
      this._setOption('tabsPosition', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoTabPanelOptions_BaseFactory;
      return function DxoTabPanelOptions_Factory(__ngFactoryType__) {
        return (ɵDxoTabPanelOptions_BaseFactory || (ɵDxoTabPanelOptions_BaseFactory = i0.ɵɵgetInheritedFactory(DxoTabPanelOptions)))(__ngFactoryType__ || DxoTabPanelOptions);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTabPanelOptions,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTabPanelOptions_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTabPanelOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoTabPanelOptionsComponent = /*#__PURE__*/(() => {
  class DxoTabPanelOptionsComponent extends DxoTabPanelOptions {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedItemChange;
    get _optionPath() {
      return 'tabPanelOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'itemsChange'
      }, {
        emit: 'selectedIndexChange'
      }, {
        emit: 'selectedItemChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTabPanelOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTabPanelOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTabPanelOptionsComponent,
      selectors: [["dxo-tab-panel-options"]],
      contentQueries: function DxoTabPanelOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        animationEnabled: "animationEnabled",
        dataSource: "dataSource",
        deferRendering: "deferRendering",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        iconPosition: "iconPosition",
        itemHoldTimeout: "itemHoldTimeout",
        items: "items",
        itemTemplate: "itemTemplate",
        itemTitleTemplate: "itemTitleTemplate",
        keyExpr: "keyExpr",
        loop: "loop",
        noDataText: "noDataText",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onItemContextMenu: "onItemContextMenu",
        onItemHold: "onItemHold",
        onItemRendered: "onItemRendered",
        onOptionChanged: "onOptionChanged",
        onSelectionChanged: "onSelectionChanged",
        onSelectionChanging: "onSelectionChanging",
        onTitleClick: "onTitleClick",
        onTitleHold: "onTitleHold",
        onTitleRendered: "onTitleRendered",
        repaintChangesOnly: "repaintChangesOnly",
        rtlEnabled: "rtlEnabled",
        scrollByContent: "scrollByContent",
        scrollingEnabled: "scrollingEnabled",
        selectedIndex: "selectedIndex",
        selectedItem: "selectedItem",
        showNavButtons: "showNavButtons",
        stylingMode: "stylingMode",
        swipeEnabled: "swipeEnabled",
        tabIndex: "tabIndex",
        tabsPosition: "tabsPosition",
        visible: "visible",
        width: "width"
      },
      outputs: {
        itemsChange: "itemsChange",
        selectedIndexChange: "selectedIndexChange",
        selectedItemChange: "selectedItemChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTabPanelOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTabPanelOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTabPanelOptionsModule = /*#__PURE__*/(() => {
  class DxoTabPanelOptionsModule {
    /** @nocollapse */static ɵfac = function DxoTabPanelOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTabPanelOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTabPanelOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTabPanelOptionsComponent]
    });
  }
  return DxoTabPanelOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorTableContextMenu = /*#__PURE__*/(() => {
  class DxoHtmlEditorTableContextMenu extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoHtmlEditorTableContextMenu_BaseFactory;
      return function DxoHtmlEditorTableContextMenu_Factory(__ngFactoryType__) {
        return (ɵDxoHtmlEditorTableContextMenu_BaseFactory || (ɵDxoHtmlEditorTableContextMenu_BaseFactory = i0.ɵɵgetInheritedFactory(DxoHtmlEditorTableContextMenu)))(__ngFactoryType__ || DxoHtmlEditorTableContextMenu);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorTableContextMenu,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorTableContextMenu_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorTableContextMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoTableContextMenuComponent = /*#__PURE__*/(() => {
  class DxoTableContextMenuComponent extends DxoHtmlEditorTableContextMenu {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get _optionPath() {
      return 'tableContextMenu';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTableContextMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTableContextMenuComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTableContextMenuComponent,
      selectors: [["dxo-table-context-menu"]],
      contentQueries: function DxoTableContextMenuComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        enabled: "enabled",
        items: "items"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTableContextMenuComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTableContextMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTableContextMenuModule = /*#__PURE__*/(() => {
  class DxoTableContextMenuModule {
    /** @nocollapse */static ɵfac = function DxoTableContextMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTableContextMenuModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTableContextMenuModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTableContextMenuComponent]
    });
  }
  return DxoTableContextMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorTableResizing = /*#__PURE__*/(() => {
  class DxoHtmlEditorTableResizing extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get minColumnWidth() {
      return this._getOption('minColumnWidth');
    }
    set minColumnWidth(value) {
      this._setOption('minColumnWidth', value);
    }
    get minRowHeight() {
      return this._getOption('minRowHeight');
    }
    set minRowHeight(value) {
      this._setOption('minRowHeight', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoHtmlEditorTableResizing_BaseFactory;
      return function DxoHtmlEditorTableResizing_Factory(__ngFactoryType__) {
        return (ɵDxoHtmlEditorTableResizing_BaseFactory || (ɵDxoHtmlEditorTableResizing_BaseFactory = i0.ɵɵgetInheritedFactory(DxoHtmlEditorTableResizing)))(__ngFactoryType__ || DxoHtmlEditorTableResizing);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorTableResizing,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorTableResizing_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorTableResizing;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoTableResizingComponent = /*#__PURE__*/(() => {
  class DxoTableResizingComponent extends DxoHtmlEditorTableResizing {
    get _optionPath() {
      return 'tableResizing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTableResizingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTableResizingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTableResizingComponent,
      selectors: [["dxo-table-resizing"]],
      inputs: {
        enabled: "enabled",
        minColumnWidth: "minColumnWidth",
        minRowHeight: "minRowHeight"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTableResizingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTableResizingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTableResizingModule = /*#__PURE__*/(() => {
  class DxoTableResizingModule {
    /** @nocollapse */static ɵfac = function DxoTableResizingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTableResizingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTableResizingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTableResizingComponent]
    });
  }
  return DxoTableResizingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTasksComponent = /*#__PURE__*/(() => {
  class DxoTasksComponent extends NestedOption {
    get colorExpr() {
      return this._getOption('colorExpr');
    }
    set colorExpr(value) {
      this._setOption('colorExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get endExpr() {
      return this._getOption('endExpr');
    }
    set endExpr(value) {
      this._setOption('endExpr', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get parentIdExpr() {
      return this._getOption('parentIdExpr');
    }
    set parentIdExpr(value) {
      this._setOption('parentIdExpr', value);
    }
    get progressExpr() {
      return this._getOption('progressExpr');
    }
    set progressExpr(value) {
      this._setOption('progressExpr', value);
    }
    get startExpr() {
      return this._getOption('startExpr');
    }
    set startExpr(value) {
      this._setOption('startExpr', value);
    }
    get titleExpr() {
      return this._getOption('titleExpr');
    }
    set titleExpr(value) {
      this._setOption('titleExpr', value);
    }
    get _optionPath() {
      return 'tasks';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTasksComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTasksComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTasksComponent,
      selectors: [["dxo-tasks"]],
      inputs: {
        colorExpr: "colorExpr",
        dataSource: "dataSource",
        endExpr: "endExpr",
        keyExpr: "keyExpr",
        parentIdExpr: "parentIdExpr",
        progressExpr: "progressExpr",
        startExpr: "startExpr",
        titleExpr: "titleExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTasksComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTasksComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTasksModule = /*#__PURE__*/(() => {
  class DxoTasksModule {
    /** @nocollapse */static ɵfac = function DxoTasksModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTasksModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTasksModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTasksComponent]
    });
  }
  return DxoTasksModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTextComponent = /*#__PURE__*/(() => {
  class DxoTextComponent extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indent() {
      return this._getOption('indent');
    }
    set indent(value) {
      this._setOption('indent', value);
    }
    get _optionPath() {
      return 'text';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTextComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTextComponent,
      selectors: [["dxo-text"]],
      inputs: {
        customizeText: "customizeText",
        font: "font",
        format: "format",
        indent: "indent"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTextComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTextModule = /*#__PURE__*/(() => {
  class DxoTextModule {
    /** @nocollapse */static ɵfac = function DxoTextModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTextModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTextModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTextComponent]
    });
  }
  return DxoTextModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoFilterPanelTexts = /*#__PURE__*/(() => {
  class DxoFilterPanelTexts extends NestedOption {
    get fix() {
      return this._getOption('fix');
    }
    set fix(value) {
      this._setOption('fix', value);
    }
    get leftPosition() {
      return this._getOption('leftPosition');
    }
    set leftPosition(value) {
      this._setOption('leftPosition', value);
    }
    get rightPosition() {
      return this._getOption('rightPosition');
    }
    set rightPosition(value) {
      this._setOption('rightPosition', value);
    }
    get stickyPosition() {
      return this._getOption('stickyPosition');
    }
    set stickyPosition(value) {
      this._setOption('stickyPosition', value);
    }
    get unfix() {
      return this._getOption('unfix');
    }
    set unfix(value) {
      this._setOption('unfix', value);
    }
    get addRow() {
      return this._getOption('addRow');
    }
    set addRow(value) {
      this._setOption('addRow', value);
    }
    get cancelAllChanges() {
      return this._getOption('cancelAllChanges');
    }
    set cancelAllChanges(value) {
      this._setOption('cancelAllChanges', value);
    }
    get cancelRowChanges() {
      return this._getOption('cancelRowChanges');
    }
    set cancelRowChanges(value) {
      this._setOption('cancelRowChanges', value);
    }
    get confirmDeleteMessage() {
      return this._getOption('confirmDeleteMessage');
    }
    set confirmDeleteMessage(value) {
      this._setOption('confirmDeleteMessage', value);
    }
    get confirmDeleteTitle() {
      return this._getOption('confirmDeleteTitle');
    }
    set confirmDeleteTitle(value) {
      this._setOption('confirmDeleteTitle', value);
    }
    get deleteRow() {
      return this._getOption('deleteRow');
    }
    set deleteRow(value) {
      this._setOption('deleteRow', value);
    }
    get editRow() {
      return this._getOption('editRow');
    }
    set editRow(value) {
      this._setOption('editRow', value);
    }
    get saveAllChanges() {
      return this._getOption('saveAllChanges');
    }
    set saveAllChanges(value) {
      this._setOption('saveAllChanges', value);
    }
    get saveRowChanges() {
      return this._getOption('saveRowChanges');
    }
    set saveRowChanges(value) {
      this._setOption('saveRowChanges', value);
    }
    get undeleteRow() {
      return this._getOption('undeleteRow');
    }
    set undeleteRow(value) {
      this._setOption('undeleteRow', value);
    }
    get validationCancelChanges() {
      return this._getOption('validationCancelChanges');
    }
    set validationCancelChanges(value) {
      this._setOption('validationCancelChanges', value);
    }
    get exportAll() {
      return this._getOption('exportAll');
    }
    set exportAll(value) {
      this._setOption('exportAll', value);
    }
    get exportSelectedRows() {
      return this._getOption('exportSelectedRows');
    }
    set exportSelectedRows(value) {
      this._setOption('exportSelectedRows', value);
    }
    get exportTo() {
      return this._getOption('exportTo');
    }
    set exportTo(value) {
      this._setOption('exportTo', value);
    }
    get clearFilter() {
      return this._getOption('clearFilter');
    }
    set clearFilter(value) {
      this._setOption('clearFilter', value);
    }
    get createFilter() {
      return this._getOption('createFilter');
    }
    set createFilter(value) {
      this._setOption('createFilter', value);
    }
    get filterEnabledHint() {
      return this._getOption('filterEnabledHint');
    }
    set filterEnabledHint(value) {
      this._setOption('filterEnabledHint', value);
    }
    get groupByThisColumn() {
      return this._getOption('groupByThisColumn');
    }
    set groupByThisColumn(value) {
      this._setOption('groupByThisColumn', value);
    }
    get groupContinuedMessage() {
      return this._getOption('groupContinuedMessage');
    }
    set groupContinuedMessage(value) {
      this._setOption('groupContinuedMessage', value);
    }
    get groupContinuesMessage() {
      return this._getOption('groupContinuesMessage');
    }
    set groupContinuesMessage(value) {
      this._setOption('groupContinuesMessage', value);
    }
    get ungroup() {
      return this._getOption('ungroup');
    }
    set ungroup(value) {
      this._setOption('ungroup', value);
    }
    get ungroupAll() {
      return this._getOption('ungroupAll');
    }
    set ungroupAll(value) {
      this._setOption('ungroupAll', value);
    }
    get cancel() {
      return this._getOption('cancel');
    }
    set cancel(value) {
      this._setOption('cancel', value);
    }
    get emptyValue() {
      return this._getOption('emptyValue');
    }
    set emptyValue(value) {
      this._setOption('emptyValue', value);
    }
    get ok() {
      return this._getOption('ok');
    }
    set ok(value) {
      this._setOption('ok', value);
    }
    get avg() {
      return this._getOption('avg');
    }
    set avg(value) {
      this._setOption('avg', value);
    }
    get avgOtherColumn() {
      return this._getOption('avgOtherColumn');
    }
    set avgOtherColumn(value) {
      this._setOption('avgOtherColumn', value);
    }
    get count() {
      return this._getOption('count');
    }
    set count(value) {
      this._setOption('count', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get maxOtherColumn() {
      return this._getOption('maxOtherColumn');
    }
    set maxOtherColumn(value) {
      this._setOption('maxOtherColumn', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get minOtherColumn() {
      return this._getOption('minOtherColumn');
    }
    set minOtherColumn(value) {
      this._setOption('minOtherColumn', value);
    }
    get sum() {
      return this._getOption('sum');
    }
    set sum(value) {
      this._setOption('sum', value);
    }
    get sumOtherColumn() {
      return this._getOption('sumOtherColumn');
    }
    set sumOtherColumn(value) {
      this._setOption('sumOtherColumn', value);
    }
    get allFields() {
      return this._getOption('allFields');
    }
    set allFields(value) {
      this._setOption('allFields', value);
    }
    get columnFields() {
      return this._getOption('columnFields');
    }
    set columnFields(value) {
      this._setOption('columnFields', value);
    }
    get dataFields() {
      return this._getOption('dataFields');
    }
    set dataFields(value) {
      this._setOption('dataFields', value);
    }
    get filterFields() {
      return this._getOption('filterFields');
    }
    set filterFields(value) {
      this._setOption('filterFields', value);
    }
    get rowFields() {
      return this._getOption('rowFields');
    }
    set rowFields(value) {
      this._setOption('rowFields', value);
    }
    get columnFieldArea() {
      return this._getOption('columnFieldArea');
    }
    set columnFieldArea(value) {
      this._setOption('columnFieldArea', value);
    }
    get dataFieldArea() {
      return this._getOption('dataFieldArea');
    }
    set dataFieldArea(value) {
      this._setOption('dataFieldArea', value);
    }
    get filterFieldArea() {
      return this._getOption('filterFieldArea');
    }
    set filterFieldArea(value) {
      this._setOption('filterFieldArea', value);
    }
    get rowFieldArea() {
      return this._getOption('rowFieldArea');
    }
    set rowFieldArea(value) {
      this._setOption('rowFieldArea', value);
    }
    get collapseAll() {
      return this._getOption('collapseAll');
    }
    set collapseAll(value) {
      this._setOption('collapseAll', value);
    }
    get dataNotAvailable() {
      return this._getOption('dataNotAvailable');
    }
    set dataNotAvailable(value) {
      this._setOption('dataNotAvailable', value);
    }
    get expandAll() {
      return this._getOption('expandAll');
    }
    set expandAll(value) {
      this._setOption('expandAll', value);
    }
    get exportToExcel() {
      return this._getOption('exportToExcel');
    }
    set exportToExcel(value) {
      this._setOption('exportToExcel', value);
    }
    get grandTotal() {
      return this._getOption('grandTotal');
    }
    set grandTotal(value) {
      this._setOption('grandTotal', value);
    }
    get noData() {
      return this._getOption('noData');
    }
    set noData(value) {
      this._setOption('noData', value);
    }
    get removeAllSorting() {
      return this._getOption('removeAllSorting');
    }
    set removeAllSorting(value) {
      this._setOption('removeAllSorting', value);
    }
    get showFieldChooser() {
      return this._getOption('showFieldChooser');
    }
    set showFieldChooser(value) {
      this._setOption('showFieldChooser', value);
    }
    get sortColumnBySummary() {
      return this._getOption('sortColumnBySummary');
    }
    set sortColumnBySummary(value) {
      this._setOption('sortColumnBySummary', value);
    }
    get sortRowBySummary() {
      return this._getOption('sortRowBySummary');
    }
    set sortRowBySummary(value) {
      this._setOption('sortRowBySummary', value);
    }
    get total() {
      return this._getOption('total');
    }
    set total(value) {
      this._setOption('total', value);
    }
    get addRowToNode() {
      return this._getOption('addRowToNode');
    }
    set addRowToNode(value) {
      this._setOption('addRowToNode', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoFilterPanelTexts_BaseFactory;
      return function DxoFilterPanelTexts_Factory(__ngFactoryType__) {
        return (ɵDxoFilterPanelTexts_BaseFactory || (ɵDxoFilterPanelTexts_BaseFactory = i0.ɵɵgetInheritedFactory(DxoFilterPanelTexts)))(__ngFactoryType__ || DxoFilterPanelTexts);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoFilterPanelTexts,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoFilterPanelTexts_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoFilterPanelTexts;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoTextsComponent = /*#__PURE__*/(() => {
  class DxoTextsComponent extends DxoFilterPanelTexts {
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTextsComponent,
      selectors: [["dxo-texts"]],
      inputs: {
        fix: "fix",
        leftPosition: "leftPosition",
        rightPosition: "rightPosition",
        stickyPosition: "stickyPosition",
        unfix: "unfix",
        addRow: "addRow",
        cancelAllChanges: "cancelAllChanges",
        cancelRowChanges: "cancelRowChanges",
        confirmDeleteMessage: "confirmDeleteMessage",
        confirmDeleteTitle: "confirmDeleteTitle",
        deleteRow: "deleteRow",
        editRow: "editRow",
        saveAllChanges: "saveAllChanges",
        saveRowChanges: "saveRowChanges",
        undeleteRow: "undeleteRow",
        validationCancelChanges: "validationCancelChanges",
        exportAll: "exportAll",
        exportSelectedRows: "exportSelectedRows",
        exportTo: "exportTo",
        clearFilter: "clearFilter",
        createFilter: "createFilter",
        filterEnabledHint: "filterEnabledHint",
        groupByThisColumn: "groupByThisColumn",
        groupContinuedMessage: "groupContinuedMessage",
        groupContinuesMessage: "groupContinuesMessage",
        ungroup: "ungroup",
        ungroupAll: "ungroupAll",
        cancel: "cancel",
        emptyValue: "emptyValue",
        ok: "ok",
        avg: "avg",
        avgOtherColumn: "avgOtherColumn",
        count: "count",
        max: "max",
        maxOtherColumn: "maxOtherColumn",
        min: "min",
        minOtherColumn: "minOtherColumn",
        sum: "sum",
        sumOtherColumn: "sumOtherColumn",
        allFields: "allFields",
        columnFields: "columnFields",
        dataFields: "dataFields",
        filterFields: "filterFields",
        rowFields: "rowFields",
        columnFieldArea: "columnFieldArea",
        dataFieldArea: "dataFieldArea",
        filterFieldArea: "filterFieldArea",
        rowFieldArea: "rowFieldArea",
        collapseAll: "collapseAll",
        dataNotAvailable: "dataNotAvailable",
        expandAll: "expandAll",
        exportToExcel: "exportToExcel",
        grandTotal: "grandTotal",
        noData: "noData",
        removeAllSorting: "removeAllSorting",
        showFieldChooser: "showFieldChooser",
        sortColumnBySummary: "sortColumnBySummary",
        sortRowBySummary: "sortRowBySummary",
        total: "total",
        addRowToNode: "addRowToNode"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTextsModule = /*#__PURE__*/(() => {
  class DxoTextsModule {
    /** @nocollapse */static ɵfac = function DxoTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTextsComponent]
    });
  }
  return DxoTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTickIntervalComponent = /*#__PURE__*/(() => {
  class DxoTickIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'tickInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTickIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTickIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTickIntervalComponent,
      selectors: [["dxo-tick-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTickIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTickIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTickIntervalModule = /*#__PURE__*/(() => {
  class DxoTickIntervalModule {
    /** @nocollapse */static ɵfac = function DxoTickIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTickIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTickIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTickIntervalComponent]
    });
  }
  return DxoTickIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTickComponent = /*#__PURE__*/(() => {
  class DxoTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTickComponent,
      selectors: [["dxo-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTickModule = /*#__PURE__*/(() => {
  class DxoTickModule {
    /** @nocollapse */static ɵfac = function DxoTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTickComponent]
    });
  }
  return DxoTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTileComponent = /*#__PURE__*/(() => {
  class DxoTileComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get _optionPath() {
      return 'tile';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTileComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTileComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTileComponent,
      selectors: [["dxo-tile"]],
      inputs: {
        border: "border",
        color: "color",
        hoverStyle: "hoverStyle",
        label: "label",
        selectionStyle: "selectionStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTileComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTileModule = /*#__PURE__*/(() => {
  class DxoTileModule {
    /** @nocollapse */static ɵfac = function DxoTileModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTileModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTileModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTileComponent]
    });
  }
  return DxoTileModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTitleComponent = /*#__PURE__*/(() => {
  class DxoTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTitleComponent,
      selectors: [["dxo-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        verticalAlignment: "verticalAlignment",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap",
        alignment: "alignment"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTitleModule = /*#__PURE__*/(() => {
  class DxoTitleModule {
    /** @nocollapse */static ɵfac = function DxoTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTitleComponent]
    });
  }
  return DxoTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoToComponent = /*#__PURE__*/(() => {
  class DxoToComponent extends DxoAnimationState {
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoToComponent,
      selectors: [["dxo-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoToComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoToModule = /*#__PURE__*/(() => {
  class DxoToModule {
    /** @nocollapse */static ɵfac = function DxoToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoToComponent]
    });
  }
  return DxoToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPopupToolbarItem = /*#__PURE__*/(() => {
  class DxiPopupToolbarItem extends CollectionNestedOption {
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get toolbar() {
      return this._getOption('toolbar');
    }
    set toolbar(value) {
      this._setOption('toolbar', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiPopupToolbarItem_BaseFactory;
      return function DxiPopupToolbarItem_Factory(__ngFactoryType__) {
        return (ɵDxiPopupToolbarItem_BaseFactory || (ɵDxiPopupToolbarItem_BaseFactory = i0.ɵɵgetInheritedFactory(DxiPopupToolbarItem)))(__ngFactoryType__ || DxiPopupToolbarItem);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPopupToolbarItem,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiPopupToolbarItem_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiPopupToolbarItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiToolbarItemComponent extends DxiPopupToolbarItem {
    get _optionPath() {
      return 'toolbarItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiToolbarItemComponent,
      selectors: [["dxi-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        toolbar: "toolbar",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_toolbarItems,
        useExisting: DxiToolbarItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiToolbarItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiToolbarItemModule = /*#__PURE__*/(() => {
  class DxiToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiToolbarItemComponent]
    });
  }
  return DxiToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridToolbar = /*#__PURE__*/(() => {
  class DxoDataGridToolbar extends NestedOption {
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get fileSelectionItems() {
      return this._getOption('fileSelectionItems');
    }
    set fileSelectionItems(value) {
      this._setOption('fileSelectionItems', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get multiline() {
      return this._getOption('multiline');
    }
    set multiline(value) {
      this._setOption('multiline', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoDataGridToolbar_BaseFactory;
      return function DxoDataGridToolbar_Factory(__ngFactoryType__) {
        return (ɵDxoDataGridToolbar_BaseFactory || (ɵDxoDataGridToolbar_BaseFactory = i0.ɵɵgetInheritedFactory(DxoDataGridToolbar)))(__ngFactoryType__ || DxoDataGridToolbar);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridToolbar,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridToolbar_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoDataGridToolbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoToolbarComponent = /*#__PURE__*/(() => {
  class DxoToolbarComponent extends DxoDataGridToolbar {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    set _fileSelectionItemsContentChildren(value) {
      this.setChildren('fileSelectionItems', value);
    }
    get _optionPath() {
      return 'toolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoToolbarComponent,
      selectors: [["dxo-toolbar"]],
      contentQueries: function DxoToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_fileSelectionItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._fileSelectionItemsContentChildren = _t);
        }
      },
      inputs: {
        disabled: "disabled",
        items: "items",
        visible: "visible",
        fileSelectionItems: "fileSelectionItems",
        container: "container",
        multiline: "multiline"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoToolbarModule = /*#__PURE__*/(() => {
  class DxoToolbarModule {
    /** @nocollapse */static ɵfac = function DxoToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoToolbarComponent]
    });
  }
  return DxoToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoToolboxComponent = /*#__PURE__*/(() => {
  class DxoToolboxComponent extends NestedOption {
    set _groupsContentChildren(value) {
      this.setChildren('groups', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get shapeIconsPerRow() {
      return this._getOption('shapeIconsPerRow');
    }
    set shapeIconsPerRow(value) {
      this._setOption('shapeIconsPerRow', value);
    }
    get showSearch() {
      return this._getOption('showSearch');
    }
    set showSearch(value) {
      this._setOption('showSearch', value);
    }
    get visibility() {
      return this._getOption('visibility');
    }
    set visibility(value) {
      this._setOption('visibility', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'toolbox';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoToolboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoToolboxComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoToolboxComponent,
      selectors: [["dxo-toolbox"]],
      contentQueries: function DxoToolboxComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groups, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupsContentChildren = _t);
        }
      },
      inputs: {
        groups: "groups",
        shapeIconsPerRow: "shapeIconsPerRow",
        showSearch: "showSearch",
        visibility: "visibility",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoToolboxComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoToolboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoToolboxModule = /*#__PURE__*/(() => {
  class DxoToolboxModule {
    /** @nocollapse */static ɵfac = function DxoToolboxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoToolboxModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoToolboxModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoToolboxComponent]
    });
  }
  return DxoToolboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTooltipComponent = /*#__PURE__*/(() => {
  class DxoTooltipComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get interactive() {
      return this._getOption('interactive');
    }
    set interactive(value) {
      this._setOption('interactive', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get zIndex() {
      return this._getOption('zIndex');
    }
    set zIndex(value) {
      this._setOption('zIndex', value);
    }
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get shared() {
      return this._getOption('shared');
    }
    set shared(value) {
      this._setOption('shared', value);
    }
    get isShown() {
      return this._getOption('isShown');
    }
    set isShown(value) {
      this._setOption('isShown', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get showMode() {
      return this._getOption('showMode');
    }
    set showMode(value) {
      this._setOption('showMode', value);
    }
    get customizeLinkTooltip() {
      return this._getOption('customizeLinkTooltip');
    }
    set customizeLinkTooltip(value) {
      this._setOption('customizeLinkTooltip', value);
    }
    get customizeNodeTooltip() {
      return this._getOption('customizeNodeTooltip');
    }
    set customizeNodeTooltip(value) {
      this._setOption('customizeNodeTooltip', value);
    }
    get linkTooltipTemplate() {
      return this._getOption('linkTooltipTemplate');
    }
    set linkTooltipTemplate(value) {
      this._setOption('linkTooltipTemplate', value);
    }
    get nodeTooltipTemplate() {
      return this._getOption('nodeTooltipTemplate');
    }
    set nodeTooltipTemplate(value) {
      this._setOption('nodeTooltipTemplate', value);
    }
    get _optionPath() {
      return 'tooltip';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTooltipComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTooltipComponent,
      selectors: [["dxo-tooltip"]],
      inputs: {
        arrowLength: "arrowLength",
        border: "border",
        color: "color",
        container: "container",
        contentTemplate: "contentTemplate",
        cornerRadius: "cornerRadius",
        customizeTooltip: "customizeTooltip",
        enabled: "enabled",
        font: "font",
        format: "format",
        interactive: "interactive",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        shadow: "shadow",
        zIndex: "zIndex",
        argumentFormat: "argumentFormat",
        location: "location",
        shared: "shared",
        isShown: "isShown",
        text: "text",
        position: "position",
        showMode: "showMode",
        customizeLinkTooltip: "customizeLinkTooltip",
        customizeNodeTooltip: "customizeNodeTooltip",
        linkTooltipTemplate: "linkTooltipTemplate",
        nodeTooltipTemplate: "nodeTooltipTemplate"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTooltipComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTooltipModule = /*#__PURE__*/(() => {
  class DxoTooltipModule {
    /** @nocollapse */static ɵfac = function DxoTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTooltipModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTooltipModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoTooltipComponent]
    });
  }
  return DxoTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiTotalItemComponent = /*#__PURE__*/(() => {
  class DxiTotalItemComponent extends CollectionNestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get column() {
      return this._getOption('column');
    }
    set column(value) {
      this._setOption('column', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get showInColumn() {
      return this._getOption('showInColumn');
    }
    set showInColumn(value) {
      this._setOption('showInColumn', value);
    }
    get skipEmptyValues() {
      return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value) {
      this._setOption('skipEmptyValues', value);
    }
    get summaryType() {
      return this._getOption('summaryType');
    }
    set summaryType(value) {
      this._setOption('summaryType', value);
    }
    get valueFormat() {
      return this._getOption('valueFormat');
    }
    set valueFormat(value) {
      this._setOption('valueFormat', value);
    }
    get _optionPath() {
      return 'totalItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTotalItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTotalItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTotalItemComponent,
      selectors: [["dxi-total-item"]],
      inputs: {
        alignment: "alignment",
        column: "column",
        cssClass: "cssClass",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        name: "name",
        showInColumn: "showInColumn",
        skipEmptyValues: "skipEmptyValues",
        summaryType: "summaryType",
        valueFormat: "valueFormat"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_totalItems,
        useExisting: DxiTotalItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiTotalItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiTotalItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTotalItemModule = /*#__PURE__*/(() => {
  class DxiTotalItemModule {
    /** @nocollapse */static ɵfac = function DxiTotalItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTotalItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTotalItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiTotalItemComponent]
    });
  }
  return DxiTotalItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiUser = /*#__PURE__*/(() => {
  class DxiUser extends CollectionNestedOption {
    get avatarAlt() {
      return this._getOption('avatarAlt');
    }
    set avatarAlt(value) {
      this._setOption('avatarAlt', value);
    }
    get avatarUrl() {
      return this._getOption('avatarUrl');
    }
    set avatarUrl(value) {
      this._setOption('avatarUrl', value);
    }
    get id() {
      return this._getOption('id');
    }
    set id(value) {
      this._setOption('id', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxiUser_BaseFactory;
      return function DxiUser_Factory(__ngFactoryType__) {
        return (ɵDxiUser_BaseFactory || (ɵDxiUser_BaseFactory = i0.ɵɵgetInheritedFactory(DxiUser)))(__ngFactoryType__ || DxiUser);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiUser,
      selectors: [["base-dxi-user"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiUser_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiUser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxiTypingUserComponent = /*#__PURE__*/(() => {
  class DxiTypingUserComponent extends DxiUser {
    get _optionPath() {
      return 'typingUsers';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTypingUserComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTypingUserComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTypingUserComponent,
      selectors: [["dxi-typing-user"]],
      inputs: {
        avatarAlt: "avatarAlt",
        avatarUrl: "avatarUrl",
        id: "id",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_typingUsers,
        useExisting: DxiTypingUserComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiTypingUserComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiTypingUserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTypingUserModule = /*#__PURE__*/(() => {
  class DxiTypingUserModule {
    /** @nocollapse */static ɵfac = function DxiTypingUserModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTypingUserModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTypingUserModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiTypingUserComponent]
    });
  }
  return DxiTypingUserModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoUploadComponent = /*#__PURE__*/(() => {
  class DxoUploadComponent extends NestedOption {
    get chunkSize() {
      return this._getOption('chunkSize');
    }
    set chunkSize(value) {
      this._setOption('chunkSize', value);
    }
    get maxFileSize() {
      return this._getOption('maxFileSize');
    }
    set maxFileSize(value) {
      this._setOption('maxFileSize', value);
    }
    get _optionPath() {
      return 'upload';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoUploadComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoUploadComponent,
      selectors: [["dxo-upload"]],
      inputs: {
        chunkSize: "chunkSize",
        maxFileSize: "maxFileSize"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoUploadComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoUploadModule = /*#__PURE__*/(() => {
  class DxoUploadModule {
    /** @nocollapse */static ɵfac = function DxoUploadModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoUploadModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoUploadModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoUploadComponent]
    });
  }
  return DxoUploadModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoUrlComponent = /*#__PURE__*/(() => {
  class DxoUrlComponent extends NestedOption {
    get rangeMaxPoint() {
      return this._getOption('rangeMaxPoint');
    }
    set rangeMaxPoint(value) {
      this._setOption('rangeMaxPoint', value);
    }
    get rangeMinPoint() {
      return this._getOption('rangeMinPoint');
    }
    set rangeMinPoint(value) {
      this._setOption('rangeMinPoint', value);
    }
    get _optionPath() {
      return 'url';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoUrlComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoUrlComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoUrlComponent,
      selectors: [["dxo-url"]],
      inputs: {
        rangeMaxPoint: "rangeMaxPoint",
        rangeMinPoint: "rangeMinPoint"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoUrlComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoUrlComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoUrlModule = /*#__PURE__*/(() => {
  class DxoUrlModule {
    /** @nocollapse */static ɵfac = function DxoUrlModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoUrlModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoUrlModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoUrlComponent]
    });
  }
  return DxoUrlModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoUserComponent = /*#__PURE__*/(() => {
  class DxoUserComponent extends DxoUser {
    get _optionPath() {
      return 'user';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoUserComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoUserComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoUserComponent,
      selectors: [["dxo-user"]],
      inputs: {
        avatarAlt: "avatarAlt",
        avatarUrl: "avatarUrl",
        id: "id",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoUserComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoUserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoUserModule = /*#__PURE__*/(() => {
  class DxoUserModule {
    /** @nocollapse */static ɵfac = function DxoUserModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoUserModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoUserModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoUserComponent]
    });
  }
  return DxoUserModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidationRuleComponent = /*#__PURE__*/(() => {
  class DxiValidationRuleComponent extends CollectionNestedOption {
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get comparisonTarget() {
      return this._getOption('comparisonTarget');
    }
    set comparisonTarget(value) {
      this._setOption('comparisonTarget', value);
    }
    get comparisonType() {
      return this._getOption('comparisonType');
    }
    set comparisonType(value) {
      this._setOption('comparisonType', value);
    }
    get pattern() {
      return this._getOption('pattern');
    }
    set pattern(value) {
      this._setOption('pattern', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidationRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidationRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidationRuleComponent,
      selectors: [["dxi-validation-rule"]],
      inputs: {
        message: "message",
        trim: "trim",
        type: "type",
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        min: "min",
        reevaluate: "reevaluate",
        validationCallback: "validationCallback",
        comparisonTarget: "comparisonTarget",
        comparisonType: "comparisonType",
        pattern: "pattern"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidationRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidationRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidationRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidationRuleModule = /*#__PURE__*/(() => {
  class DxiValidationRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidationRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidationRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidationRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidationRuleComponent]
    });
  }
  return DxiValidationRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoValidationComponent = /*#__PURE__*/(() => {
  class DxoValidationComponent extends NestedOption {
    get autoUpdateParentTasks() {
      return this._getOption('autoUpdateParentTasks');
    }
    set autoUpdateParentTasks(value) {
      this._setOption('autoUpdateParentTasks', value);
    }
    get enablePredecessorGap() {
      return this._getOption('enablePredecessorGap');
    }
    set enablePredecessorGap(value) {
      this._setOption('enablePredecessorGap', value);
    }
    get validateDependencies() {
      return this._getOption('validateDependencies');
    }
    set validateDependencies(value) {
      this._setOption('validateDependencies', value);
    }
    get _optionPath() {
      return 'validation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoValidationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValidationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoValidationComponent,
      selectors: [["dxo-validation"]],
      inputs: {
        autoUpdateParentTasks: "autoUpdateParentTasks",
        enablePredecessorGap: "enablePredecessorGap",
        validateDependencies: "validateDependencies"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoValidationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoValidationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoValidationModule = /*#__PURE__*/(() => {
  class DxoValidationModule {
    /** @nocollapse */static ɵfac = function DxoValidationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValidationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoValidationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoValidationComponent]
    });
  }
  return DxoValidationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValueAxisComponent = /*#__PURE__*/(() => {
  class DxiValueAxisComponent extends CollectionNestedOption {
    set _breaksContentChildren(value) {
      this.setChildren('breaks', value);
    }
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get aggregatedPointsPosition() {
      return this._getOption('aggregatedPointsPosition');
    }
    set aggregatedPointsPosition(value) {
      this._setOption('aggregatedPointsPosition', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get autoBreaksEnabled() {
      return this._getOption('autoBreaksEnabled');
    }
    set autoBreaksEnabled(value) {
      this._setOption('autoBreaksEnabled', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get breaks() {
      return this._getOption('breaks');
    }
    set breaks(value) {
      this._setOption('breaks', value);
    }
    get breakStyle() {
      return this._getOption('breakStyle');
    }
    set breakStyle(value) {
      this._setOption('breakStyle', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get customPosition() {
      return this._getOption('customPosition');
    }
    set customPosition(value) {
      this._setOption('customPosition', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get maxAutoBreakCount() {
      return this._getOption('maxAutoBreakCount');
    }
    set maxAutoBreakCount(value) {
      this._setOption('maxAutoBreakCount', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get minVisualRangeLength() {
      return this._getOption('minVisualRangeLength');
    }
    set minVisualRangeLength(value) {
      this._setOption('minVisualRangeLength', value);
    }
    get multipleAxesSpacing() {
      return this._getOption('multipleAxesSpacing');
    }
    set multipleAxesSpacing(value) {
      this._setOption('multipleAxesSpacing', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get pane() {
      return this._getOption('pane');
    }
    set pane(value) {
      this._setOption('pane', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get showZero() {
      return this._getOption('showZero');
    }
    set showZero(value) {
      this._setOption('showZero', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get synchronizedValue() {
      return this._getOption('synchronizedValue');
    }
    set synchronizedValue(value) {
      this._setOption('synchronizedValue', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get valueType() {
      return this._getOption('valueType');
    }
    set valueType(value) {
      this._setOption('valueType', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visualRange() {
      return this._getOption('visualRange');
    }
    set visualRange(value) {
      this._setOption('visualRange', value);
    }
    get visualRangeUpdateMode() {
      return this._getOption('visualRangeUpdateMode');
    }
    set visualRangeUpdateMode(value) {
      this._setOption('visualRangeUpdateMode', value);
    }
    get wholeRange() {
      return this._getOption('wholeRange');
    }
    set wholeRange(value) {
      this._setOption('wholeRange', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    categoriesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visualRangeChange;
    get _optionPath() {
      return 'valueAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'categoriesChange'
      }, {
        emit: 'visualRangeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValueAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValueAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValueAxisComponent,
      selectors: [["dxi-value-axis"]],
      contentQueries: function DxiValueAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_breaks, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._breaksContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        aggregatedPointsPosition: "aggregatedPointsPosition",
        allowDecimals: "allowDecimals",
        autoBreaksEnabled: "autoBreaksEnabled",
        axisDivisionFactor: "axisDivisionFactor",
        breaks: "breaks",
        breakStyle: "breakStyle",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        customPosition: "customPosition",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        maxAutoBreakCount: "maxAutoBreakCount",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        minValueMargin: "minValueMargin",
        minVisualRangeLength: "minVisualRangeLength",
        multipleAxesSpacing: "multipleAxesSpacing",
        name: "name",
        offset: "offset",
        opacity: "opacity",
        pane: "pane",
        placeholderSize: "placeholderSize",
        position: "position",
        showZero: "showZero",
        strips: "strips",
        stripStyle: "stripStyle",
        synchronizedValue: "synchronizedValue",
        tick: "tick",
        tickInterval: "tickInterval",
        title: "title",
        type: "type",
        valueMarginsEnabled: "valueMarginsEnabled",
        valueType: "valueType",
        visible: "visible",
        visualRange: "visualRange",
        visualRangeUpdateMode: "visualRangeUpdateMode",
        wholeRange: "wholeRange",
        width: "width"
      },
      outputs: {
        categoriesChange: "categoriesChange",
        visualRangeChange: "visualRangeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_valueAxis,
        useExisting: DxiValueAxisComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValueAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValueAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValueAxisModule = /*#__PURE__*/(() => {
  class DxiValueAxisModule {
    /** @nocollapse */static ɵfac = function DxiValueAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValueAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValueAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValueAxisComponent]
    });
  }
  return DxiValueAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoValueAxisComponent = /*#__PURE__*/(() => {
  class DxoValueAxisComponent extends NestedOption {
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get minVisualRangeLength() {
      return this._getOption('minVisualRangeLength');
    }
    set minVisualRangeLength(value) {
      this._setOption('minVisualRangeLength', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get showZero() {
      return this._getOption('showZero');
    }
    set showZero(value) {
      this._setOption('showZero', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get valueType() {
      return this._getOption('valueType');
    }
    set valueType(value) {
      this._setOption('valueType', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visualRange() {
      return this._getOption('visualRange');
    }
    set visualRange(value) {
      this._setOption('visualRange', value);
    }
    get visualRangeUpdateMode() {
      return this._getOption('visualRangeUpdateMode');
    }
    set visualRangeUpdateMode(value) {
      this._setOption('visualRangeUpdateMode', value);
    }
    get wholeRange() {
      return this._getOption('wholeRange');
    }
    set wholeRange(value) {
      this._setOption('wholeRange', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visualRangeChange;
    get _optionPath() {
      return 'valueAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'visualRangeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoValueAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoValueAxisComponent,
      selectors: [["dxo-value-axis"]],
      contentQueries: function DxoValueAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        allowDecimals: "allowDecimals",
        axisDivisionFactor: "axisDivisionFactor",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        minValueMargin: "minValueMargin",
        minVisualRangeLength: "minVisualRangeLength",
        opacity: "opacity",
        showZero: "showZero",
        strips: "strips",
        stripStyle: "stripStyle",
        tick: "tick",
        tickInterval: "tickInterval",
        type: "type",
        valueMarginsEnabled: "valueMarginsEnabled",
        valueType: "valueType",
        visible: "visible",
        visualRange: "visualRange",
        visualRangeUpdateMode: "visualRangeUpdateMode",
        wholeRange: "wholeRange",
        width: "width",
        max: "max",
        min: "min"
      },
      outputs: {
        visualRangeChange: "visualRangeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoValueAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoValueAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoValueAxisModule = /*#__PURE__*/(() => {
  class DxoValueAxisModule {
    /** @nocollapse */static ɵfac = function DxoValueAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoValueAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoValueAxisComponent]
    });
  }
  return DxoValueAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoValueErrorBarComponent = /*#__PURE__*/(() => {
  class DxoValueErrorBarComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get edgeLength() {
      return this._getOption('edgeLength');
    }
    set edgeLength(value) {
      this._setOption('edgeLength', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get lineWidth() {
      return this._getOption('lineWidth');
    }
    set lineWidth(value) {
      this._setOption('lineWidth', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get _optionPath() {
      return 'valueErrorBar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoValueErrorBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueErrorBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoValueErrorBarComponent,
      selectors: [["dxo-value-error-bar"]],
      inputs: {
        color: "color",
        displayMode: "displayMode",
        edgeLength: "edgeLength",
        highValueField: "highValueField",
        lineWidth: "lineWidth",
        lowValueField: "lowValueField",
        opacity: "opacity",
        type: "type",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoValueErrorBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoValueErrorBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoValueErrorBarModule = /*#__PURE__*/(() => {
  class DxoValueErrorBarModule {
    /** @nocollapse */static ɵfac = function DxoValueErrorBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueErrorBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoValueErrorBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoValueErrorBarComponent]
    });
  }
  return DxoValueErrorBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoValueFormatComponent = /*#__PURE__*/(() => {
  class DxoValueFormatComponent extends DxoFormat {
    get _optionPath() {
      return 'valueFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoValueFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoValueFormatComponent,
      selectors: [["dxo-value-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoValueFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoValueFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoValueFormatModule = /*#__PURE__*/(() => {
  class DxoValueFormatModule {
    /** @nocollapse */static ɵfac = function DxoValueFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoValueFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoValueFormatComponent]
    });
  }
  return DxoValueFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoValueIndicatorComponent = /*#__PURE__*/(() => {
  class DxoValueIndicatorComponent extends DxoGaugeIndicator {
    get _optionPath() {
      return 'valueIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoValueIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoValueIndicatorComponent,
      selectors: [["dxo-value-indicator"]],
      inputs: {
        arrowLength: "arrowLength",
        backgroundColor: "backgroundColor",
        baseValue: "baseValue",
        beginAdaptingAtRadius: "beginAdaptingAtRadius",
        color: "color",
        horizontalOrientation: "horizontalOrientation",
        indentFromCenter: "indentFromCenter",
        length: "length",
        offset: "offset",
        palette: "palette",
        secondColor: "secondColor",
        secondFraction: "secondFraction",
        size: "size",
        spindleGapSize: "spindleGapSize",
        spindleSize: "spindleSize",
        text: "text",
        type: "type",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoValueIndicatorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoValueIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoValueIndicatorModule = /*#__PURE__*/(() => {
  class DxoValueIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoValueIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValueIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoValueIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoValueIndicatorComponent]
    });
  }
  return DxoValueIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoHtmlEditorVariables = /*#__PURE__*/(() => {
  class DxoHtmlEditorVariables extends NestedOption {
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get escapeChar() {
      return this._getOption('escapeChar');
    }
    set escapeChar(value) {
      this._setOption('escapeChar', value);
    }
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDxoHtmlEditorVariables_BaseFactory;
      return function DxoHtmlEditorVariables_Factory(__ngFactoryType__) {
        return (ɵDxoHtmlEditorVariables_BaseFactory || (ɵDxoHtmlEditorVariables_BaseFactory = i0.ɵɵgetInheritedFactory(DxoHtmlEditorVariables)))(__ngFactoryType__ || DxoHtmlEditorVariables);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoHtmlEditorVariables,
      selectors: [["ng-component"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoHtmlEditorVariables_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoHtmlEditorVariables;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
let DxoVariablesComponent = /*#__PURE__*/(() => {
  class DxoVariablesComponent extends DxoHtmlEditorVariables {
    get _optionPath() {
      return 'variables';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoVariablesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoVariablesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoVariablesComponent,
      selectors: [["dxo-variables"]],
      inputs: {
        dataSource: "dataSource",
        escapeChar: "escapeChar"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoVariablesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoVariablesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoVariablesModule = /*#__PURE__*/(() => {
  class DxoVariablesModule {
    /** @nocollapse */static ɵfac = function DxoVariablesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoVariablesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoVariablesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoVariablesComponent]
    });
  }
  return DxoVariablesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoVerticalLineComponent = /*#__PURE__*/(() => {
  class DxoVerticalLineComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'verticalLine';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoVerticalLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoVerticalLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoVerticalLineComponent,
      selectors: [["dxo-vertical-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoVerticalLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoVerticalLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoVerticalLineModule = /*#__PURE__*/(() => {
  class DxoVerticalLineModule {
    /** @nocollapse */static ɵfac = function DxoVerticalLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoVerticalLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoVerticalLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoVerticalLineComponent]
    });
  }
  return DxoVerticalLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiViewComponent = /*#__PURE__*/(() => {
  class DxiViewComponent extends CollectionNestedOption {
    get agendaDuration() {
      return this._getOption('agendaDuration');
    }
    set agendaDuration(value) {
      this._setOption('agendaDuration', value);
    }
    get allDayPanelMode() {
      return this._getOption('allDayPanelMode');
    }
    set allDayPanelMode(value) {
      this._setOption('allDayPanelMode', value);
    }
    get appointmentCollectorTemplate() {
      return this._getOption('appointmentCollectorTemplate');
    }
    set appointmentCollectorTemplate(value) {
      this._setOption('appointmentCollectorTemplate', value);
    }
    get appointmentTemplate() {
      return this._getOption('appointmentTemplate');
    }
    set appointmentTemplate(value) {
      this._setOption('appointmentTemplate', value);
    }
    get appointmentTooltipTemplate() {
      return this._getOption('appointmentTooltipTemplate');
    }
    set appointmentTooltipTemplate(value) {
      this._setOption('appointmentTooltipTemplate', value);
    }
    get cellDuration() {
      return this._getOption('cellDuration');
    }
    set cellDuration(value) {
      this._setOption('cellDuration', value);
    }
    get dataCellTemplate() {
      return this._getOption('dataCellTemplate');
    }
    set dataCellTemplate(value) {
      this._setOption('dataCellTemplate', value);
    }
    get dateCellTemplate() {
      return this._getOption('dateCellTemplate');
    }
    set dateCellTemplate(value) {
      this._setOption('dateCellTemplate', value);
    }
    get dropDownAppointmentTemplate() {
      return this._getOption('dropDownAppointmentTemplate');
    }
    set dropDownAppointmentTemplate(value) {
      this._setOption('dropDownAppointmentTemplate', value);
    }
    get endDayHour() {
      return this._getOption('endDayHour');
    }
    set endDayHour(value) {
      this._setOption('endDayHour', value);
    }
    get firstDayOfWeek() {
      return this._getOption('firstDayOfWeek');
    }
    set firstDayOfWeek(value) {
      this._setOption('firstDayOfWeek', value);
    }
    get groupByDate() {
      return this._getOption('groupByDate');
    }
    set groupByDate(value) {
      this._setOption('groupByDate', value);
    }
    get groupOrientation() {
      return this._getOption('groupOrientation');
    }
    set groupOrientation(value) {
      this._setOption('groupOrientation', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get intervalCount() {
      return this._getOption('intervalCount');
    }
    set intervalCount(value) {
      this._setOption('intervalCount', value);
    }
    get maxAppointmentsPerCell() {
      return this._getOption('maxAppointmentsPerCell');
    }
    set maxAppointmentsPerCell(value) {
      this._setOption('maxAppointmentsPerCell', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get resourceCellTemplate() {
      return this._getOption('resourceCellTemplate');
    }
    set resourceCellTemplate(value) {
      this._setOption('resourceCellTemplate', value);
    }
    get scrolling() {
      return this._getOption('scrolling');
    }
    set scrolling(value) {
      this._setOption('scrolling', value);
    }
    get startDate() {
      return this._getOption('startDate');
    }
    set startDate(value) {
      this._setOption('startDate', value);
    }
    get startDayHour() {
      return this._getOption('startDayHour');
    }
    set startDayHour(value) {
      this._setOption('startDayHour', value);
    }
    get timeCellTemplate() {
      return this._getOption('timeCellTemplate');
    }
    set timeCellTemplate(value) {
      this._setOption('timeCellTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'views';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiViewComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiViewComponent,
      selectors: [["dxi-view"]],
      inputs: {
        agendaDuration: "agendaDuration",
        allDayPanelMode: "allDayPanelMode",
        appointmentCollectorTemplate: "appointmentCollectorTemplate",
        appointmentTemplate: "appointmentTemplate",
        appointmentTooltipTemplate: "appointmentTooltipTemplate",
        cellDuration: "cellDuration",
        dataCellTemplate: "dataCellTemplate",
        dateCellTemplate: "dateCellTemplate",
        dropDownAppointmentTemplate: "dropDownAppointmentTemplate",
        endDayHour: "endDayHour",
        firstDayOfWeek: "firstDayOfWeek",
        groupByDate: "groupByDate",
        groupOrientation: "groupOrientation",
        groups: "groups",
        intervalCount: "intervalCount",
        maxAppointmentsPerCell: "maxAppointmentsPerCell",
        name: "name",
        offset: "offset",
        resourceCellTemplate: "resourceCellTemplate",
        scrolling: "scrolling",
        startDate: "startDate",
        startDayHour: "startDayHour",
        timeCellTemplate: "timeCellTemplate",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_views,
        useExisting: DxiViewComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiViewComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiViewModule = /*#__PURE__*/(() => {
  class DxiViewModule {
    /** @nocollapse */static ɵfac = function DxiViewModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiViewModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiViewModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiViewComponent]
    });
  }
  return DxiViewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoViewToolbarComponent = /*#__PURE__*/(() => {
  class DxoViewToolbarComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'viewToolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoViewToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoViewToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoViewToolbarComponent,
      selectors: [["dxo-view-toolbar"]],
      contentQueries: function DxoViewToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoViewToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoViewToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoViewToolbarModule = /*#__PURE__*/(() => {
  class DxoViewToolbarModule {
    /** @nocollapse */static ɵfac = function DxoViewToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoViewToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoViewToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoViewToolbarComponent]
    });
  }
  return DxoViewToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoWidthComponent = /*#__PURE__*/(() => {
  class DxoWidthComponent extends NestedOption {
    get rangeMaxPoint() {
      return this._getOption('rangeMaxPoint');
    }
    set rangeMaxPoint(value) {
      this._setOption('rangeMaxPoint', value);
    }
    get rangeMinPoint() {
      return this._getOption('rangeMinPoint');
    }
    set rangeMinPoint(value) {
      this._setOption('rangeMinPoint', value);
    }
    get end() {
      return this._getOption('end');
    }
    set end(value) {
      this._setOption('end', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get _optionPath() {
      return 'width';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoWidthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoWidthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoWidthComponent,
      selectors: [["dxo-width"]],
      inputs: {
        rangeMaxPoint: "rangeMaxPoint",
        rangeMinPoint: "rangeMinPoint",
        end: "end",
        start: "start"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoWidthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoWidthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoWidthModule = /*#__PURE__*/(() => {
  class DxoWidthModule {
    /** @nocollapse */static ɵfac = function DxoWidthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoWidthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoWidthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoWidthComponent]
    });
  }
  return DxoWidthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoZoomAndPanComponent = /*#__PURE__*/(() => {
  class DxoZoomAndPanComponent extends NestedOption {
    get allowMouseWheel() {
      return this._getOption('allowMouseWheel');
    }
    set allowMouseWheel(value) {
      this._setOption('allowMouseWheel', value);
    }
    get allowTouchGestures() {
      return this._getOption('allowTouchGestures');
    }
    set allowTouchGestures(value) {
      this._setOption('allowTouchGestures', value);
    }
    get argumentAxis() {
      return this._getOption('argumentAxis');
    }
    set argumentAxis(value) {
      this._setOption('argumentAxis', value);
    }
    get dragBoxStyle() {
      return this._getOption('dragBoxStyle');
    }
    set dragBoxStyle(value) {
      this._setOption('dragBoxStyle', value);
    }
    get dragToZoom() {
      return this._getOption('dragToZoom');
    }
    set dragToZoom(value) {
      this._setOption('dragToZoom', value);
    }
    get panKey() {
      return this._getOption('panKey');
    }
    set panKey(value) {
      this._setOption('panKey', value);
    }
    get valueAxis() {
      return this._getOption('valueAxis');
    }
    set valueAxis(value) {
      this._setOption('valueAxis', value);
    }
    get _optionPath() {
      return 'zoomAndPan';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoZoomAndPanComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoZoomAndPanComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoZoomAndPanComponent,
      selectors: [["dxo-zoom-and-pan"]],
      inputs: {
        allowMouseWheel: "allowMouseWheel",
        allowTouchGestures: "allowTouchGestures",
        argumentAxis: "argumentAxis",
        dragBoxStyle: "dragBoxStyle",
        dragToZoom: "dragToZoom",
        panKey: "panKey",
        valueAxis: "valueAxis"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoZoomAndPanComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoZoomAndPanComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoZoomAndPanModule = /*#__PURE__*/(() => {
  class DxoZoomAndPanModule {
    /** @nocollapse */static ɵfac = function DxoZoomAndPanModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoZoomAndPanModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoZoomAndPanModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoZoomAndPanComponent]
    });
  }
  return DxoZoomAndPanModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoZoomLevelComponent = /*#__PURE__*/(() => {
  class DxoZoomLevelComponent extends NestedOption {
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'zoomLevel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoZoomLevelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoZoomLevelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoZoomLevelComponent,
      selectors: [["dxo-zoom-level"]],
      inputs: {
        items: "items",
        value: "value"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoZoomLevelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoZoomLevelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoZoomLevelModule = /*#__PURE__*/(() => {
  class DxoZoomLevelModule {
    /** @nocollapse */static ɵfac = function DxoZoomLevelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoZoomLevelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoZoomLevelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoZoomLevelComponent]
    });
  }
  return DxoZoomLevelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiAlertComponent, DxiAlertModule, DxiAnnotationComponent, DxiAnnotationModule, DxiBreakComponent, DxiBreakModule, DxiButtonComponent, DxiButtonModule, DxiCenterComponent, DxiCenterModule, DxiChangeComponent, DxiChangeModule, DxiColComponent, DxiColModule, DxiColumnComponent, DxiColumnModule, DxiCommandComponent, DxiCommandModule, DxiConnectionPointComponent, DxiConnectionPointModule, DxiConstantLineComponent, DxiConstantLineModule, DxiCustomOperationComponent, DxiCustomOperationModule, DxiCustomShapeComponent, DxiCustomShapeModule, DxiFieldComponent, DxiFieldModule, DxiFileSelectionItemComponent, DxiFileSelectionItemModule, DxiGroupComponent, DxiGroupItemComponent, DxiGroupItemModule, DxiGroupModule, DxiItemComponent, DxiItemModule, DxiLayerComponent, DxiLayerModule, DxiLegendComponent, DxiLegendModule, DxiLocationComponent, DxiLocationModule, DxiMarkerComponent, DxiMarkerModule, DxiMentionComponent, DxiMentionModule, DxiMenuItemComponent, DxiMenuItemModule, DxiPaneComponent, DxiPaneModule, DxiRangeComponent, DxiRangeModule, DxiResourceComponent, DxiResourceModule, DxiRouteComponent, DxiRouteModule, DxiRowComponent, DxiRowModule, DxiSeriesComponent, DxiSeriesModule, DxiSortByGroupSummaryInfoComponent, DxiSortByGroupSummaryInfoModule, DxiStripComponent, DxiStripLineComponent, DxiStripLineModule, DxiStripModule, DxiTabComponent, DxiTabModule, DxiToolbarItemComponent, DxiToolbarItemModule, DxiTotalItemComponent, DxiTotalItemModule, DxiTypingUserComponent, DxiTypingUserModule, DxiValidationRuleComponent, DxiValidationRuleModule, DxiValueAxisComponent, DxiValueAxisModule, DxiViewComponent, DxiViewModule, DxoAdapterComponent, DxoAdapterModule, DxoAdaptiveLayoutComponent, DxoAdaptiveLayoutModule, DxoAggregationComponent, DxoAggregationIntervalComponent, DxoAggregationIntervalModule, DxoAggregationModule, DxoAnimationComponent, DxoAnimationModule, DxoApiKeyComponent, DxoApiKeyModule, DxoAppointmentDraggingComponent, DxoAppointmentDraggingModule, DxoAreaComponent, DxoAreaModule, DxoArgumentAxisComponent, DxoArgumentAxisModule, DxoArgumentFormatComponent, DxoArgumentFormatModule, DxoAtComponent, DxoAtModule, DxoAuthorComponent, DxoAuthorModule, DxoAutoLayoutComponent, DxoAutoLayoutModule, DxoBackgroundColorComponent, DxoBackgroundColorModule, DxoBackgroundComponent, DxoBackgroundModule, DxoBarComponent, DxoBarModule, DxoBehaviorComponent, DxoBehaviorModule, DxoBorderComponent, DxoBorderModule, DxoBoundaryOffsetComponent, DxoBoundaryOffsetModule, DxoBoxComponent, DxoBoxModule, DxoBreakStyleComponent, DxoBreakStyleModule, DxoBubbleComponent, DxoBubbleModule, DxoButtonOptionsComponent, DxoButtonOptionsModule, DxoCalendarOptionsComponent, DxoCalendarOptionsModule, DxoCandlestickComponent, DxoCandlestickModule, DxoChartComponent, DxoChartModule, DxoColCountByScreenComponent, DxoColCountByScreenModule, DxoCollisionComponent, DxoCollisionModule, DxoColorComponent, DxoColorModule, DxoColorizerComponent, DxoColorizerModule, DxoColumnChooserComponent, DxoColumnChooserModule, DxoColumnFixingComponent, DxoColumnFixingModule, DxoCommonAnnotationSettingsComponent, DxoCommonAnnotationSettingsModule, DxoCommonAxisSettingsComponent, DxoCommonAxisSettingsModule, DxoCommonPaneSettingsComponent, DxoCommonPaneSettingsModule, DxoCommonSeriesSettingsComponent, DxoCommonSeriesSettingsModule, DxoConnectorComponent, DxoConnectorModule, DxoConstantLineStyleComponent, DxoConstantLineStyleModule, DxoContextMenuComponent, DxoContextMenuModule, DxoContextToolboxComponent, DxoContextToolboxModule, DxoControlBarComponent, DxoControlBarModule, DxoConverterComponent, DxoConverterModule, DxoCrosshairComponent, DxoCrosshairModule, DxoCursorOffsetComponent, DxoCursorOffsetModule, DxoDataPrepareSettingsComponent, DxoDataPrepareSettingsModule, DxoDayHeaderFormatComponent, DxoDayHeaderFormatModule, DxoDefaultItemPropertiesComponent, DxoDefaultItemPropertiesModule, DxoDelayComponent, DxoDelayModule, DxoDependenciesComponent, DxoDependenciesModule, DxoDetailsComponent, DxoDetailsModule, DxoDisplayFormatComponent, DxoDisplayFormatModule, DxoDragBoxStyleComponent, DxoDragBoxStyleModule, DxoDropDownOptionsComponent, DxoDropDownOptionsModule, DxoEdgesComponent, DxoEdgesModule, DxoEditingComponent, DxoEditingModule, DxoExportComponent, DxoExportModule, DxoFieldChooserComponent, DxoFieldChooserModule, DxoFieldPanelComponent, DxoFieldPanelModule, DxoFileUploaderOptionsComponent, DxoFileUploaderOptionsModule, DxoFilterBuilderComponent, DxoFilterBuilderModule, DxoFilterBuilderPopupComponent, DxoFilterBuilderPopupModule, DxoFilterOperationDescriptionsComponent, DxoFilterOperationDescriptionsModule, DxoFilterPanelComponent, DxoFilterPanelModule, DxoFilterRowComponent, DxoFilterRowModule, DxoFontComponent, DxoFontModule, DxoFormComponent, DxoFormItemComponent, DxoFormItemModule, DxoFormModule, DxoFormatComponent, DxoFormatModule, DxoFromComponent, DxoFromModule, DxoFullstackedareaComponent, DxoFullstackedareaModule, DxoFullstackedbarComponent, DxoFullstackedbarModule, DxoFullstackedlineComponent, DxoFullstackedlineModule, DxoFullstackedsplineComponent, DxoFullstackedsplineModule, DxoFullstackedsplineareaComponent, DxoFullstackedsplineareaModule, DxoGeometryComponent, DxoGeometryModule, DxoGridComponent, DxoGridModule, DxoGridSizeComponent, DxoGridSizeModule, DxoGroupComponent, DxoGroupModule, DxoGroupOperationDescriptionsComponent, DxoGroupOperationDescriptionsModule, DxoGroupPanelComponent, DxoGroupPanelModule, DxoGroupingComponent, DxoGroupingModule, DxoHatchingComponent, DxoHatchingModule, DxoHeaderFilterComponent, DxoHeaderFilterModule, DxoHeightComponent, DxoHeightModule, DxoHideComponent, DxoHideEventComponent, DxoHideEventModule, DxoHideModule, DxoHistoryToolbarComponent, DxoHistoryToolbarModule, DxoHorizontalLineComponent, DxoHorizontalLineModule, DxoHoverStyleComponent, DxoHoverStyleModule, DxoIconsComponent, DxoIconsModule, DxoImageComponent, DxoImageModule, DxoImageUploadComponent, DxoImageUploadModule, DxoIndentComponent, DxoIndentModule, DxoItemComponent, DxoItemDraggingComponent, DxoItemDraggingModule, DxoItemModule, DxoItemTextFormatComponent, DxoItemTextFormatModule, DxoItemViewComponent, DxoItemViewModule, DxoKeyboardNavigationComponent, DxoKeyboardNavigationModule, DxoLabelComponent, DxoLabelModule, DxoLegendComponent, DxoLegendModule, DxoLineComponent, DxoLineModule, DxoLinkComponent, DxoLinkModule, DxoLoadPanelComponent, DxoLoadPanelModule, DxoLoadingIndicatorComponent, DxoLoadingIndicatorModule, DxoLookupComponent, DxoLookupModule, DxoMainToolbarComponent, DxoMainToolbarModule, DxoMarginComponent, DxoMarginModule, DxoMarkerComponent, DxoMarkerModule, DxoMasterDetailComponent, DxoMasterDetailModule, DxoMaxRangeComponent, DxoMaxRangeModule, DxoMediaResizingComponent, DxoMediaResizingModule, DxoMessageTimestampFormatComponent, DxoMessageTimestampFormatModule, DxoMinRangeComponent, DxoMinRangeModule, DxoMinVisualRangeLengthComponent, DxoMinVisualRangeLengthModule, DxoMinorGridComponent, DxoMinorGridModule, DxoMinorTickComponent, DxoMinorTickIntervalComponent, DxoMinorTickIntervalModule, DxoMinorTickModule, DxoMyComponent, DxoMyModule, DxoNodeComponent, DxoNodeModule, DxoNodesComponent, DxoNodesModule, DxoNotificationsComponent, DxoNotificationsModule, DxoOffsetComponent, DxoOffsetModule, DxoOperationDescriptionsComponent, DxoOperationDescriptionsModule, DxoOptionsComponent, DxoOptionsModule, DxoPageSizeComponent, DxoPageSizeModule, DxoPagerComponent, DxoPagerModule, DxoPagingComponent, DxoPagingModule, DxoPermissionsComponent, DxoPermissionsModule, DxoPointComponent, DxoPointModule, DxoPopupComponent, DxoPopupModule, DxoPositionComponent, DxoPositionModule, DxoProjectionComponent, DxoProjectionModule, DxoPropertiesPanelComponent, DxoPropertiesPanelModule, DxoProviderConfigComponent, DxoProviderConfigModule, DxoRangeContainerComponent, DxoRangeContainerModule, DxoRangeareaComponent, DxoRangeareaModule, DxoRangebarComponent, DxoRangebarModule, DxoReductionComponent, DxoReductionModule, DxoRemoteOperationsComponent, DxoRemoteOperationsModule, DxoResourceAssignmentsComponent, DxoResourceAssignmentsModule, DxoResourcesComponent, DxoResourcesModule, DxoRowDraggingComponent, DxoRowDraggingModule, DxoScaleComponent, DxoScaleModule, DxoScaleTypeRangeComponent, DxoScaleTypeRangeModule, DxoScatterComponent, DxoScatterModule, DxoScrollBarComponent, DxoScrollBarModule, DxoScrollingComponent, DxoScrollingModule, DxoSearchComponent, DxoSearchEditorOptionsComponent, DxoSearchEditorOptionsModule, DxoSearchModule, DxoSearchPanelComponent, DxoSearchPanelModule, DxoSelectionComponent, DxoSelectionModule, DxoSelectionStyleComponent, DxoSelectionStyleModule, DxoSeriesTemplateComponent, DxoSeriesTemplateModule, DxoShadowComponent, DxoShadowModule, DxoShowComponent, DxoShowEventComponent, DxoShowEventModule, DxoShowFirstSubmenuModeComponent, DxoShowFirstSubmenuModeModule, DxoShowModule, DxoShowSubmenuModeComponent, DxoShowSubmenuModeModule, DxoShutterComponent, DxoShutterModule, DxoSizeComponent, DxoSizeModule, DxoSliderHandleComponent, DxoSliderHandleModule, DxoSliderMarkerComponent, DxoSliderMarkerModule, DxoSmallValuesGroupingComponent, DxoSmallValuesGroupingModule, DxoSortingComponent, DxoSortingModule, DxoSourceComponent, DxoSourceModule, DxoSplineComponent, DxoSplineModule, DxoSplineareaComponent, DxoSplineareaModule, DxoSplitterComponent, DxoSplitterModule, DxoStackedareaComponent, DxoStackedareaModule, DxoStackedbarComponent, DxoStackedbarModule, DxoStackedlineComponent, DxoStackedlineModule, DxoStackedsplineComponent, DxoStackedsplineModule, DxoStackedsplineareaComponent, DxoStackedsplineareaModule, DxoStateStoringComponent, DxoStateStoringModule, DxoStepareaComponent, DxoStepareaModule, DxoSteplineComponent, DxoSteplineModule, DxoStockComponent, DxoStockModule, DxoStripStyleComponent, DxoStripStyleModule, DxoSubtitleComponent, DxoSubtitleModule, DxoSubvalueIndicatorComponent, DxoSubvalueIndicatorModule, DxoSummaryComponent, DxoSummaryModule, DxoTabPanelOptionsComponent, DxoTabPanelOptionsModule, DxoTableContextMenuComponent, DxoTableContextMenuModule, DxoTableResizingComponent, DxoTableResizingModule, DxoTasksComponent, DxoTasksModule, DxoTextComponent, DxoTextModule, DxoTextsComponent, DxoTextsModule, DxoTickComponent, DxoTickIntervalComponent, DxoTickIntervalModule, DxoTickModule, DxoTileComponent, DxoTileModule, DxoTitleComponent, DxoTitleModule, DxoToComponent, DxoToModule, DxoToolbarComponent, DxoToolbarModule, DxoToolboxComponent, DxoToolboxModule, DxoTooltipComponent, DxoTooltipModule, DxoUploadComponent, DxoUploadModule, DxoUrlComponent, DxoUrlModule, DxoUserComponent, DxoUserModule, DxoValidationComponent, DxoValidationModule, DxoValueAxisComponent, DxoValueAxisModule, DxoValueErrorBarComponent, DxoValueErrorBarModule, DxoValueFormatComponent, DxoValueFormatModule, DxoValueIndicatorComponent, DxoValueIndicatorModule, DxoVariablesComponent, DxoVariablesModule, DxoVerticalLineComponent, DxoVerticalLineModule, DxoViewToolbarComponent, DxoViewToolbarModule, DxoWidthComponent, DxoWidthModule, DxoZoomAndPanComponent, DxoZoomAndPanModule, DxoZoomLevelComponent, DxoZoomLevelModule };
